module.exports = {
  calendarEventNotFound: 'Kalenderereignis nicht gefunden',
  calendarEventNotFoundMessage:
    'Das Kalenderereignis mit der ID {{eventId}} wurde nicht gefunden. Es wurde möglicherweise gelöscht oder der Kalender ist nicht mehr zugänglich.',
  alarmWithSnoozeAt: 'Der Alarm klingelt das nächste Mal am {{timeString}}',
  removeImage: 'Bild entfernen',
  timezoneMismatchDetected:
    'Irgendetwas sagt uns, dass Sie sich in einer anderen Zeitzone befinden als das letzte Mal, als Sie Galarm benutzt haben.\n\nAlte Zeitzone: {{oldTimezone}}\nNeue Zeitzone: {{newTimezone}}\n\nDies kann auf eine Änderung Ihres Standorts oder eine Änderung der Zeitzone auf Ihrem Gerät zurückzuführen sein.\n\nBitte starten Sie Galarm neu, damit wir uns an die neue Zeitzone anpassen können.',
  nTimes: {
    one: '1 mal',
    other: '{{count}} mal'
  },
  loggedIntoOrganizationAccount: 'Org: {{organizationName}}\nRolle: {{role}}',
  adsMessage:
    '\nVielen Dank, dass Sie Galarm Ihr Vertrauen schenken. Um die Entwicklung von Galarm zu unterstützen, können Sie gelegentlich Werbung sehen.\n\nAktualisieren Sie unser budgetfreundliches Premium-Abo für ein werbefreies Erlebnis und Zugang zu weiteren großartigen Funktionen.',
  headsUp: 'Aufgepasst!',
  dataRetention: 'Aufbewahrung von Daten',
  retainIncidentsForDuration: 'Dauer der Verweildauer in einem Vorfall',
  retainIncidentsForDurationDescription:
    'Gibt die Dauer an, für die ein Vorfall im System verbleibt, nachdem er geschlossen wurde. Auch bei der Einstellung "Keine Aufbewahrung" können Vorfälle bis zu vier Stunden bestehen bleiben, bevor sie im Rahmen des regelmäßigen Bereinigungszyklus entfernt werden.',
  noRetention: 'Kein Selbstbehalt',
  fetchingData: 'Daten abrufen...',
  errorFetchingData: 'Fehler beim Abrufen von Daten: {{message}}',
  incidentsCleanupLevel: 'Vorfälle Bereinigungsstufe',
  incidentsCleanupLevelDescription:
    'Gibt den Vorgangsstatus an, bis zu dem Vorgänge während des periodischen Bereinigungszyklus bereinigt werden. Wenn der Status auf "Geschlossen" eingestellt ist, werden alle Vorfälle, die geschlossen sind, bereinigt. Wenn der Status auf "Bestätigt" eingestellt ist, werden alle Vorfälle, die bestätigt oder geschlossen sind, bereinigt.',
  connectedAccounts: 'Verknüpfte Google-Konten',
  incidentNameTemplate: 'Vorlage für Vorfallsnamen',
  invalidIncidentNameTemplate:
    'Ungültige Vorfallnamen-Vorlage. Bitte beachten Sie, dass Sie nur "identifier", "name" und "summary" als Variablennamen verwenden können. Bitte überprüfen Sie die Vorlage und versuchen Sie es erneut. Bitte kontaktieren Sie den Support, wenn Sie weiterhin Probleme haben.',
  preferredSourceForIncidentsDescription:
    'Wenn Sie den Listener als Webhook verwenden oder Vorfälle von einem Überwachungstool empfangen möchten, wählen Sie bitte die Quelle aus der Liste unten aus. Wenn Sie eine Quelle auswählen, zeigen wir Ihnen, wie Sie den Listener in die Quelle integrieren können.\n\nDies ist optional und Sie können die Anweisungen für jede beliebige Quelle auch später über die Menüoption "Ansicht Code" für den Listener anzeigen.',
  noCalendarsFoundForConnectedAccount:
    'Keine Kalender für das verknüpfte Konto gefunden. Bitte entfernen Sie das Konto und fügen Sie es erneut hinzu, und stellen Sie sicher, dass Galarm Zugriff auf Ihre Kalender hat. Wenn das Problem weiterhin besteht, wenden Sie sich bitte über "Einstellungen > Feedback" an den technischen Support.',
  attachScreenshotsToFeedback:
    'Sie erhalten eine E-Mail zur Bestätigung, dass wir Ihre Rückmeldung erhalten haben. Wenn Sie uns Screenshots zur Verfügung stellen möchten, damit wir das Problem besser verstehen können, antworten Sie bitte auf die E-Mail mit den Screenshots.',
  checkFeedbackReceipt:
    'Bitte prüfen Sie Ihren Posteingang auf eine E-Mail zur Bestätigung Ihrer Anmeldung. Wenn Sie diese nicht in Ihrem Posteingang finden, überprüfen Sie bitte Ihren Spam-Ordner und fügen Sie support@galarm.zendesk.com zu Ihrem E-Mail-Adressbuch hinzu.\n\nWenn Sie uns Screenshots zur Verfügung stellen möchten, damit wir das Problem besser verstehen können, antworten Sie bitte auf die E-Mail mit den Screenshots.',
  watchRewardedAdToUnlockMessage: `Sie werden nun eine Vollbildanzeige sehen. Sie können sie nach ein paar Sekunden schließen. Sie sehen nur eine solche Anzeige pro Tag. Dies hilft uns, die App kostenlos zu halten.

Um Anzeigen zu entfernen und zusätzliche Funktionen freizuschalten, sollten Sie ein Upgrade auf unseren Premium-Plan in Betracht ziehen.`,
  watchRewardedAdToUnlockMessageAndroid: `Sie sehen jetzt eine Vollbildanzeige, die bis zu 30 Sekunden dauert. Sobald sie endet, erscheint eine Nachricht „Belohnung gewährt“ und eine X-Schaltfläche oben. Tippen Sie auf das X, um die Anzeige zu schließen und fortzufahren.

Bitte drücken Sie nicht die Zurück-Taste, bevor die Nachricht „Belohnung gewährt“ erscheint. Sie sehen nur eine solche Anzeige pro Tag.

Um Anzeigen zu entfernen und zusätzliche Funktionen freizuschalten, sollten Sie ein Upgrade auf unseren Premium-Plan in Betracht ziehen.`,
  watchRewardedAdToUnlockMessageIos: `Sie sehen jetzt eine Vollbildanzeige, die bis zu 30 Sekunden dauert. Sobald sie endet, erscheint eine Nachricht „Belohnung gewährt“ und eine X-Schaltfläche oben. Tippen Sie auf das X, um die Anzeige zu schließen und fortzufahren.

Sie sehen nur eine solche Anzeige pro Tag. Um Anzeigen zu entfernen und zusätzliche Funktionen freizuschalten, sollten Sie ein Upgrade auf unseren Premium-Plan in Betracht ziehen.`,
  dontShowMessageAgain: 'Diese Meldung nicht mehr anzeigen',
  chooseDuration: 'Wählen Sie eine Dauer. Tippen Sie mehrmals, um zu addieren.',
  chargedAtPurchase:
    'Der Preis wird zur Zeit des Kaufs berechnet. Der Preis beinhaltet einen Einführungsrabatt von 20 %.',
  lookingForLifetimePlan: 'Klicken Sie hier für einen Plan auf Lebenszeit >',
  viewPremiumFeaturesDescription:
    'Vielen Dank, dass Sie ein Premium-Nutzer sind. Ihr premium Plan bietet diese Funktionen.',
  accessToPremiumFeatures:
    'Premium-Tarife bieten Ihnen die folgenden Funktionen:',
  purchasedLifetimePlan: 'Sie haben den Tarif Lifetime Premium erworben.',
  lifetimePremium: 'Lebenslange Prämie',
  buyNow: 'Jetzt kaufen',
  checkout: 'Zur Kasse',
  cancelProduct: 'Produkt abbrechen',
  endTimeForCreatorCrossesMidnightForRecipientAlarm:
    'Die Endzeit für den Alarm des Erstellers überschreitet Mitternacht. Bitte stellen Sie eine gültige Endzeit ein.',
  specificDates: 'Besondere Daten',
  specificDatesRepetition: {
    one: 'Besondere Daten (1 Vorkommen)',
    other: 'Besondere Daten ({{count}} occurrences)'
  },
  specificDatesRepetitionSummary:
    'Spezifische Daten ({{remaining}}/{{total}} remaining)',
  nOccurrences: {
    one: '1 Vorkommnis',
    other: '{{count}} Vorkommnisse'
  },
  addOrRemoveAlarmOccurrences:
    'Sie können Ereignisse in beliebiger Reihenfolge hinzufügen. Sie können auf ein beliebiges Datum oder eine beliebige Zeit tippen, um sie zu ändern.',
  chooseTime: 'Wählen Sie eine Zeit...',
  specificDatesRepetitionPremiumScreenDescription:
    'Mit dieser Wiederholung können Sie einen Alarm so einstellen, dass er an bestimmten Daten klingelt.',
  chooseAtLeastOneOccurrence: 'Bitte wählen Sie mindestens ein Vorkommen aus.',
  editRotation: 'Rotation bearbeiten',
  alertIncidentClosed: 'Geschlossen von {{memberName}} unter {{dateString}}',
  alertIncidentRecovered: 'Automatisch wiederhergestellt bei {{dateString}}',
  alertedAssignees: 'Gewarnt {{assigneesString}}',
  acknowledgedBy: 'Anerkannt durch {{memberName}}',
  closedBy: 'Geschlossen durch {{memberName}}',
  docs: 'Dokumentation',
  docsSmall: 'Dokumente',
  openingBillingPortal: 'Abrechnungsportal öffnen',
  releaseNotes: 'Neueste Updates',
  calendarNotifications: 'Kalenderbenachrichtigungen',
  calendarGrantExpired:
    'Der Kalenderzugriff für {{connectedAccountName}} und {{userName}} ist abgelaufen. Bitte gehen Sie zu „Einstellungen“ -> „Verknüpfte Kalender“, entfernen Sie das Konto und versuchen Sie es erneut.',
  loadingReleaseNotes:
    'Aktuelle Updates werden geladen. Bitte stellen Sie sicher, dass Sie mit dem Internet verbunden sind.',
  unableToChangePlan:
    'Es ist nicht möglich, zum aktuellen Plan zu wechseln. Bitte kontaktieren Sie den technischen Support über "Einstellungen > Rückmeldung".',
  customSnooze: 'Andere',
  customSnoozeDuration: 'Sonstiges ({{durationString}})',
  snoozeDuration: 'Dauer des Schlummerns',
  action: 'Aktion',
  unableToAuthenticateUser:
    'Benutzer kann nicht authentifiziert werden. {{error}}',
  addOccurrence: 'Vorkommen hinzufügen',
  closeIncidents: 'Vorfälle schließen',
  closingIncidents: 'Schließen von Vorfällen',
  olderThanHours: 'Älter als (Stunden)',
  errorLoadingRecaptcha:
    'Es ist ein Fehler beim Laden der reCAPTCHA-Herausforderung aufgetreten. Bitte versuchen Sie es nach einiger Zeit erneut und kontaktieren Sie den technischen Support, falls das Problem weiterhin besteht.',
  completeRecaptcha:
    'Um die Registrierung fortzusetzen, müssen Sie die folgende Aufgabe lösen.',
  incidentNotesPlaceholder: 'Notizen zu diesem Vorfall hinzufügen (optional)',
  incidentSummaryPlaceholder:
    'Fügen Sie eine kurze Zusammenfassung für diesen Vorfall hinzu (optional)',
  rotationMustHaveMembers: 'Die Rotation muss mindestens ein Mitglied haben.',
  listenerMustHaveTriggers: 'Listener muss mindestens einen Auslöser haben.',
  rotationExpiresOn: 'Läuft ab am {{dateString}}',
  rotationExpiredOn: 'Abgelaufen am {{dateString}}',
  editAndSaveRotationToSetExpirationDate:
    'Bearbeiten und speichern Sie die Drehung, um das Verfallsdatum einzustellen.',
  cantEnableAlarmNoValidNextDate:
    'Der Alarm kann nicht aktiviert werden. Kein gültiges nächstes Datum für den Alarm.',
  noValidNextDateForAlarm: 'Kein gültiges nächstes Datum für den Alarm.',
  chords: 'Akkorde',
  discovery: 'Entdeckung',
  rainforest: 'Regenwald',
  wishes: 'Wünsche',
  natural_marimba: 'Natürliche Marimba',
  alarms: 'Alarme',
  contacts: 'Kontakte',
  groups: 'Gruppen',
  settings: 'Einstellungen',
  notificationsTab: 'Benachrichtigungen',
  specifyTimeInFutureForAlarm:
    'Der Alarm darf nicht in der Vergangenheit liegen.',
  specifyTimeInFutureForPreReminder:
    'Die Vorab-Erinnerung für den Alarm liegt in der Vergangenheit.',
  specifyNameForGroup: 'Der Name der Gruppe ist erforderlich.',
  updatingGroupName: 'Aktualisieren von Gruppeninformationen.',
  unableToEditGroupName:
    'Die Gruppeninformationen können nicht aktualisiert werden. Bitte versuchen Sie es nach einiger Zeit erneut.',
  selectSmallerImage:
    'Das Bild ist größer als 10 MB. Wählen Sie ein kleineres Bild.',
  sendingVerificationCode:
    'Übermittlung des Verifizierungscodes an {{formattedMobileNumber}}.',
  verifyingCode: 'Überprüfen des Codes.',
  creatingUserProfile: 'Einstellen...',
  unabeToCreateUserProfile:
    'Sie können zu dieser Zeit kein Konto einrichten. Bitte versuchen Sie es in einigen Augenblicken erneut.',
  unableToSendVerificationCode:
    'Überprüfungscode kann nicht gesendet werden. {{error}}',
  unableToVerifyCode: 'Code kann nicht verifiziert werden. {{error}}',
  unableToRegisterUserWithoutMobileNumber:
    'Die Einrichtung kann nicht durchgeführt werden. {{error}}',
  permissionDeniedToAccessCameraIos:
    'Galarm hat keine Berechtigung, auf die Kamera zuzugreifen. \n\nGehen Sie zu Einstellungen > Galarm und erlauben Sie den Zugriff auf die Kamera.',
  permissionDeniedToAccessCameraAndroid:
    'Galarm hat keine Berechtigung, auf die Kamera zuzugreifen.\n\nGehen Sie zu Einstellungen > Apps > Galarm > Berechtigungen und erlauben Sie den Zugriff auf die Kamera.',
  permissionDeniedToAccessPhotosIos:
    'Galarm hat keine Berechtigung, auf Fotos zuzugreifen.\n\nGehen Sie zu Einstellungen > Galarm und erlauben Sie den Zugriff auf Fotos.',
  permissionDeniedToAccessPhotosAndroid:
    'Galarm hat keine Berechtigung, auf Fotos zuzugreifen.\n\nGehen Sie zu Einstellungen > Apps > Galarm > Berechtigungen und erlauben Sie den Zugriff auf den Speicher.',
  permissionDeniedToAccessCalendarIos:
    'Galarm hat keine Berechtigung für den Zugriff auf den Kalender.\nGehen Sie zu Einstellungen > Kalender und erlauben Sie den Zugriff auf Galarm.',
  permissionDeniedToAccessCalendarAndroid:
    'Galarm hat keine Berechtigung für den Zugriff auf den Kalender.\nGehen Sie zu Einstellungen > Apps > Galarm > Berechtigungen und erlauben Sie den Zugriff auf den Kalender.',
  verificationCodeSent:
    'Der Verifizierungscode wird an {{formattedMobileNumber}} gesendet.',
  rateTheApp:
    'Wir hoffen, Sie finden Galarm nützlich. Bitte nehmen Sie sich einen Moment Zeit, um uns im Play Store zu bewerten. Vielen Dank für Ihre Unterstützung.',
  backgroundAppRefreshDisabledPermission:
    'Alarme klingeln möglicherweise nicht, weil Galarm keine Berechtigung hat, die App im Hintergrund zu aktualisieren.\n\nTippen Sie auf "Aktivieren", und aktivieren Sie "App-Hintergrundaktualisierung".',
  selectedGroupUnselected:
    'Sie können entweder eine Gruppe oder eine Gruppe von Kontakten als Teilnehmer auswählen. Ihre zuvor ausgewählte Gruppe wird abgewählt. Fortfahren?',
  selectedContactsUnselected:
    'Sie können entweder eine Gruppe oder eine Reihe von Kontakten als Teilnehmer auswählen. Ihre zuvor ausgewählten Kontakte werden abgewählt. Fortfahren?',
  notificationsDisabledIos:
    'Alarme werden nicht klingeln, weil Galarm keine Berechtigung hat, Benachrichtigungen anzuzeigen.\n\nGehen Sie zu Einstellungen > Galarm > Benachrichtigungen und aktivieren Sie "Alarme", "Klänge" und "Banner".',
  notificationsDisabledAndroid:
    'Alarm-Benachrichtigungen werden nicht auf dem Bildschirm angezeigt.\n\nTippen Sie auf "Aktivieren", wählen Sie "Benachrichtigungen" und lassen Sie Benachrichtigungen zu.',
  alarmNotificationChannelDisabled:
    'Alarm-Benachrichtigungen werden nicht mehr auf dem Bildschirm angezeigt. \n\nTippen Sie auf "Aktivieren", damit die Alarm-Benachrichtigungen auf dem Bildschirm angezeigt werden können.',
  alarmLockScreenNotificationlDisabled:
    'Alarm-Benachrichtigungen werden nicht mehr auf dem Sperrbildschirm angezeigt. \n\nTippen Sie auf "Aktivieren", damit die Alarm-Benachrichtigungen auf dem Sperrbildschirm angezeigt werden.',
  alarmWillNotRingDueToNotificationsDisabledIos:
    'Alarme klingeln nicht, da die Benachrichtigungen deaktiviert sind.\n\nGehen Sie zu Einstellungen > Galarm > Benachrichtigungen und aktivieren Sie "Alarme", "Klänge" und "Banner".',
  alarmWillNotRingDueToCriticalAlertsDisabledIos:
    'Alarme klingeln nicht, wenn das Telefon stumm geschaltet ist, da kritische Alarme deaktiviert sind.\n\nGehen Sie zu Einstellungen > Galarm > Benachrichtigungen und aktivieren Sie "Kritische Alarme".',
  alarmWillNotRingDueToNotificationsDisabledAndroid:
    'Der Alarm wird nicht auf dem Bildschirm angezeigt, da die Benachrichtigungen deaktiviert sind.\n\nTippen Sie auf "Aktivieren", wählen Sie "Benachrichtigungen" und lassen Sie Benachrichtigungen zu.',
  noNotificationsScheduledAlarmInPast:
    'Der Alarm liegt in der Vergangenheit. Es sind keine Benachrichtigungen geplant.',
  alarmOverAllowedLimit: {
    zero: '\nSie haben Ihre Alarmgrenze von {{limit}} erreicht.\n\nBitte löschen Sie einen bestehenden Alarm oder verwenden Sie ihn erneut.',
    one: 'Sie haben Ihre Alarmgrenze von {{limit}} erreicht.\n\nSie haben 1 inaktiven Alarm, den Sie löschen oder wiederverwenden können.',
    other:
      'Sie haben Ihre Alarmgrenze von {{limit}} erreicht.\n\nSie haben {{count}} inaktive Alarme, die Sie löschen oder wiederverwenden können.'
  },
  alarmAlreadyConfirmed: 'Sie haben es bereits bestätigt.',
  alarmAlreadyDeclined: 'Sie haben bereits abgelehnt.',
  participantMovedToPosition: '{{name}} auf die Position {{count}} verschoben.',
  memberIsFirstParticpant: '{{name}} ist der erste Teilnehmer.',
  memberIsLastParticpant: '{{name}} ist der letzte Teilnehmer.',
  cantContinueWithRegistrationWhenOffline:
    'Die Registrierung kann nicht fortgesetzt werden, da das Gerät offline ist.',
  cantContinueWithRegistrationWhenOfflineWithTryAgain:
    'Die Registrierung kann nicht fortgesetzt werden, da das Gerät offline ist. Stellen Sie sicher, dass Sie mit dem Internet verbunden sind.',
  confirmBlockContact:
    'Sie werden keine Alarme mehr von {{name}} erhalten. Weitermachen?',
  confirmUnblockContact:
    'Wenn Sie {{name}} entsperren, werden auch die blockierten Alarme wiederhergestellt. Fortfahren?',
  unblockingContact:
    'Aufhebung der Sperrung von {{name}} und Wiederherstellung von Alarmen.',
  unableToUnblockContact:
    'Die Sperrung des Kontakts kann nicht aufgehoben werden. {{error}}',
  blockingContact: 'Blockieren {{name}}.',
  unableToBlockContact: 'Der Kontakt kann nicht blockiert werden. {{error}}',
  cantAddContactToAlarmBecauseBlocked:
    'Sie haben {{name}} blockiert. Heben Sie die Blockierung auf, um sie als Teilnehmer des Alarms hinzuzufügen.',
  cantAddContactToGroupBecauseBlocked:
    'Sie haben {{name}} blockiert. Heben Sie die Blockierung auf, um sie als Mitglied der Gruppe hinzuzufügen.',
  sendMessageNotAllowedForPastAlarms:
    'Bei inaktiven Alarmen können keine Nachrichten gesendet werden.',
  nameIsRequired: 'Name ist erforderlich.',
  confirmDisableGroupAlarm:
    'Wenn Sie den Gruppenalarm deaktivieren, wird auch der Alarm für die anderen Teilnehmer deaktiviert. Fortfahren?',
  removeMemberFromGroup: 'Möchten Sie {{name}} aus dieser Gruppe entfernen?',
  leaveGroupConfirm: 'Willst du diese Gruppe verlassen?',
  deviceOffline:
    'Das Gerät ist offline. Stellen Sie sicher, dass Sie mit dem Internet verbunden sind und versuchen Sie es erneut.',
  mustBeOnlineForEnhancedAutoSnoozeCount:
    'Sie müssen online sein, um einen Alarm mit einer Schlummeranzahl von mehr als 2 zu speichern.',
  cantUpdateGroupDefaulConfigWhenOffline:
    'Die geänderte Gruppenkonfiguration wird nicht auf zukünftige Alarme angewendet, da das Gerät offline ist.',
  specifyFeedback: 'Rückmeldung ist erforderlich.',
  specifyEmailId: 'Eine E-Mail-Adresse ist erforderlich.',
  specifyValidEmailId: 'Die E-Mail-Adresse ist ungültig.',
  specifyProblem: 'Eine Problembeschreibung ist erforderlich.',
  appInstalledUsingSameNumberOnDifferentPhone:
    'Sie haben Galarm auf einem anderen Gerät mit der gleichen Nummer installiert. Die App auf diesem Gerät wird zurückgesetzt.',
  invalidUid:
    'Dieses Benutzerkonto existiert nicht mehr. Die Galarm-App auf diesem Gerät wird zurückgesetzt.',
  accountDeleted: 'Ihr Konto wurde gelöscht.',
  deleteAccount: 'Mein Konto löschen',
  deletingAccount: 'Löschung Ihres Kontos',
  howCanWeImprove:
    'Wir bedauern, Sie gehen zu sehen. Wie können wir uns verbessern?',
  noMusicAlert: 'Keine Musikdateien gefunden.',
  noLongerAvailableMusic:
    '{{fileName}} ist nicht mehr verfügbar. Der Klingelton wurde geändert in {{defaultRingtoneName}}',
  userInactiveTitle: 'Willkommen zurück!',
  userInactiveMessage:
    'Erstellen Sie Alarme für wichtige Dinge und verpassen Sie sie nicht.',
  createAlarm: 'Alarm erstellen',
  updatedAppAvailable: 'Eine neue Version der App ist verfügbar.',
  alarmOccurrenceDisabled: 'Deaktiviert für dieses Vorkommnis',
  ownAlarmOccurrenceDone: {
    zero: 'Erledigt am {{timeString}}',
    one: 'Erledigt markiert unter {{timeString}} am {{dateString}}'
  },
  ownAlarmOccurrenceSkipped: {
    zero: 'Überspringen bei {{timeString}}',
    one: 'Überspringen auf {{timeString}} am {{dateString}}'
  },
  enabledAlarmsCount: {
    one: '1 Alarm aktiviert.',
    other: '{{count}} Alarme aktiviert.'
  },
  enabledAndNotEnabledAlarmsCount: {
    one: '1 Alarm aktiviert. Alarme ohne zukünftiges Auftreten bleiben deaktiviert.',
    other:
      '{{count}} Alarme aktiviert. Alarme ohne zukünftiges Auftreten bleiben deaktiviert.'
  },
  disabledAlarmsCount: {
    one: '1 Alarm deaktiviert.',
    other: '{{count}} Alarme deaktiviert.'
  },
  ownAlarmOccurrenceUnacknowledged: 'Nicht geantwortet',
  participantAlarmOccurrenceDone: {
    zero: 'Erledigt von {{participantName}} unter {{timeString}}',
    one: 'Erledigt von {{participantName}} unter {{timeString}} am {{dateString}}'
  },
  participantAlarmOccurrenceSkipped: {
    zero: 'Übersprungen von {{participantName}} unter {{timeString}}',
    one: 'Übersprungen von {{participantName}} unter {{timeString}} am {{dateString}}'
  },
  participantAlarmOccurrenceUnacknowledged:
    '{{participantName}} hat nicht geantwortet',
  groupAlarmOccurrenceConfirmed: {
    zero: 'Bestätigt am {{timeString}}',
    one: 'Bestätigt unter {{timeString}} am {{dateString}}'
  },
  groupAlarmOccurrenceDeclined: {
    zero: 'Abgelehnt bei {{timeString}}',
    one: 'Abgelehnt unter {{timeString}} am {{dateString}}'
  },
  warning: 'Warnung',
  info: 'Infos',
  confirm: 'Bestätigen',
  error: 'Fehler',
  cantUploadImage: 'Bild kann nicht hochgeladen werden',
  cantDeleteImage: 'Bild kann nicht gelöscht werden',
  cantEditGroup: 'Gruppe kann nicht bearbeitet werden',
  cantAddNewContact: 'Kann keinen neuen Kontakt hinzufügen',
  cantDeleteContact: 'Kontakt kann nicht gelöscht werden',
  cantEditContact: 'Kontakt kann nicht bearbeitet werden',
  cantSaveAlarm: 'Kann den Alarm nicht speichern',
  cantSaveGroup: 'Kann die Gruppe nicht speichern',
  cantReloadContacts: 'Kontakte können nicht neu geladen werden',
  cantTakePhoto: 'Kann kein Foto machen',
  cantExportToCalendar: 'Kann nicht in den Kalender exportieren',
  cantOpenPhotoLibrary: 'Fotobibliothek kann nicht geöffnet werden',
  cantDeleteAlarmHistory: 'Alarmverlauf kann nicht gelöscht werden',
  cannotDuplicateAlarm: 'Alarm kann nicht dupliziert werden',
  upgradeToPremiumToDuplicateAlarm:
    'Aktualisieren Sie auf Premium, um mehr Alarme für Gruppen und Freunde zu erstellen.',
  confirmAcceptAlarm: 'Akzeptieren Sie den Alarm?',
  confirmRejectAlarm: 'Ablehnen des Alarms?',
  deleteAlarm: 'Alarm löschen?',
  restoreAlarmConfirmation: 'Alarm wiederherstellen?',
  respondToRepeatingAlarm: {
    zero: 'Sie werden von {{alarmCreatorName}} als Empfänger des Alarms {{alarmName}} hinzugefügt. Sie werden unter {{alarmTimeString}} {{alarmRepetitionString}} alarmiert. {{alarmDateString}}',
    one: 'Sie werden als Teilnehmer des Alarms {{alarmName}} von {{alarmCreatorName}} hinzugefügt. Sie werden unter {{alarmTimeString}} {{alarmRepetitionString}} alarmiert. {{alarmDateString}}'
  },
  respondToOneTimeAlarm: {
    zero: 'Sie werden als Empfänger des Alarms {{alarmName}} von {{alarmCreatorName}} hinzugefügt. Sie werden unter {{alarmTimeString}} alarmiert. {{alarmDateString}}',
    one: 'Sie werden als Teilnehmer des Alarms {{alarmName}} von {{alarmCreatorName}} hinzugefügt. Sie werden unter {{alarmTimeString}} alarmiert. {{alarmDateString}}'
  },
  cantMoveMemberUp: '{{name}} kann nicht nach oben verschoben werden',
  cantMoveMemberDown: '{{name}} kann nicht nach unten verschoben werden',
  decline: 'Ablehnen',
  cantEditProfile: 'Profil kann nicht bearbeitet werden',
  cantSelectContact: 'Kontakt kann nicht ausgewählt werden',
  cantSendMessage: 'Nachricht kann nicht gesendet werden',
  cantSendVerificationCode: 'Verifizierungscode kann nicht gesendet werden',
  confirmBlockContactTitle: 'Bestätigen Sie den Block Kontakt',
  confirmUnblockContactTitle: 'Bestätigen Sie den Kontakt entsperren',
  cantSaveProfile: 'Profil kann nicht gespeichert werden',
  cantBlockContact: 'Kontakt kann nicht blockiert werden',
  cantUnblockContact: 'Kontakt kann nicht entsperrt werden',
  cantLoadEarlierMessages: 'Frühere Nachrichten können nicht geladen werden',
  cantRestoreAlarm: 'Alarm kann nicht wiederhergestellt werden',
  cantSendFeedback: 'Rückmeldung kann nicht übermittelt werden',
  cantSubmitProblem: 'Kann Problem nicht einreichen',
  cantDeletePastAlarmsInBulk:
    'Inaktive Alarme können nicht massenhaft gelöscht werden',
  cantAddNewGroup: 'Neue Gruppe kann nicht hinzugefügt werden',
  alreadySnoozing: 'Schon geschlummert',
  markAlarmUndone:
    "Sie haben diesen Alarm vor {{durationString}} als 'Erledigt' markiert. Rückgängig machen?",
  markAlarmUnskipped:
    'Sie haben diesen Alarm vor {{durationString}} übersprungen. Rückgängig machen?',
  cantUndo: 'Kann nicht rückgängig gemacht werden',
  fetchMusicFromPhone: 'Suche nach verfügbarer Musik.',
  enableAllAlarmsInCategory: 'Alle Alarme in dieser Kategorie aktivieren?',
  disableAllAlarmsInCategory: 'Alle Alarme in dieser Kategorie deaktivieren?',
  allAlarmsAlreadyEnabled:
    'Alle Alarme in dieser Kategorie sind bereits aktiviert.',
  allAlarmsAlreadyDisabled:
    'Alle Alarme in dieser Kategorie sind bereits deaktiviert.',
  time: 'Zeit',
  timeForBuddy: 'Zeit für Buddy',
  timeForYou: 'Erinnern Sie mich an',
  name: 'Name',
  title: 'Titel',
  notes: 'Notizen',
  repeat: 'Wiederholen',
  preReminder: 'Vorab-Erinnerung',
  remove: 'Entfernen',
  considerEventsEndingWith:
    'Alarme für Ereignisse einstellen, die mit dem angegebenen Text enden',
  considerEventsContaining:
    'Alarme für Ereignisse einstellen, die den angegebenen Text enthalten',
  eventsEndingWith: 'Ereignisse, die mit dem angegebenen Text enden',
  eventsContaining: 'Ereignisse, die den angegebenen Text enthalten',
  preReminderShortAlert: '{{duration}} Vorab-Erinnerung',
  preReminderTitle: '{{alarmName}} unter {{date}}',
  preReminderGroupHelperText:
    'Diese Vorab-Erinnerung ist nur für Sie bestimmt. Andere Teilnehmer des Alarms können ihre eigenen Vorab-Erinnerungen einstellen, sobald sie den Alarm erhalten.',
  addPreReminder: 'Vorab-Erinnerung hinzufügen',
  helperTextForPreReminder:
    'Tippen Sie oben auf die Reset-Taste, um die Vorab-Erinnerung zu entfernen.',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  creator: 'Ersteller',
  useAsDefaultGroupConfiguration: 'Auf zukünftige Alarme anwenden',
  done: 'Erledigt',
  selectAll: 'Alle auswählen',
  skipped: 'Überspringen',
  save: 'Speichern',
  members: 'Mitglieder',
  mobileNumber: 'Rufnummer',
  enter: 'Eingabe',
  addMembers: 'Mitglieder hinzufügen',
  respond: 'Antworten',
  yes: 'Ja',
  no: 'Nein',
  notAvailable: 'Nicht verfügbar',
  cancel: 'Abbrechen',
  participants: 'Teilnehmer',
  takePhoto: 'Foto aufnehmen',
  chooseFromLibrary: 'Aus Bibliothek wählen',
  resendCode: 'Code erneut senden',
  register: 'Registrieren',
  inviteFriends: 'Diese App teilen',
  invite: 'Einladen',
  incorrectNumber: 'Falsche Nummer?',
  date: 'datum',
  cascadingAlarmInterval: 'Zeit zwischen den Warnmeldungen der Teilnehmer',
  ringParticipantAlarmsByDefault: 'Alarme klingeln lassen, ohne zu akzeptieren',
  alarmRingtone: 'Alarm-Klingelton',
  pickASong: 'Musik vom Telefon auswählen',
  privacyPolicy: 'Datenschutzbestimmungen',
  sendFeedback: 'Rückmeldung',
  galarmWeb: 'Galarm Web',
  galarmEnterprise: 'Galarm Pro',
  galarmAdmin: 'Galarm Verwaltung',
  troubleshooting: 'Fehlersuche',
  alarmDidntRingHelp: 'Hilfe! Mein alarm hat nicht geklingelt',
  autoStartSettingHelperText:
    'Wenn Ihr Telefon über eine Autostart-Einstellung verfügt, vergewissern Sie sich bitte, dass der Autostart für Galarm aktiviert ist.',
  batteryOptimizationHelperText: 'Batterieoptimierung für Galarm deaktivieren',
  troubleshootingHelperText:
    'Die folgenden Einstellungen verhindern möglicherweise, dass die Alarme wie erwartet klingeln. Bitte überprüfen Sie diese Einstellungen.',
  getMoreHelpText: 'Haben Sie immer noch Probleme?',
  autoStartSetting: 'Autostart',
  batteryOptimization: 'Optimierung der Batterie',
  battery: 'Batterie',
  rateTheAppSettings: 'Diese App bewerten',
  about: 'Über & Hilfe',
  leaveGroup: 'Gruppe verlassen',
  removeGroup: 'Gruppe entfernen',
  viewMember: '{{memberName}} anzeigen',
  removeMember: 'entfernen {{memberName}}',
  changeMemberState: 'Ändern, wer alarmieren kann {{memberName}}',
  changeYourGroupState: 'Ändern Sie, wer Sie alarmieren kann',
  numMembersInGroup: 'Mitglieder: {{count}}',
  notifications: 'App-Benachrichtigungen sind deaktiviert',
  backgroundAppRefresh: 'App-Aktualisierung im Hintergrund ist deaktiviert',
  groupsInCommon: 'Gemeinsame Gruppen',
  alarmsInCommon: 'Gemeinsame Alarme',
  close: 'Schließen',
  responsePending: 'Ihre Antwort?',
  later: 'Später',
  install: 'Installieren',
  all: 'Alle',
  numYears: {
    one: '1 Jahr',
    other: '{{count}} Jahre'
  },
  numMonths: {
    one: '1 Monat',
    other: '{{count}} Monate'
  },
  numDays: {
    one: '1 Tag',
    other: '{{count}} Tage'
  },
  hours: {
    one: '1 Stunde',
    other: '{{count}} Stunden'
  },
  minutes: {
    one: '1 Minute',
    other: '{{count}} Minuten'
  },
  seconds: {
    one: '1 Sekunde',
    other: '{{count}} Sekunden'
  },
  minutesSmall: '{{count}} min',
  secondsSmall: '{{count}} sec',
  hoursAfter: {
    one: '1 Stunde nach',
    other: '{{count}} Stunden nach'
  },
  minutesAfter: {
    one: '1 Minute nach',
    other: '{{count}} Minuten nach'
  },
  hoursAfterBuddy: {
    one: '1 Stunde nach freund',
    other: '{{count}} Stunden nach dem Freund'
  },
  minutesAfterBuddy: {
    one: '1 Minute nach freund',
    other: '{{count}} Minuten nach dem Freund'
  },
  longerThanAnHour: '> 1 Stunde',
  licenses: 'Lizenzierung von Drittanbietern',
  version: 'Version',
  termsOfService: 'Bedingungen der Dienstleistung',
  showPrivacyPolicy: '> Datenschutzbestimmungen',
  showTermsOfService: '> Allgemeine Geschäftsbedingungen',
  showLicenses: '> Lizenzierung von Drittanbietern',
  change: 'Ändern',
  snooze: 'Schlummern',
  somethingWentWrong:
    'Etwas ist schiefgelaufen. Bitte aktualisieren Sie die Seite.',
  ringOnVibrate: 'Klingeln auf Stumm',
  vibrate: 'Vibrieren',
  ringOnEarphoneOnly: 'Klingel-Alarm nur über Kopfhörer',
  ringOnSpeakerAndEarphone: 'Klingelalarm über Lautsprecher und Kopfhörer',
  whenEarphoneIsConnected: 'Wenn Kopfhörer angeschlossen sind',
  tapGesture: 'Tippen',
  slideGesture: 'Dia',
  silent: 'Stumm',
  volume: 'Lautstärke',
  soundAndVibration: 'Klänge und Vibrationen',
  advancedSettings: 'Erweiterte Einstellungen',
  gestureToDismissAnAlarm: 'Geste zum Ignorieren eines Alarms',
  someNotificationsAreMuted: 'Einige Benachrichtigungen sind stummgeschaltet',
  allNotificationsEnabled: 'Alle Benachrichtigungen sind aktiviert',
  notificationSettings: 'Einstellungen für die Benachrichtigung',
  missedAlarmsPlacement: 'Platzierung verpasster Alarme',
  missedAlarmsPlacementTooltipMessage:
    'Wählen Sie, wo verpasste Alarme in Ihrer Alarmliste angezeigt werden.',
  showMissedAlarmsOnTop: 'Oben anzeigen',
  showMissedAlarmsAfterUpcoming: 'Nach bevorstehenden Alarmen anzeigen',
  showMissedAlarmsNotification: 'Benachrichtigung oben anzeigen',
  hideMissedAlarms: 'Verpasste Alarme nicht anzeigen',
  galarmWebNotifications: 'Galarm Web-Benachrichtigungen',
  alarmsfromOthersNotifications: 'Alarme der Teilnehmer Benachrichtigungen',
  sharedAlarmNotifications: 'Gemeinsame Alarm-Benachrichtigungen',
  alarmChatNotifictions: 'Alarm Chat-Benachrichtigungen',
  groupNotifications: 'Gruppen-Benachrichtigungen',
  alarmAcknowledgementNotifications: 'Alarm-Quittierungs-Benachrichtigungen',
  send: 'Senden',
  prev: 'Zurück',
  snoozing: '{{timeString}}',
  snoozingStatus: 'Schlummern',
  specifySnoozeDuartion: 'Dauer des Schlummerns festlegen',
  chooseDifferentDuration: 'Wählen Sie eine andere Dauer',
  noCalendarsFound: 'Es wurden keine Kalender auf dem Gerät gefunden.',
  eventWillEndAt: 'Die Veranstaltung endet auf {{timeString}}.',
  selectDurationWithinTheSameDay:
    'Das Ereignis kann die Tagesgrenze nicht überschreiten.',
  cannotMapRepeatTypeInTheDeviceCalendar:
    'Exportieren in den Kalender" ist nicht möglich, da die Einstellung "Wiederholen" Ihres Alarms vom Kalender nicht unterstützt wird.',
  alarmSavedToCalendar: 'Der Alarm wurde erfolgreich im Kalender gespeichert.',
  faq: 'Häufig gestellte Fragen',
  searchingFaqs: 'Suche nach verwandten Hilfeartikeln...',
  faqsMayHelp:
    'Wir haben einige Hilfeartikel gefunden, die Ihre Frage beantworten könnten:',
  noFaqsFound: 'Keine verwandten Hilfeartikel gefunden.',
  sendFeedbackAnyway: 'Feedback trotzdem senden',
  editFeedback: 'Feedback bearbeiten',
  submitProblemAnyway: 'Problem trotzdem einreichen',
  editProblem: 'Problem bearbeiten',
  openSettings: 'Einstellungen öffnen',
  openAppSettings: 'App-Einstellungen öffnen',
  alreadyDone: 'Erledigt',
  enableAutoStart: 'Autostart einschalten',
  restrictedApps: 'Eingeschränkte Apps',
  unmonitoredApps: 'Unüberwachte Apps',
  enableProtected: 'Geschützte Apps',
  manageAppLaunch: 'App-Start verwalten',
  unblockContact: 'Kontakt entsperren',
  blockContact: 'Kontakt blockieren',
  call: 'Rufen Sie  an. {{name}}',
  text: 'Text {{name}}',
  chat: 'Chat',
  ok: 'OK',
  stopSnooze: 'Schlummern stoppen',
  emailId: 'Ihre E-Mail Adresse',
  feedback: 'Rückmeldung',
  submit: 'Einreichen',
  reportAProblem: 'Ein Problem melden',
  enableAlarm: 'Alarm einschalten',
  restoreAlarm: 'Alarm wiederherstellen',
  deletePastAlarms: 'Inaktive Alarme löschen',
  accept: 'Akzeptieren',
  defaultPersonalAlarmName: 'Persönliche Erinnerung',
  defaultGroupAlarmName: 'Gruppe Veranstaltung',
  defaultRecipientAlarmName: 'Alarm für Freunde',
  search: 'Suche',
  recent: 'Neueste',
  upcoming: 'Demnächst',
  missed: 'Verpasst',
  expired: 'Verpasst',
  past: 'Vergangenheit',
  active: 'Aktiv',
  inactive: 'inaktiv',
  allAlarms: 'Alle Alarme',
  myAlarms: 'Meine Alarme',
  participantAlarms: 'Alarme für Teilnehmer',
  pendingParticipantAlarms: 'Neue Alarme von anderen',
  alarmsWithUnreadChatMessages: 'Alarme mit neuem Chat',
  systemNotifications: 'System-Meldungen',
  missedAlarms: 'Verpasste Alarme',
  missedAlarmsInCategory: '{{name}} Verpasste Alarme',
  showMissedAlarms: 'Verpasste Alarme anzeigen',
  recentlyDeletedAlarms: 'Kürzlich gelöschte Alarme',
  searchAlarms: 'Suche Alarme',
  participant: 'Teilnehmer',
  you: 'Sie',
  none: 'Keine',
  onceOnly: 'Nur einmal',
  weekdays: 'Wochentage',
  weekends: 'Wochenenden',
  everyDayString: 'Täglich',
  everySunday: 'Jeden Sonntag',
  everyMonday: 'Jeden Montag',
  everyTuesday: 'Jeden Dienstag',
  everyWednesday: 'Jeden Mittwoch',
  everyThursday: 'Jeden Donnerstag',
  everyFriday: 'Jeden Freitag',
  everySaturday: 'Jeden Samstag',
  sunday: 'Sonntag',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  january: 'Januar',
  february: 'Februar',
  march: 'März',
  april: 'April',
  may: 'Mai',
  june: 'Juni',
  july: 'Juli',
  august: 'August',
  september: 'September',
  october: 'Oktober',
  november: 'November',
  december: 'Dezember',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mär',
  apr: 'Apr',
  shortMay: 'Mai',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Okt',
  nov: 'Nov',
  dec: 'Dez',
  sun: 'So',
  mon: 'Mo',
  tue: 'Di',
  wed: 'Mi',
  thu: 'Do',
  fri: 'Fr',
  sat: 'Sa',
  first: '1.',
  second: '2.',
  third: '3.',
  fourth: '4.',
  fifth: '5.',
  every: 'Alle',
  oddNumberedDays: 'Ungerade nummerierte Daten',
  evenNumberedDays: 'Geradzahlige Daten',
  noParticipants: 'Keine Teilnehmer',
  typeYourMessage: 'Geben Sie Ihre Nachricht ein',
  cantPostMessageToPastAlarm:
    'Nachricht kann nicht an einen inaktiven Alarm gesendet werden',
  groupName: 'gruppe: {{name}}',
  confirmed: 'bestätigt',
  declined: 'abgelehnt',
  Done: 'Erledigt',
  Skip: 'Überspringen',
  Confirm: 'Bestätigen',
  Decline: 'Ablehnen',
  Accept: 'Akzeptieren',
  today: 'heute',
  on: 'auf',
  recipientAlarm: 'Alarm für Freunde',
  recipient: 'Empfänger',
  remindMeAfter: 'Erinnern Sie mich',
  remindMeIn: 'Erinnern Sie mich in',
  newRecipientAlarm: 'Neuer freundlicher alarm',
  editRecipientAlarm: 'Alarm für Freunde bearbeiten',
  newInstantAlarm: 'Neuer Sofortalarm',
  instantAlarms: 'Sofortalarme',
  noTaskAlarms: `Keine Aufgabenalarme

Aufgabenalarme werden aus Aufgaben und Aufgabenlisten festgelegt.`,
  taskAlarmName: 'Aufgabe: {{alarmName}}',
  noInstantAlarms: `Keine Sofortalarme

Sofortalarme können verwendet werden, um einen Kontakt oder eine Gruppe bei Notfällen oder dringenden Aufgaben sofort zu benachrichtigen.`,
  alarmDone: 'Alarm Markiert Erledigt',
  alarmSkipped: 'Alarm übersprungen',
  undo: 'Rückgängig machen',
  enterVerificationCode: 'Bitte geben Sie den 4-stelligen Code unten ein:',
  initializing: 'Initialisierung',
  tryAgain: 'Erneut versuchen',
  nMore: '+ {{count}} mehr',
  enableNotification: 'Aktivieren',
  enableAlarmNotificationChannel: 'Aktivieren Sie',
  enableBackgroundAppRefresh: 'Aktivieren Sie',
  viewImpactedAlarms: 'Alarme',
  viewImpactedGroups: 'gruppen',
  dismiss: 'Ignorieren',
  minsInterval: '+ {{count}}m',
  secsInterval: '+ {{count}}s',
  hoursInterval: '+ {{count}}h',
  daysInterval: '+ {{count}}d',
  snoozeUnitHours: 'Stunden',
  snoozeUnitMinutes: 'Minuten',
  snoozeUnitDays: 'Tage',
  selectMinutes: 'Minuten auswählen',
  selectHours: 'Stunden auswählen',
  selectDays: 'Tage auswählen',
  selectHoursAndMinutes: 'Stunden und Minuten auswählen',
  enterDuration: 'Dauer',
  snoozeUnit: 'Einheit',
  specifySnoozeUnit: 'Schlummern Einheit spezifizieren',
  specifySnoozeDuration: 'Dauer des Schlummerns festlegen',
  duration: 'Dauer',
  quickAlarmName: {
    zero: '{{minutes}} Min-Erinnerung',
    one: '{{hours}} Stundenerinnerung',
    other: '{{hours}} Stunde {{minutes}} min erinnerung'
  },
  alarmTitleForGoogleVoiceTimerCommand: '{{durationString}} erinnerung',
  addedAlarmFromVoiceCommand:
    'Hinzufügen eines Alarms für {{alarmName}} unter {{dateString}}',
  addedTimerFromVoiceCommand: 'Ein Timer wurde hinzugefügt für {{duration}}',
  clear: 'Klar',
  ringtoneDuration: 'Klingelton Dauer',
  newAlarm: 'Neuer Alarm',
  quickAlarm: 'Schnelle Erinnerung',
  quickAlarmWillRingAt: 'Der Alarm klingelt unter {{timeString}}.',
  calendarWithSnoozeAt:
    'Die Veranstaltung wird als nächstes auf {{timeString}} klingeln.',
  random: 'Zufällig',
  enableAllAlarms: 'Alle Alarme einschalten',
  disableAllAlarms: 'Alle Alarme deaktivieren',
  deleteAllAlarms: 'Alle Alarme löschen',
  hideCategory: 'Kategorie ausblenden',
  unhideCategory: 'Kategorie einblenden',
  dontShowHiddenCategories: 'Ausgeblendete Kategorien nicht anzeigen',
  showHiddenCategories: 'Versteckte Kategorien anzeigen',
  welcomeAlarmsTitle: 'Fangen wir an!',
  welcomeAlarmsMessage: 'Hier sind einige häufig verwendete Alarme:',
  onboardingAlarms: 'Onboarding Alarme',
  hiddenAlarmCategories: 'Versteckte Kategorien',
  restorePurchases: 'Käufe wiederherstellen',
  noAvailablePurchasesFound:
    'Keine verfügbaren Einkäufe für Ihr Konto gefunden.\n\nBitte senden Sie uns eine Rückmeldung über "Einstellungen > Feedback", wenn Sie einen gültigen Kauf haben, den Sie nicht wiederherstellen können.',
  restoringPurchases: 'Wiederherstellung von Käufen',
  fetchingContacts: 'Prüfen, welche Kontakte Galarm verwenden',
  enterNameAndUploadPhotoForUser:
    'Geben Sie unten Ihren Namen ein und laden Sie optional Ihr Profilfoto hoch',
  enterNameAndUploadPhotoForGroup:
    'Geben Sie unten einen Namen ein und laden Sie optional ein Gruppenfoto hoch',
  noContactsWithAppInstalled: 'Niemand in Ihren Kontakten verwendet Galarm.',
  galarmContacts: {
    one: '1 Galarm-Kontakt',
    other: '{{count}} Galarm-Kontakte'
  },
  contactsPendingInvitation: {
    one: '1 ausstehende Einladung',
    other: '{{count}} ausstehende Einladungen'
  },
  otherContacts: {
    one: '1 sonstiger Kontakt',
    other: '{{count}} sonstige Kontakte'
  },
  over100Contacts: 'Über 100 weitere Kontakte',
  noAlarms:
    'Sie haben noch keine Alarme. Tippen Sie auf +, um einen neuen Alarm hinzuzufügen.',
  noContactsWeb: {
    one: 'Wir haben keine Kontakte gefunden, die Galarm benutzen. Entweder haben wir keine Berechtigung, auf Ihre Kontakte zuzugreifen, oder niemand in Ihren Kontakten verwendet Galarm. Sie können Ihre Kontakte über die mobile App synchronisieren.\n\nSie können Kontakte, die Galarm verwenden, auf verschiedene Weise zu Ihren Alarmen hinzufügen, um von der App zu profitieren',
    other:
      'Bitte registrieren Sie sich in der mobilen App, um Kontakte zu Ihren Alarmen hinzuzufügen.'
  },
  viewingAlarmsInCommon: 'Gemeinsame Alarme mit {{name}}',
  viewingGroupsInCommon: 'Gemeinsame Gruppen mit {{contactName}}',
  changeGroupMemberConfigTextForCascadingAlarm:
    'Aktive Teilnehmer werden in der angezeigten Reihenfolge benachrichtigt.',
  changeGroupMemberConfigTextForSimultaneousAlarm:
    'Nur aktive Teilnehmer werden benachrichtigt.',
  changeGroupMemberStateText: {
    zero: 'Ändern Sie die Mitglieder, die Sie alarmieren können, wenn ein Alarm für die Gruppe "{{groupName}}" erstellt wird.\n\nSie werden nur benachrichtigt, wenn der Alarm von erlaubten Mitgliedern erstellt wird.',
    one: 'Ändern Sie die Mitglieder, die {{memberName}} alarmieren können, wenn ein Alarm für die Gruppe "{{groupName}}" erstellt wird.\n\n{{memberName}} wird nur alarmiert, wenn der Alarm von erlaubten Mitgliedern erstellt wird.'
  },
  allowed: 'Erlaubt',
  notAllowed: 'Nicht erlaubt',
  changeStatus: 'Erlaubte Mitglieder',
  noUpcomingAlarms: 'Keine anstehenden Alarme',
  showMore: 'Mehr anzeigen',
  nMorePastAlarms: {
    one: '1 weiterer inaktiver alarm',
    other: '{{count}} mehr inaktive alarme'
  },
  shareAppMessage:
    'Ich erledige alle meine Dinge rechtzeitig, indem ich mit der Galarm-App Erinnerungen für sie erstelle. Mit dieser App können wir uns auch gegenseitig in unsere Erinnerungen einbeziehen. Ich empfehle den Download dieser innovativen App für Alarme und Erinnerungen. {{downloadLink}}',
  addingMembers: 'Hinzufügen von Mitgliedern.',
  unableToAddMembers:
    'Es können keine Mitglieder hinzugefügt werden. {{error}}',
  removingMember: 'Mitglied wird entfernt.',
  unableToRemoveMember: 'Das Mitglied kann nicht entfernt werden. {{error}}',
  leavingGroup: 'Die Gruppe verlassen.',
  unableToLeaveGroup: 'Kann die Gruppe nicht verlassen. {{error}}',
  expiredPersonalAlarmForCreator: {
    zero: 'Dieser Alarm ist vor {{durationString}} abgelaufen. Tippen Sie auf "Erledigt", um den Alarm abzuschließen.',
    one: 'Dieser Alarm lief vor {{durationString}} ab. Tippen Sie auf "Erledigt", um den Alarm abzuschließen und die Teilnehmer zu benachrichtigen.',
    other:
      'Dieser Alarm lief vor {{durationString}} ab. Tippen Sie auf "Erledigt", um den Alarm abzuschließen und die Teilnehmer zu benachrichtigen.'
  },
  donePersonalAlarmForCreator:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Der Alarm ist als erledigt markiert.',
  skippedPersonalAlarmForCreator:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Sie haben den Alarm übersprungen.',
  expiredGroupAlarm:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Bitte bestätigen Sie Ihre Teilnahme.',
  expiredPersonalAlarmForParticipant:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Bitte erinneren Sie {{creatorName}}.',
  alarmDurationAndroid:
    'Der Alarm ist ab jetzt auf {{durationString}} eingestellt.',
  alarmDurationIos:
    'Der Alarm ist ab jetzt auf {{durationString}} eingestellt.',
  alarmFeedbackHeader:
    'Sie senden einen Teil der Informationen zu diesem Alarm zu Debugging-Zwecken. Personenbezogene Daten wie Alarmname, Notizen oder Teilnehmer werden nicht weitergegeben.',
  privacyPolicyHeader:
    'Der Schutz Ihrer Privatsphäre ist für uns ein wichtiges Anliegen. Genau wie Sie schätzen wir die Privatsphäre, deshalb möchten wir Sie wissen lassen, dass wir Ihre persönlichen Daten an niemanden weitergeben, es sei denn, dies ist für die Installation der Anwendung erforderlich oder gesetzlich vorgeschrieben. In jedem Fall werden wir Ihre Daten niemals verkaufen. So einfach ist das!\n \nDie von Ihnen erstellten Alarme sind nur auf Ihrem Gerät und, falls ein Alarm andere Teilnehmer einschließt, auf den Geräten dieser Teilnehmer sichtbar.\n \nWir greifen auf das Adressbuch/die Kontaktliste Ihres Telefons nur zu, um die Registerkarte "Kontakte" in Galarm aufzufüllen. Wir speichern diese Liste nicht für andere Zwecke. Wir respektieren, dass es Ihr Adressbuch ist!\n \nWir greifen auf Ihre Kamera und Fotos nur zu, um Ihnen die Möglichkeit zu geben, ein gutes Profilbild einzustellen. Dieses Bild erscheint als Ihr Avatar oder als Profilbild einer Gruppe, die Sie bearbeiten. Andere Galarm-Benutzer, die Mitglieder der von Ihnen eingestellten Alarme sind, können dieses Bild sehen.\n\nWir senden die öffentliche IP-Adresse Ihres Geräts und seine eindeutige ID bei allen Anfragen, z. B. bei der Anforderung und Überprüfung des Codes während des Registrierungsprozesses. Diese Informationen sind nicht mit Ihrem Konto verknüpft und werden nur verwendet, um mögliche bösartige Aktivitäten zu ermitteln.\n \nBitte lesen Sie die vollständige Datenschutzerklärung, um mehr über die von uns gesammelten Daten und ihre Verwendung zu erfahren.',
  termsOfServiceHeader:
    'Durch die Nutzung der Galarm-App erklären Sie sich mit unseren Nutzungsbedingungen einverstanden, die Ihren Zugang zu und Ihre Nutzung dieser mobilen App sowie der darin angebotenen Funktionen und Dienste regeln. \n\nDas Motto von Galarm ist einfach - wir helfen Ihnen dabei, kein Ereignis zu verpassen!  Ob Sie persönliche Alarme einrichten, um sich wecken zu lassen, pünktlich zu Terminen zu erscheinen und Erinnerungen für Aktivitäten wie die rechtzeitige Einnahme von Medikamenten einzustellen, oder ob Sie Gruppenalarme für die Organisation von Gruppenaktivitäten wie Kinobesuche, Sportereignisse und Partys erstellen, Galarm ermöglicht es Ihnen, einen sozialen Alarm zu haben, um sich gegenseitig zu erinnern, den Status zu verfolgen und zu kommunizieren.\n\nBitte nutzen Sie Galarm nur, wenn Sie mit diesen Bedingungen einverstanden sind. Unten finden Sie einen Link dazu.',
  acknowledgedPersonalAlarm:
    'Sie haben den Alarm vor {{durationString}} als "Erledigt" markiert.',
  skippedPersonalAlarm: 'Sie haben den Alarm übersprungen {{durationString}}.',
  authenticatingWithServer: 'Verbinden...',
  selectParticipantsForPersonalAlarm:
    'Wählen Sie eine Gruppe oder eine Reihe von Personen aus, die als Sicherungen für Ihren persönlichen Alarm fungieren.',
  selectParticipantsForGroupAlarm:
    'Wählen Sie eine Gruppe oder eine Reihe von Personen für Ihre Gruppenaktivität aus.',
  acknowledgedGroupAlarm:
    'Sie {{acknowledgedAsString}} diesen Alarm {{durationString}} vor.',
  acknowledgedExpiredGroupAlarm:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Sie {{acknowledgedAsString}} diesen Alarm.',
  acknowledgedPersonalAlarmForParticipant:
    '{{creatorName}} den Alarm vor {{durationString}} als "Erledigt" markiert.',
  acknowledgedExpiredPersonalAlarmForParticipant:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. {{creatorName}} hat den Alarm als "Erledigt" markiert.',
  entityNotFound:
    'Huch! Wir konnten die ausgewählte {{entityType}} nicht finden. Es kann sein, dass wir sie noch suchen oder dass sie entfernt wurde.',
  goBack: 'Zurückgehen',
  uploadingImageToServer: 'Bild auf den Server hochladen.',
  deletingImageFromServer: 'Bild vom Server löschen',
  errorUploadingImageToServer:
    'Fehler beim Hochladen des Bildes auf den Server. Bitte versuchen Sie es später noch einmal.',
  unableToRemoveGroup: 'Die Gruppe kann nicht entfernt werden. {{error}}',
  addingGroup: 'Gruppe hinzufügen.',
  editingGroup: 'Redaktionsgruppe.',
  unableToAddGroup: 'Gruppe kann nicht hinzugefügt werden. {{error}}',
  unableToEditGroup: 'Die Gruppe kann nicht bearbeitet werden. {{error}}',
  thanksForFeedback: 'Danke, dass Sie uns helfen, uns zu verbessern.',
  licensesHeader:
    'Galarm enthält Software, die von Dritten lizenziert wurde. Bitte sehen Sie sich unsere Seite zur Lizenzierung von Drittanbietern an, um die entsprechenden Informationen zur Lizenzierung zu erhalten.',
  alarmAlreadyInSnooze: 'Sie werden unter {{durationString}} daran erinnert.',
  carrierChargesMayApply: 'Es können Beförderungsgebühren anfallen.',
  selectCascadingInterval:
    'Der erste Teilnehmer wird {{firstParticipantDurationString}} nach der Zeit des Alarms alarmiert, der zweite Teilnehmer wird {{secondParticipantDurationString}} nach der Zeit des Alarms alarmiert und so weiter, wenn Sie den Alarm nicht als erledigt markieren.',
  reorderParticipantsScreenDescription:
    'Die Teilnehmer werden in der angezeigten Reihenfolge benachrichtigt.',
  noMembers: 'Keine Mitglieder',
  selectedGroupDescription: {
    zero: '{{numActiveMembers}} Teilnehmer',
    one: '{{numActiveMembers}} aktiver und {{numInactiveMembers}} inaktiver Teilnehmer',
    other:
      '{{numActiveMembers}} aktive und {{numInactiveMembers}} inaktive Teilnehmer'
  },
  groupAlarmWillRingAtSameTime:
    'Alle Teilnehmer werden unter {{timeString}} benachrichtigt.',
  welcomeToGalarm: 'Willkommen bei Galarm',
  checkingConnection: 'Überprüfung der Verbindung',
  deletePastAlarmsTitle: 'Löschen inaktiver Alarme, die älter sind als',
  deletePastAlarmsOption: {
    zero: '{{option}} (0 Alarme)',
    one: '{{option}} (1 Alarm)',
    other: '{{option}} ({{count}} alarme)'
  },
  chooseSnoozeInterval: 'Erinnern Sie mich wieder in',
  personalAlarmDescription:
    'Verwenden Sie einen persönlichen Alarm für das Aufwachen, die Einnahme von Medikamenten oder jede andere Aufgabe für sich selbst. Sie können optional Teilnehmer hinzufügen, die benachrichtigt werden, wenn Sie einen Alarm verpassen, damit sie Sie erinneren können. Die Teilnehmer werden auch benachrichtigt, wenn Sie den Alarm als erledigt markieren.',
  groupAlarmDescription:
    'Verwenden Sie einen Gruppenalarm für Gruppenaktivitäten wie Ausflüge, Partys oder andere Veranstaltungen. Der Alarm ertönt zur gleichen Zeit für alle Teilnehmer und sie können ihre Teilnahme bestätigen.',
  instantAlarmDescription:
    'Verwenden Sie diesen Alarm, um einen Kontakt oder eine Gruppe von Kontakten über eine Notfallübung, den Beginn eines Spiels, eine dringende Aufgabe/Besprechung und andere Ereignisse zu informieren, die sofortige Aufmerksamkeit erfordern.',
  recipientAlarmDescription:
    'Erstellen Sie Alarme für eine andere Person ("Freund"), um sie an Dinge zu erinnern, die sie erledigen muss. Sie werden benachrichtigt, um den Freund zu erinnern, falls er den Alarm verpasst. Sie werden auch benachrichtigt, wenn der Freund den Alarm als erledigt markiert.\n  \nBeachten Sie, dass die Alarme in Ihrer Zeitzone erstellt werden.',
  whatsThis: 'Was ist das?',
  alarmCurrentlyDisabled: 'Dieser Alarm ist derzeit deaktiviert',
  alarmCurrentlyRejected: 'Dieser Alarm wird derzeit abgelehnt',
  currentlyTypingUsers: {
    one: '{{currentlyTypingUsers}} tippt...',
    other: '{{currentlyTypingUsers}} tippen...'
  },
  noSearchResultsFound: 'Keine {{type}} gefunden',
  noGroupsCreated: 'Sie haben keine Gruppen erstellt.',
  noGroupsWeb: {
    one: 'Sie haben keine Gruppen erstellt.',
    other:
      'Bitte registrieren Sie sich in der mobilen App, um Gruppen zu erstellen und sie zu Alarmen hinzuzufügen.'
  },
  internalErrorDuringRegistration:
    'Bei der Benutzerregistrierung ist ein interner Fehler aufgetreten. Bitte versuchen Sie es nach ein paar Minuten erneut.',
  selectRecipientAlarmInterval: {
    zero: 'Sie werden zur gleichen Zeit wie der Empfänger benachrichtigt',
    one: 'Wenn der Empfänger den Alarm nicht als "Erledigt" markiert, werden Sie nach der Zeit des Alarms auf {{durationString}} benachrichtigt.',
    other:
      'Wenn der Empfänger den Alarm nicht als "Erledigt" markiert, werden Sie nach der Zeit des Alarms auf {{durationString}} benachrichtigt.'
  },
  selectRecipient: 'Empfänger auswählen',
  acknowledgedExpiredRecipientAlarm:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Sie haben diesen Alarm als "Erledigt" markiert.',
  skippedExpiredRecipientAlarm:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Sie haben diesen Alarm übersprungen.',
  expiredRecipientAlarm:
    'Dieser Alarm lief vor {{durationString}} ab. Tippen Sie auf "Erledigt", um den Alarm abzuschließen und {{creatorName}} zu benachrichtigen.',
  acknowledgedRecipientAlarm:
    'Sie haben diesen Alarm vor {{durationString}} als "Erledigt" markiert.',
  skippedRecipientAlarm:
    'Sie haben diesen Alarm vor {{durationString}} übersprungen.',
  acknowledgedExpiredRecipientAlarmForCreator:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. {{recipientName}} hat den Alarm als "Erledigt" markiert.',
  skippedExpiredRecipientAlarmForCreator:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. {{recipientName}} hat den Alarm übersprungen.',
  expiredRecipientAlarmForCreator:
    'Dieser Alarm ist vor {{durationString}} abgelaufen. Bitte erinneren Sie {{recipientName}}.',
  acknowledgedRecipientAlarmForCreator:
    '{{recipientName}} den Alarm vor {{durationString}} als "Erledigt" markiert.',
  selectRecipientForRecipientAlarm: 'Wählen Sie einen Empfänger für den Alarm',
  selectAtLeastOneParticipantForGroupAlarm:
    'Mindestens einen Teilnehmer zum Alarm hinzufügen',
  addAtLeastOneMemberToGroup: 'Mindestens ein Mitglied zur Gruppe hinzufügen',
  atTheSameTime: 'Zur gleichen Zeit',
  myself: 'Ich selbst',
  group: 'Gruppe',
  someoneElse: 'Jemand anders',
  participantsAreNotified: 'Die Teilnehmer werden benachrichtigt.',
  creatorIsNotified: '{{creatorName}} benachrichtigt wird.',
  membersAddedToGroup: {
    one: '{{memberNames}} wird der Gruppe {{groupName}} hinzugefügt.',
    other: '{{memberNames}} werden der Gruppe {{groupName}} hinzugefügt.'
  },
  memberRemovedFromGroup:
    '{{memberName}} wurde aus der Gruppe {{groupName}} entfernt, was sich auf einige Ihrer Alarme ausgewirkt haben könnte.',
  youRemovedFromGroup:
    'Sie wurden aus der Gruppe {{groupName}} entfernt, was sich auf einige Ihrer Alarme ausgewirkt haben kann.',
  memberLeftGroup:
    '{{memberName}} linke Gruppe {{groupName}}, was sich auf einige Ihrer Alarme ausgewirkt haben könnte.',
  youLeftGroup:
    'Sie haben die Gruppe {{groupName}} verlassen, was sich auf einige Ihrer Alarme ausgewirkt haben könnte.',
  groupLeft: 'Sie haben die Gruppe {{groupName}} verlassen.',
  memberMovedToADifferentTimezone:
    '{{memberName}} in eine andere Zeitzone umgezogen, was sich auf einige Ihrer Alarme ausgewirkt haben könnte.',
  memberDstChanged: {
    zero: '{{memberName}} nicht mehr die Sommerzeit einhalten. Die entsprechenden Alarme wurden aktualisiert.',
    one: '{{memberName}} mit der Einhaltung der Sommerzeit begonnen. Die entsprechenden Alarme wurden aktualisiert.'
  },
  impactedAlarms: 'Betroffene Alarme:',
  alwaysRingParticipantAlarmsOn:
    'Alarme von anderen werden klingeln, wenn Sie sie nicht ablehnen.',
  alwaysRingParticipantAlarmsOff:
    'Alarme von anderen Personen klingeln nur, wenn Sie sie akzeptieren.',
  agreeToTermsOfServiceAndPrivacyPolicy:
    'Wenn Sie fortfahren, akzeptieren Sie die Allgemeinen Geschäftsbedingungen und die Datenschutzrichtlinie von Galarm.',
  deleteAccountWarningHeader:
    'Warnung: Diese Aktion ist nicht umkehrbar. Die Löschung Ihres Kontos wird:',
  deleteAccountDeleteAlarms:
    '- Löschen Sie alle Alarme, die Sie erstellt haben',
  deleteAccountDeleteRecipientAlarms:
    '- Löschen Sie alle Alarme von Freunden, bei denen Sie der Empfänger sind',
  deleteAccountRemoveFromGroups: '- Sie aus allen Gruppen entfernen',
  cancelSubscriptionWarning:
    'Sie haben ein aktives Premium-Abonnement. Das Löschen Ihres Kontos storniert es nicht automatisch. Bitte kündigen Sie Ihr Abonnement, um zukünftige Gebühren zu vermeiden.',
  deleteAccountWarningFooter: {
    zero: 'Wenn Sie das Telefon wechseln, können Sie die App einfach auf Ihrem neuen Telefon installieren und sich mit derselben Nummer anmelden. Sie können die App auf diesem Telefon entfernen.\n\nWenn Sie Ihr Konto löschen, können Sie es nicht mehr wiederherstellen.',
    one: 'Wenn Sie das Telefon wechseln, können Sie die App einfach auf Ihrem neuen Telefon installieren und sich mit derselben Nummer anmelden. Sie können die App auf diesem Telefon entfernen.\n\nWenn Sie Ihr Konto löschen, können Sie es nicht mehr wiederherstellen. Sie können Ihr aktives Galarm-Abonnement im Play Store verwalten.',
    other:
      'Wenn Sie das Telefon wechseln, können Sie die App einfach auf Ihrem neuen Telefon installieren und die App auf diesem Telefon löschen.\n\nSobald Sie Ihr Konto gelöscht haben, können Sie es nicht mehr wiederherstellen. Sie können Ihr aktives Galarm-Abonnement im App Store verwalten.'
  },
  typeConfirmationStringToDeleteAccount:
    'Geben Sie {{confirmationString}} ein, um Ihr Konto zu löschen.',
  unableToDeleteAccount: 'Konto kann nicht gelöscht werden. {{error}}',
  impactedGroups: 'Betroffene Gruppen:',
  memberDeletedAccount:
    '{{memberName}} hat sein Konto gelöscht, was sich auf einige Ihrer Alarme und Gruppen ausgewirkt haben kann.',
  confirmCountryCodeAndEnterNumberForExistingUser:
    'Bitte bestätigen Sie Ihre Landesvorwahl und geben Sie die Telefonnummer ein, die Sie bei der Registrierung verwendet haben.',
  requiredPermissionsDisabledWarningIos:
    'Benachrichtigungen sind deaktiviert. Alarme klingeln nicht. Zum Beheben antippen.',
  requiredPermissionsDisabledWarningAndroid:
    'Galarm verfügt nicht über die erforderlichen Berechtigungen, um Alarme zu klingeln. Tippen Sie zur Behebung.',
  notificationChannelPopupDisabledWarningAndroid:
    'Alarm-Benachrichtigungen werden nicht auf dem Bildschirm angezeigt. Tippen Sie zum Beheben auf .',
  alarmLockScreenNotificationDisabledWarningAndroid:
    'Alarm-Benachrichtigungen werden nicht auf dem Sperrbildschirm angezeigt. Tippen Sie zum Beheben auf .',
  why: 'Warum',
  how: 'Wie',
  registrationRequired: 'Registrierung erforderlich',
  phoneNumberRequired: 'Telefonnummer erforderlich',
  fewSeconds: 'wenige Sekunden',
  lessThanMinute: 'weniger als eine Minute',
  updateUnsupportedVersion:
    'Um Galarm weiterhin nutzen zu können, ist eine aktualisierte Version der App erforderlich.',
  update: 'Update',
  back: 'Zurück',
  unableToMarkAlarmDone:
    'Der Alarm kann zu diesem Zeitpunkt nicht als erledigt markiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToMarkAlarmUndone:
    'Der Alarm kann zu dieser Zeit nicht als rückgängig gemacht markiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToMarkAlarmUnskipped:
    'Zu dieser Zeit kann der Alarm nicht als nicht übersprungen markiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToSkipAlarm:
    'Das Überspringen des Alarms ist zu dieser Zeit nicht möglich. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToSetGroupAlarmResponse:
    'Der Gruppenalarm kann zu dieser Zeit nicht unter {{response}} abgerufen werden. Bitte versuchen Sie es in einigen Augenblicken erneut.',
  unableToDeleteAlarm:
    'Der Alarm kann zu dieser Zeit nicht gelöscht werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToSetAlarmResponse:
    'Ihre Antwort kann zu dieser Zeit nicht eingestellt werden. Bitte versuchen Sie es in einigen Augenblicken erneut.',
  unableToSnoozeAlarm: 'Sie können den Alarm nicht schlummern lassen.',
  unableToStopSnoozeForAlarm:
    'Das Schlummern des Alarms kann nicht beendet werden.',
  unableToUpdateParticipantAlarmRingerSettings:
    'Die Ruftoneinstellungen können zu dieser Zeit nicht aktualisiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  updateParticipantPreReminderDuration:
    'Die Dauer der Vorab-Erinnerung kann zu dieser Zeit nicht aktualisiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToUpdateAlarmRingerSettings:
    'Die Ruftoneinstellungen können zu dieser Zeit nicht aktualisiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  unableToUpdateAlarmPreReminderDuration:
    'Die Dauer der Vorab-Erinnerung kann zu dieser Zeit nicht aktualisiert werden. Bitte versuchen Sie es in ein paar Minuten erneut.',
  retrievingAlarmsFromServer: 'Abrufen von Alarmen vom Server...',
  startApp: 'Start >',
  phoneNumberRequiredGroupListHeaderText:
    'Die Gruppe ist eine Sammlung von Galarm-Kontakten, mit denen Sie schnell Alarme erstellen können.\n\nBitte registrieren Sie sich mit Ihrer Telefonnummer, um Ihre Kontakte zu finden, die Galarm benutzen. Sie können sie zu Gruppen hinzufügen.',
  phoneNumberRequiredBuddyAlarmHeaderText:
    'Mit Buddy Alarm können Sie Alarme für Freunde und Familienmitglieder einstellen, um sie an Dinge zu erinnern, die sie erledigen müssen.\n\nUm diese und viele andere coole Funktionen der App nutzen zu können, registrieren Sie sich bitte mit Ihrer Telefonnummer.',
  phoneNumberRequiredInstantAlarmHeaderText: `Sofortige Benachrichtigungen können verwendet werden, um einen Kontakt oder eine Gruppe sofort im Notfall oder bei dringenden Aufgaben zu benachrichtigen.

Um diese und viele andere coole Funktionen der App nutzen zu können, registrieren Sie sich bitte mit Ihrer Telefonnummer.`,
  phoneNumberRequiredContactListHeaderText:
    'Kontakte sind Personen, die als Teilnehmer zu Alarmen hinzugefügt werden können.\n\nBitte registrieren Sie sich mit Ihrer Telefonnummer, um Ihre Kontakte, die Galarm verwenden, anzuzeigen. Sie können sie als Teilnehmer zu Ihren Alarmen hinzufügen.',
  phoneNumberRequiredGroupAlarmHeaderText:
    'Der Gruppenalarm kann verwendet werden, um eine Erinnerung für eine Gruppe von Personen einzustellen.\n\nUm diese und viele andere coole Funktionen der App nutzen zu können, registrieren Sie sich bitte mit Ihrer Telefonnummer.',
  phoneNumberRequiredParticipantsHeaderText:
    'Die Teilnehmer fungieren als Sicherungen für diesen Alarm. Sie werden erinnert, wenn Sie den Alarm verpassen.\n\nUm diese und viele andere coole Funktionen der App zu nutzen, registrieren Sie sich bitte mit Ihrer Telefonnummer.',
  youHaveNotRegistered:
    'Ihre Alarme sind derzeit nicht gesichert.\n\nBitte registrieren Sie sich mit Ihrer Telefonnummer. Sobald Sie sich registriert haben, werden Ihre Alarme in der Cloud gesichert. So können Sie Ihre Alarme und andere Einstellungen wiederherstellen, wenn Sie das Telefon wechseln.\n',
  registerNow: 'Jetzt registrieren',
  hoursAndMinutes: 'Stunden und Minuten',
  days: 'Tage',
  weeks: 'Wochen',
  months: 'Monate',
  years: 'Jahre',
  daysOfWeek: 'Wöchentlich (ausgewählte Tage)',
  monthly: 'Monatlich',
  yearly: 'Jährlich',
  everyDay: 'Täglich',
  selectDaysOfWeek: 'Wochentage auswählen',
  alarmRingMessageForSpecificDates:
    'Dieser Alarm klingelt nur in Monaten, die mindestens {{dayOfMonth}} haben. Möchten Sie fortfahren?',
  alarmRingMessageForSpecificYear:
    'Dieser Alarm klingelt nur in Schaltjahren. Möchten Sie fortfahren?',
  alarmRingMessageForSpecificDayOfWeekInMonth:
    'Dieser Alarm klingelt nur in Monaten mit {{weekNumberOfDayInMonth}} {{dayName}} s. Möchten Sie fortfahren? ',
  alarmRepetitionAdjustedBasedOnNewDate:
    'Die Wiederholung des Alarms wurde auf der Grundlage des neuen Datums aktualisiert.',
  inviteFriendsToInstallGalarm:
    'Kontakte sind Personen, die als Teilnehmer zu Ihren Alarmen hinzugefügt werden können. Sie können Kontakte einladen:\n\n1. Aus Ihrem Adressbuch\n\n2. Indem Sie deren Namen und Nummer manuell eingeben.\n\nTippen Sie oben rechts auf „Aktualisieren“, um die Galarm-Kontakte nach ihrer Registrierung neu zu laden.',
  whyCreateNewGroup:
    'Gruppen sind Sammlungen von Kontakten, die als Teilnehmer zu Ihren Alarmen hinzugefügt werden können.\n  \nSie haben keine Gruppen erstellt.',
  noNotifications: 'Sie haben keine neuen Benachrichtigungen.',
  createGroup: 'Gruppe erstellen',
  galarmRequiresAccessToContactsPermission:
    'Galarm bittet um die Erlaubnis, auf Ihre Kontakte zuzugreifen. Diese Informationen werden an seine Server gesendet, um Ihre Kontakte mit Galarm zu identifizieren. Diese Benutzer können als Teilnehmer zu Ihren Alarmen hinzugefügt werden.',
  galarmRequiresAccessToAudioFilesPermission:
    'Bei einigen Alarmen wird Telefonmusik als Klingelton verwendet. Bitte geben Sie die Erlaubnis, auf Audiodateien auf Ihrem Gerät zuzugreifen, um diese Alarme mit dem gewählten Klingelton klingeln zu lassen.',
  galarmRequiresAccessToContactsSelectScreen:
    'Galarm hat keine Berechtigung, auf Kontakte zuzugreifen. Bitte erlauben Sie den Zugriff auf Kontakte, wenn Sie diese Funktion nutzen möchten.',
  allow: 'Erlauben Sie',
  deny: 'Verweigern',
  galarmRequiresAccessToContacts:
    'Kontakte sind Personen, die als Teilnehmer zu Ihren Alarmen hinzugefügt werden können. Sie können Kontakte hinzufügen, indem Sie:\n\n1. Automatisches Importieren aus den Telefonkontakten. Tippen Sie auf "Zugriff zulassen" und aktivieren Sie "Kontakte".\n\n2. Manuelles Hinzufügen des Namens und der Nummer. Tippen Sie auf "Kontakt hinzufügen", um zu beginnen.',
  galarmRequiresAccessToAlarmAndRemindersPermission:
    'Galarm benötigt die Berechtigung "Alarme & Erinnerungen", um Alarme genau zu den angegebenen Zeiten klingeln zu lassen. Bitte aktivieren Sie diese auf dem nächsten Bildschirm.',
  accessToContactsPermissionRequiredAndroid:
    'Galarm hat keine Berechtigung, auf Ihre Telefonkontakte zuzugreifen.\n\nWenn Sie den Zugriff erlauben, werden Personen in Ihren Telefonkontakten, die Galarm verwenden, als Galarm-Kontakte angezeigt. Diese Personen können als Alarm-Teilnehmer hinzugefügt werden. Tippen Sie auf "Zugriff zulassen", wählen Sie "Berechtigung" und aktivieren Sie "Kontakte".\n\nSie können Kontakte immer noch manuell zu Galarm hinzufügen.',
  accessToContactsPermissionRequiredIos:
    'Galarm hat keine Berechtigung, auf Ihre Telefonkontakte zuzugreifen.\n\nWenn Sie den Zugriff erlauben, werden Personen in Ihren Telefonkontakten, die Galarm verwenden, als Galarm-Kontakte angezeigt. Diese Personen können als Alarm-Teilnehmer hinzugefügt werden. Tippen Sie auf "Zugriff zulassen" und aktivieren Sie "Kontakte".\n\nSie können Kontakte immer noch manuell zu Galarm hinzufügen.',
  giveAccess: 'Zugriff zulassen',
  enterValidMobileNumber:
    'Bitte geben Sie eine gültige Telefonnummer ein, um sich zu registrieren.',
  proceedAnyway: 'Trotzdem weitermachen',
  checkInvalidPhoneNumber:
    'Wir glauben, dass Sie eine ungültige Nummer als {{mobileNumber}} eingegeben haben.',
  checkInvalidCountryCode:
    'Der als {{countryCode}} angegebene Ländercode ist ungültig. Wenn mehr als ein Ländercode vorhanden ist, bearbeiten Sie das Feld, um den zutreffenden Ländercode beizubehalten.',
  editNumber: 'Nummer bearbeiten',
  editCountryCode: 'Ländercode bearbeiten',
  sendingCodeOnCall: 'Ich rufe Sie mit dem Code an.',
  sendCodeOnCall: 'Ruf mich an mit dem Code',
  registrationLandingScreenRegisterText:
    'Tippen Sie auf Weiter, um sich mit Ihrer Telefonnummer zu registrieren.\n\nWenn Sie sich registrieren:\n1) Sie können Teilnehmer zu Ihren Alarmen hinzufügen und mit ihnen chatten.\n2) Ihre Alarme werden in der Cloud gesichert, so dass bei einem Telefonwechsel Ihre Alarme auf dem neuen Telefon angezeigt werden.',
  continue: 'Weiter',
  registerLater: 'Überspringen der Registrierung',
  cancelRegistration: 'Registrierung abbrechen',
  welcome: 'Willkommen',
  haventReceivedCodeYet: {
    one: 'Haben Sie den Code noch nicht erhalten? Sie können den Code in 1 Sekunde erneut anfordern.',
    other:
      'Haben Sie den Code noch nicht erhalten? Sie können den Code in {{count}} Sekunden erneut anfordern.'
  },
  storagePermissionDenied:
    'Der Zugriff auf Musikdateien ist nicht möglich, da die Speichererlaubnis verweigert wird.',
  havingTroubleRegisteringMessage:
    'Galarm ist nach mehreren Versuchen nicht in der Lage, den Code zu verifizieren.\n\nMöchten Sie die Registrierung überspringen und die App sofort nutzen?',
  autoDetectVerificationCode:
    'Um die Registrierung zu vereinfachen, kann Galarm den Verifizierungscode automatisch erkennen, wenn Sie Galarm erlauben, SMS-Nachrichten einzusehen.',
  notNow: 'Nicht jetzt',
  verifyNumberText:
    'Wir werden Ihnen eine SMS mit dem Verifizierungscode schicken:\n\n{{formattedMobileNumber}}',
  addToContacts: 'Zu Kontakten hinzufügen',
  todayString: 'Heute',
  tomorrowString: 'Morgen',
  backups: 'Sicherungen',
  acintyoTrademark:
    '© 2026 Acintyo, Inc. Alle Rechte vorbehalten.\nGalarm ist eine eingetragene Marke von Acintyo, Inc.\nGeschützt durch die US-Patente 10382613 und 10867286.\nWeitere Patente sind angemeldet.',
  acintyoTrademarkWeb:
    '© 2026 Acintyo, Inc. Alle Rechte vorbehalten. Galarm ist eine eingetragene Marke von Acintyo, Inc.\nGeschützt durch die US-Patente 10382613 und 10867286. Weitere Patente sind angemeldet.',
  acintyoTrademarkEnterprise: '© 2026 Acintyo, Inc.\nAlle Rechte vorbehalten.',
  markAlarmDone: 'Alarm als Erledigt markieren',
  skipAlarm: 'Überspringen des Alarms',
  confirmGroupAlarm: 'Bestätigen Sie die Teilnahme',
  declineGroupAlarm: 'Ablehnen Teilnahme',
  snoozeAlarm: 'Schlummern Alarm',
  deleteAlarmQuickAction: 'Alarm löschen',
  disableAlarm: 'Alarm deaktivieren',
  confirmDisableAlarm: 'Alarm deaktivieren?',
  saveToCalendar: 'In den Kalender exportieren',
  stillRingGroupAlarmAfterConfirmingInAdvance:
    'Sie bestätigen den Gruppenalarm im Voraus.  Möchten Sie noch die Erinnerung zur Alarmzeit?',
  updateNow: 'Jetzt aktualisieren',
  nParticipants: {
    one: '1 anderer Teilnehmer',
    other: '{{count}} andere Teilnehmer'
  },
  details: 'Einzelheiten',
  changeParanthesis: '(Veränderung)',
  loadMoreHistory: 'Ansicht mehr',
  alarmSummaryForHistory:
    'Frühere Antworten für {{alarmName}}.\nWiederholungen {{alarmRepetitionString}}\n{{previousOccurrencesString}}',
  alarmSummaryForHistoryWeb: 'Frühere Antworten für {{alarmName}}',
  alarmSummaryForHistoryRepetitionWeb:
    'Wiederholungen {{alarmRepetitionString}}',
  dontSeeCompleteHistory: 'Sie sehen die Geschichte nicht vollständig?',
  dontSeeCompleteHistoryExplanation:
    'Der Alarmverlauf wird ab der Zeit aufgezeichnet, in der der Alarm erzeugt wird. Für jeden Alarm wird nur ein begrenzter Zeitraum gespeichert, der von der Wiederholung des Alarms abhängt. Wenn sich der Alarm zum Beispiel jeden Tag wiederholt, wird eine Historie von 30 Tagen gespeichert.\n\nWenn Sie die Zeit des Alarms oder die Wiederholung ändern, wird der Alarmverlauf zurückgesetzt.',
  noActionAvailableForAlarmOccurrence:
    'Für dieses Ereignis sind keine Maßnahmen verfügbar.',
  enterEmailIdForFeedback: 'Zum Beantworten und Teilen von Updates',
  noPreviousOccurrences: 'Noch kein Alarmverlauf',
  nMissedOccurrencesOfAlarmInLastNDays: {
    zero: 'Noch kein Alarmverlauf',
    one: '{{missedAlarmOccurrences}} den letzten Platz verpasst {{count}}',
    other: '{{missedAlarmOccurrences}} den letzten Platz verpasst {{count}}'
  },
  soundAndVibrationSummaryString: {
    zero: '{{volume}}% lautstärke, {{ringtoneName}}',
    one: '{{volume}}% lautstärke, {{ringtoneName}}, Ankündigung Titel'
  },
  soundAndVibrationSummaryStringIos: {
    zero: '{{ringtoneName}}',
    one: 'Kritisch, {{volume}}% Lautstärke, {{ringtoneName}}'
  },
  previousOccurrences: 'Alarm-Verlauf',
  retrieving: 'Abrufen...',
  startTimeOfDay: 'Beginnt bei',
  endTimeOfDay: 'Endet am',
  ringEveryHours: 'Klingelt jeder',
  everyNHours: 'Stündlich',
  everyMHoursNMinutes: 'Stunden und Minuten',
  selectHourlyRepetition: 'Stündliche Wiederholung auswählen',
  everyNHoursRepetitionString: {
    one: 'Jede Stunde von {{startTimeString}} bis {{endTimeString}} jede {{daysString}}',
    other:
      'Alle {{count}} Stunden von {{startTimeString}} bis {{endTimeString}} alle {{daysString}}'
  },
  everyNHoursAndMinutesRepetitionString:
    'Jede {{hoursAndMinutes}} von {{startTimeString}} bis {{endTimeString}} jede {{daysString}}',
  everyMHoursAndNMinutesRepetitionString: 'Alle {{repeatString}}',
  everyNHoursRepetitionStringForCalendar: {
    one: 'Jede Stunde von {{startTimeString}} bis {{endTimeString}}',
    other:
      'Alle {{count}} Stunden von {{startTimeString}} bis {{endTimeString}}'
  },
  everyNHoursAndMinutesRepetitionStringForCalendar:
    'Jede {{hoursAndMinutes}} von {{startTimeString}} bis {{endTimeString}}',
  everyNHoursAndMinutesRepetitionStringForAlarmSummary:
    'Alle {{hoursAndMinutes}} bis {{endTimeString}}',
  everyNHoursRepetitionStringForAlarmSummary: {
    one: 'Jede Stunde bis {{endTimeString}}',
    other: 'Alle {{count}} Stunden bis {{endTimeString}}'
  },
  daysRepetitionOddString: {
    other: 'Alle ungerade nummerierten Daten',
    one: 'Ungerade nummerierte Daten ({{daysString}})'
  },
  daysRepetitionEvenString: {
    other: 'Alle geradzahligen Daten',
    one: 'Geradzahlige Daten ({{daysString}})'
  },
  oddNumberedRepetitionPreviewString: {
    one: 'Der Alarm klingelt an ungeraden Daten, die auf {{daysString}} fallen, zur angegebenen Zeit.',
    other: 'Der Alarm klingelt an allen ungeraden Daten zur angegebenen Zeit.'
  },
  evenNumberedRepetitionPreviewString: {
    one: 'Der Alarm klingelt an geradzahligen Daten, die auf {{daysString}} fallen, zur angegebenen Zeit.',
    other: 'Der Alarm klingelt an allen geraden Daten zur angegebenen Zeit.'
  },
  hourlyRepetitionPreviewString: {
    one: 'Dieser Alarm klingelt einmal pro {{daysString}} um:',
    other: 'Dieser Alarm klingelt {{count}} mal alle {{daysString}} an:'
  },
  daysRepetitionPreviewString: {
    one: 'Dieser Alarm wird jeden Tag klingeln.',
    other: 'Dieser Alarm klingelt alle {{count}} Tage.'
  },
  weeksRepetitionPreviewString: {
    one: 'Der Alarm klingelt jede Woche am „{{daysString}}” (Tag der Rasse).',
    other: 'Der Alarm klingelt alle {{count}} Wochen auf {{daysString}}.'
  },
  weeksRepetitionPreviewStringEveryDay: {
    one: 'Der alarm wird jeden Tag klingeln.',
    other: 'Der alarm klingelt jeden Tag alle {{count}} Wochen.'
  },
  specifyNumberOfWeeksAndChooseDays:
    'Geben Sie die Anzahl der Wochen an und wählen Sie die Tage für die Wiederholung aus.',
  everyNDays: {
    one: 'Jeden Tag',
    other: 'Alle {{count}} Tage'
  },
  everyNWeeks: {
    one: 'Jede Woche „{{daysString}}“',
    other: 'Alle {{count}} Wochen {{daysString}}'
  },
  everyNMonths: {
    one: 'Jeden Monat',
    other: 'Alle {{count}} Monate'
  },
  everyNYears: {
    one: 'Jedes Jahr',
    other: 'Alle {{count}} Jahre'
  },
  cantSetEndTime: 'Endzeit kann nicht eingestellt werden',
  endTimeShouldBeGreater: 'Die Endzeit sollte größer als die Startzeit sein.',
  cantSetStartTime: 'Startzeit kann nicht eingestellt werden',
  startTimeShouldBeLess: 'Die Startzeit sollte kürzer sein als die Endzeit.',
  everyDaySmall: 'Tag',
  everyGivenDay: '{{day}}',
  everyGivenDays: '{{days}}',
  adjustingAlarmsAfterTimezoneChange:
    'Wir haben festgestellt, dass Sie in eine andere Zeitzone umgezogen sind. Wir passen Ihre Alarme an.',
  ringOnDays: 'Klingelt an',
  yourAlarmsMayNotRing: 'Ihre Alarme dürfen nicht klingeln',
  yourAlarmsMayNotRingTapToFix:
    'Ihre Alarme klingeln möglicherweise nicht. Tippen Sie auf , um dies zu beheben.',
  unsyncedAlarmsWarning:
    'Einige Alarme wurden nicht mit dem Server synchronisiert. Verbinden Sie sich mit dem Internet und tippen Sie, um sie jetzt zu speichern.',
  pendingActionFailed:
    'Eine Alarmänderung ({{actionName}}) konnte nach mehreren Versuchen nicht gespeichert werden und wurde verworfen. Bitte überprüfen Sie Ihre Alarme oder kontaktieren Sie den Support, wenn Daten fehlen.',
  pendingActionFailedWithRef:
    'Eine Alarmänderung ({{actionName}}) konnte nach mehreren Versuchen nicht gespeichert werden und wurde verworfen. Referenz-ID: {{referenceId}}. Kontaktieren Sie den Support mit dieser ID, um bei der Wiederherstellung zu helfen.',
  xiaomiSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und erlauben Sie "Galarm", damit Ihre Alarme immer klingeln. \n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-mi',
  oppoSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und aktivieren Sie "Automatisches Starten zulassen".\n\n - Tippen Sie auf die Schaltfläche "Letzte Apps" auf Ihrem Telefon, wischen Sie das Symbol der Galarm-App nach unten und tippen Sie auf "Sperren".  \n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-oppo.',
  oppo8AndLowerSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und aktivieren Sie "Automatisches Starten zulassen".\n\n - Tippen Sie auf die Schaltfläche "Letzte Apps" auf Ihrem Telefon, wischen Sie das Symbol der Galarm-App nach unten und tippen Sie auf "Sperren".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-oppo-8-and-lower.',
  vivo9And10SetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und erlauben Sie "Galarm".\n\n - Tippen Sie auf "Batterienutzung", wählen Sie "Hoher Stromverbrauch im Hintergrund" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-vivo',
  vivo11SetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n- Tippen Sie auf "Autostart aktivieren" und erlauben Sie "Galarm".\n\n- Tippen Sie auf "Batterienutzung", wählen Sie "Hoher Stromverbrauch im Hintergrund" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-vivo-11',
  vivoSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n- Öffnen Sie "Telefoneinstellungen > Apps > Spezieller App-Zugriff > Autostart" und aktivieren Sie den Autostart für Galarm.\n\n- Öffnen Sie "Telefoneinstellungen > Akku > Verwaltung des Stromverbrauchs im Hintergrund > Galarm" und wählen Sie "Stromverbrauch im Hintergrund nicht einschränken".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-vivo-12-and-above.',
  vivo8AndLowerSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und erlauben Sie "Galarm".\n\n - Tippen Sie auf "Batterienutzung", wählen Sie "Hoher Stromverbrauch im Hintergrund" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-vivo-8-and-lower',
  huawei7AndLowerAdditionalSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Geschützte Apps" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-huawei-7-and-lower',
  huaweiAdditionalSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "App-Start verwalten" und schalten Sie "Galarm" auf "Manuell verwalten". Stellen Sie in der folgenden Eingabeaufforderung sicher, dass "Automatisch starten" und "Im Hintergrund ausführen" aktiviert sind.\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-huawei.',
  meizuSetupInstructions:
    'Befolgen Sie die Anweisungen unter dem folgenden Link, damit Ihre Alarme immer klingeln: https://dontkillmyapp.com/meizu',
  asusSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und klicken Sie auf "Autostart-Manager". Aktivieren Sie "Galarm" im "Autostart-Manager".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-asus.',
  nokia8AndLowerAdditionalSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Autostart aktivieren" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-nokia-8-and-lower',
  nokiaAdditionalSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Eingeschränkte Apps" und deaktivieren Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-nokia',
  lenovoSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf die Schaltfläche "Letzte Apps" auf Ihrem Telefon, suchen Sie die Galarm-App und tippen Sie auf das Symbol "Sperren" in der oberen rechten Ecke.\n  \nUm mehr zu erfahren, besuchen Sie https://dontkillmyapp.com/lenovo',
  samsungAdditionalSetupInstructions:
    'Befolgen Sie diese Anweisungen, damit Ihre Alarme immer klingeln:\n\n - Tippen Sie auf "Unüberwachte Apps" und erlauben Sie "Galarm".\n\nUm mehr zu erfahren, besuchen Sie www.galarmapp.com/setup-samsung',
  tecnoSetupInstructions:
    'Befolgen Sie die Anweisungen unter dem folgenden Link, damit Ihre Alarme immer klingeln: https://www.galarmapp.com/setup-tecno',
  infinixSetupInstructions:
    'Befolgen Sie die Anweisungen unter dem folgenden Link, damit Ihre Alarme immer klingeln: https://www.galarmapp.com/setup-infinix',
  samsungAdditionalSetupInstructionsAndroid11AndAbove:
    'Standardmäßig zeigt Samsung "kurze" Benachrichtigungen an, die schnell wieder verschwinden. Befolgen Sie diese Anweisungen, um "detaillierte" alarm-Benachrichtigungen anzuzeigen.\n\n - Öffnen Sie die Telefoneinstellungen und wählen Sie "Benachrichtigungen".\n - Wählen Sie den Stil "Ausführliche" Benachrichtigungen\n  \nWeitere Informationen finden Sie unter www.galarmapp.com/setup-samsung-android11-and-above.',
  iosSetupInstructions:
    'Standardmäßig ist der iOS-Bannerstil für Benachrichtigungen auf "Temporär" eingestellt, wodurch die Benachrichtigungen schnell verschwinden. Befolgen Sie diese Anweisungen, um den Bannerstil auf "Dauerhaft" einzustellen.\n\n- Öffnen Sie die Telefoneinstellungen und blättern Sie zu Galarm\n- Wählen Sie "Benachrichtigungen" und stellen Sie den Banner-Stil auf "Dauerhaft" ein.\n\nWeitere Informationen finden Sie unter www.galarmapp.com/setup-ios.',
  iosSetupInstructions15AndBelow:
    'Standardmäßig ist der iOS-Bannerstil für Benachrichtigungen auf "Temporär" eingestellt, wodurch die Benachrichtigungen schnell verschwinden. Befolgen Sie diese Anweisungen, um den Bannerstil auf "Dauerhaft" einzustellen.\n\n- Öffnen Sie die Telefoneinstellungen und blättern Sie zu Galarm\n- Wählen Sie "Benachrichtigungen" und stellen Sie den Banner-Stil auf "Dauerhaft" ein.\n\nWeitere Informationen finden Sie unter www.galarmapp.com/setup-ios-15-below.',
  setNotificationsStyle: 'Stil der Benachrichtigungen einstellen',
  setNotificationsStyleToDetailed:
    'Stil der Benachrichtigungen auf "Detailliert" einstellen',
  setBannerStyle: 'Banner-Stil einstellen',
  setBannerStyleToPersistent: 'Banner-Stil auf "Dauerhaft" einstellen',
  selectAtleastOneDay:
    'Wählen Sie die Tage aus, an denen der Alarm klingeln soll.',
  selectAtLeastOneHourOrMinute:
    'Entweder Stunden oder Minuten sollten ein Wert ungleich Null sein',
  hourlyAlarmDefaultStartTimeSetAlert:
    'Die Startzeit des Alarms wurde auf 8 Uhr morgens eingestellt.',
  batteryUsage: 'Verwendung der Batterie',
  dontShowAgain: 'Nicht wieder auftauchen',
  alarmWillRingEveryHourTillSeen:
    'Der Alarm wird jede Stunde schlummern, bis Sie etwas unternehmen.',
  unknown: 'Unbekannt',
  alarmMarkedDone: '{{name}} hat den Alarm als "Erledigt" markiert.',
  alarmMarkedSkipped: '{{name}} hat den Alarm übersprungen.',
  alarmIsMarkedDone: '{{alarmName}} wird als Erledigt markiert.',
  alarmIsSkipped: '{{alarmName}} wird übersprungen.',
  alarmIsConfirmed: '{{alarmName}} wird bestätigt.',
  alarmIsDeclined: '{{alarmName}} wird abgelehnt.',
  alarmIsSnoozed: '{{alarmName}} wird geschlummert.',
  alarmIsAccepted: '{{alarmName}} wird akzeptiert.',
  alarmIsRejected: '{{alarmName}} wird abgelehnt.',
  dismissingCalendarEvent: 'Kalenderereignis für „{{title}}” ignorieren',
  newContactInfo:
    'Bitte geben Sie den Namen und die Telefonnummer des Kontakts an.\n\nNur registrierte Benutzer können als Kontakte hinzugefügt werden. Wenn der Benutzer kein registrierter Galarm-Benutzer ist, können Sie ihn über "Einstellungen > Diese App teilen" einladen. Sie können ihn als Kontakt hinzufügen, nachdem er sich mit seiner Telefonnummer registriert hat. ',
  cantEditContactMobileNumber:
    'Sie können die Rufnummer nicht bearbeiten. Löschen Sie den Kontakt und fügen Sie ihn erneut hinzu, wenn Sie die Nummer ändern möchten.',
  phoneContactsNotSyncedPermissionDenied:
    'Galarm hat keine Berechtigung, auf Telefonkontakte zuzugreifen. Telefonkontakte werden nicht synchronisiert.',
  inviteContactMessage:
    'Hallo {{contactName}}, ich möchte Sie in meine Alarme und Erinnerungen mit Galarm aufnehmen. Laden Sie die App von {{downloadLink}} herunter. Bitte registrieren Sie sich mit dieser Nummer und beginnen Sie mit dem Austausch von Alarmen.',
  noRepeat: 'Wiederholt sich nicht',
  deepLinkNoLongerValidTitle: 'Huch!',
  deepLinkNoLongerValidMessage:
    'Alarm wurde nicht erstellt. Möglicherweise handelt es sich um eine alte oder ungültige Verknüpfung.',
  inviteContact: 'Kontakt einladen',
  fromPhoneBook: 'Aus dem Adressbuch',
  addFromPhoneBook: 'Aus Adressbuch einladen',
  manually: 'Manuell',
  addManualContact: 'Manuell einladen',
  noOtherContactsFound: 'Alle Kontakte in Ihrem Adressbuch verwenden Galarm.',
  cantAddPhoneContactPermissionDenied:
    'Galarm hat keine Berechtigung, auf Telefonkontakte zuzugreifen. Erlauben Sie den Zugriff auf Kontakte.',
  alarmWillRingWithRandomRingtone:
    'Es wird ein zufälliger Klingelton für den Alarm gewählt.',
  alarmWillRingWithRandomRingtoneGlobal:
    'Bei Alarmen wird ein zufälliger Klingelton gewählt.',
  createdAlarmFromDeepLinkTitle: 'Sie sind bereit!',
  createdAlarmFromDeepLinkMessage:
    'Sie werden unter {{alarmTime}} an "{{alarmName}}" erinnert. {{alarmDate}}',
  createdRepeatingAlarmFromDeepLinkMessage: {
    zero: 'Sie werden an "{{alarmName}}" erinnert. {{repetitionString}}',
    one: 'Unter {{alarmTime}} werden Sie an "{{alarmName}}" {{repetitionString}} erinnert. {{alarmDate}}'
  },
  deleteCategoryAlertTitle: 'Kategorie löschen?',
  deleteCategoryAlertMessage: {
    zero: '',
    one: '1 Alarm gehört zu dieser Kategorie. Wenn Sie diese Kategorie löschen, wird die Kategorie für diesen Alarm zurückgesetzt.',
    other:
      '{{count}} Alarme gehören zu dieser Kategorie. Wenn Sie diese Kategorie löschen, wird die Kategorie für diese Alarme zurückgesetzt.'
  },
  updateReadyToInstallAlertTitle: 'Update installieren?',
  updateReadyToInstallAlertMessage:
    'Die Updates können jetzt installiert werden. Möchten Sie das Update jetzt installieren? ',
  hideCategoryAlertTitle: 'Kategorie ausblenden?',
  hideCategoryAlertMessage: {
    zero: 'Sie werden diese Kategorie in Zukunft nicht mehr verwenden können.',
    one: '1 Alarm gehört zu dieser Kategorie. Wenn Sie diese Kategorie ausblenden, wird die Kategorie für diesen Alarm zurückgesetzt.\n  \nSie können diese Kategorie in Zukunft nicht mehr verwenden.',
    other:
      '{{count}} Alarme gehören zu dieser Kategorie. Wenn Sie diese Kategorie ausblenden, wird die Kategorie für diese Alarme zurückgesetzt.\n  \nSie können diese Kategorie in Zukunft nicht mehr verwenden.'
  },
  alarmCategoryDeleteAllAlarmsPrompt: {
    one: '1 Alarm gehört zu dieser Kategorie. Möchten Sie ihn löschen?\n\nBeachten Sie, dass Alarme von Teilnehmern nicht gelöscht werden.',
    other:
      '{{count}} Alarme gehören zu dieser Kategorie. Möchten Sie sie löschen?\n\nBeachten Sie, dass die Alarme der Teilnehmer nicht gelöscht werden.'
  },
  enterNameForGroup: 'Geben Sie einen Namen für die Gruppe ein',
  enterMobileNumber: 'Geben Sie Ihre Rufnummer ein',
  enterNotesForAlarm: 'Notizen zum Alarm eingeben',
  enterUserName: 'Geben Sie Ihren Namen ein',
  enterEmailId: 'Optional',
  enterFeedback: 'Wie können wir uns verbessern?',
  describeProblem: 'Beschreiben Sie Ihr Problem',
  invited: 'Eingeladen',
  resend: 'Erneut senden',
  addContact: 'Kontakt hinzufügen',
  inviteAgain: 'Erneut einladen',
  contactNotRegistered:
    '{{contactName}} Galarm noch nicht installiert hat. Sie können sie zu Alarmen hinzufügen, sobald sie installiert und mit ihrer Telefonnummer registriert sind.',
  registration: 'Anmeldung',
  verify: 'Überprüfung',
  profile: 'Profil',
  profileImage: 'Profilbild',
  addProfileImage: 'Profilbild hinzufügen',
  groupDetails: 'Details zur Gruppe',
  newGroup: 'Neue gruppe',
  uploadImage: 'Bild ändern',
  selectParticipants: 'Teilnehmer auswählen',
  selectMembers: 'Mitglieder auswählen',
  selectTimezone: 'Zeitzone auswählen',
  searchForATimezone: 'Suche nach einer Zeitzone',
  timezone: 'Zeit Zone',
  deviceTimezone: 'Gerät Zeitzone',
  useDeviceTimezone: 'Gerätezeitzone verwenden',
  specifyTimezoneForAlarm: 'Festlegen der Zeitzone für Alarme',
  editName: 'Name bearbeiten',
  groupImage: 'Gruppe Bild',
  addGroupImage: 'Gruppenbild hinzufügen',
  selectAlarmType: 'Erstellen eines Alarms für',
  contactDetails: 'Kontakt Details',
  commonAlarms: 'Alarme',
  commonGroups: 'Gruppen',
  groupAlarmsTitle: 'Alarme',
  selectRingtone: 'Klingelton auswählen',
  selectMusic: 'Musik auswählen',
  select: 'Wählen Sie',
  personalAlarm: 'Persönlicher Alarm',
  groupAlarm: 'Gruppe Alarm',
  newPersonalAlarm: 'Neuer persönlicher Alarm',
  newGroupAlarm: 'Neue Gruppe Alarm',
  editPersonalAlarm: 'Persönlichen Alarm bearbeiten',
  editTaskAlarm: 'Alarm bearbeiten',
  editGroupAlarm: 'Gruppe bearbeiten Alarm',
  rearrangeParticipants: 'Teilnehmer neu anordnen',
  alarmConversation: 'Alarm Chat',
  deviceRestartRequired: 'App-Neustart erforderlich',
  disabledAlarm: 'Deaktivierter Alarm {{name}}',
  newContact: 'Neuer Kontakt',
  contactName: 'Kontakt Name',
  contactMobileNumber: 'Kontakt Telefonnummer',
  enterNameForContact: 'Name des Kontakts eingeben',
  pickCountryForContact: 'Land des Kontaktes',
  enterMobileNumberForContact: 'Rufnummer des Kontakts eingeben',
  specifyNameForContact: 'Name des Kontakts ist erforderlich',
  specifyValidPhoneNumberForContact:
    'Eine gültige Telefonnummer ist erforderlich',
  addingContact: 'Hinzufügen eines Kontakts',
  deletingContact: 'Entfernen des Kontakts',
  editingContact: 'Redaktioneller Kontakt',
  pending: 'Anhängig',
  deleteContact: 'Kontakt entfernen',
  galarmContact: 'Manuell hinzugefügt',
  phoneContact: 'Aus Telefonkontakten hinzugefügt',
  confirmDeleteContactTitle: '{{name}} entfernen?',
  confirmDeleteContact: 'Sie können sie nicht zu Ihren Alarmen hinzufügen.',
  contactAdded:
    'Großartig! Jetzt können Sie {{name}} als Teilnehmer zu Ihren Alarmen hinzufügen.',
  contactInvited:
    'Eine Textnachricht wurde an {{name}} gesandt, in der sie zur Nutzung von Galarm aufgefordert werden.',
  changeSnoozeDuration: 'Veränderung Dauer',
  durationOfEvent: 'Dauer des Ereignisses',
  upgradeToPremium: 'Aktualisierung auf Premium',
  premium: 'Prämie',
  alarmLimitReached: 'Alarmgrenze erreicht',
  unableToConnectToGooglePlay:
    'Verbindung zu Google Play kann nicht hergestellt werden. Stellen Sie sicher, dass Sie bei Ihrem Google-Konto angemeldet sind.',
  cantLoadVideo: 'Video kann nicht geladen werden',
  cantUpgradeToPremium: 'Keine Aktualisierung auf Premium möglich',
  unableToConnectToIapAndroid:
    'Die Verbindung zum Play Store kann nicht hergestellt werden. Bitte öffnen Sie die Play Store-App und vergewissern Sie sich, dass Sie eingeloggt sind.',
  unableToConnectToIapIos:
    'Die Verbindung zum App Store kann nicht hergestellt werden. Bitte öffnen Sie die App Store App und vergewissern Sie sich, dass Sie eingeloggt sind.',
  premiumFeaturesIos:
    'Als Premium-Nutzer erhalten Sie ein erhöhtes Limit von {{maxLimit}} gleichzeitigen Alarmen.\n\nIhr Kauf hilft uns außerdem, weitere Funktionen zu entwickeln.',
  premiumFeaturesAndroid:
    'Erstellen Sie unbegrenzte Alarme durch eine Aktualisierung auf premium.\n\nIhr Kauf hilft uns auch bei der Entwicklung weiterer Funktionen.',
  upgrade: 'Aktualisierung',
  rvInternalError:
    'Wir konnten das Video aufgrund eines internen Fehlers nicht laden. Wir haben jedoch Ihre Alarmgrenze um 1 erhöht.',
  rvNetworkError:
    'Bitte stellen Sie sicher, dass Sie eine gute Internetverbindung haben und versuchen Sie es erneut.',
  rvNotFoundError:
    'Wir konnten zu dieser Zeit kein passendes Video finden. Wir haben jedoch Ihre Alarmgrenze um 1 erhöht.',
  dontRemindMe: 'Erinnern Sie mich nicht daran',
  sameTimeAsBuddy: 'Zur gleichen Zeit wie mein Freund',
  noAlertForBuddyAlarm:
    'Sie haben sich dafür entschieden, bei diesem Alarm nicht alarmiert zu werden.',
  noAlertRecipientIntervalDescription: 'Sie werden nicht gewarnt.',
  chooseHours: 'Stunden wählen',
  chooseMins: 'Minuten wählen',
  changeHours: 'Stunden ändern',
  moreOptions: 'Mehr Optionen...',
  set: 'Einstellen',
  chooseNumberOfDays: 'Anzahl der Tage eingeben',
  chooseNumberOfWeeks: 'Anzahl der Wochen eingeben',
  numberOfDaysShouldBeAtLeastOne:
    'Die Anzahl der Tage sollte mindestens 1 betragen.',
  numberOfWeeksShouldBeAtLeastOne:
    'Die Anzahl der Wochen sollte mindestens 1 betragen.',
  numberOfMonthsShouldBeAtLeastOne:
    'Die Anzahl der Monate sollte mindestens 1 betragen.',
  numberOfYearsShouldBeAtLeastOne:
    'Die Anzahl der Jahre sollte mindestens 1 betragen.',
  frequency: 'Frequenz',
  configuration: 'Konfiguration',
  endDate: 'Datum des Alarmendes',
  noEndDate: 'Kein Enddatum',
  alarmEndDateSetOnAlarm:
    'Das Datum für das Ende des Alarms ist auf {{endDateString}} eingestellt.',
  noAlarmDateSetForAlarm: 'Für diesen Alarm ist kein Enddatum eingestellt.',
  noOccurrenceForThisAlarmAsPerEndDate:
    'Das Datum des Endes lässt kein Auftreten des Alarms zu.',
  alarmDateShouldBeBiggerThanAlarmStartDate:
    'Das Datum für das Ende des Alarms sollte nach dem Datum für den Beginn des Alarms liegen.',
  aWeek: 'Eine Woche',
  aMonth: 'Ein Monat',
  allInactiveAlarms: 'Alle inaktiven Alarme',
  chooseAlarmEndDate: 'Wählen Sie das Datum für das Ende des Alarms',
  next: 'Nächstes',
  next7Days: '7 Tage ab heute',
  next30Days: '30 Tage ab heute',
  next12Months: '12 Monate ab heute',
  next10Years: '10 Jahre ab heute',
  chooseDate: 'Wählen Sie ein Datum...',
  learnMore: 'Mehr erfahren',
  repeatEvery: 'Wiederholt sich alle',
  repeatEveryDays: 'Tag(e)',
  repeatEveryWeeks: 'Woche(n)',
  repeatEveryMonths: 'Monat(e)',
  repeatEveryYears: 'Jahr(e)',
  repeatOnce: 'Einmal wiederholen',
  repeatEveryDay: 'Täglich wiederholen',
  repeatEveryWeek: 'Wöchentlich wiederholen',
  repeatEveryMonth: 'Monatlich wiederholen',
  repeatEveryYear: 'Jährlich wiederholen',
  selectRepeatOption: 'Wiederholungsoption auswählen',
  autoSnooze: 'Alarme automatisch schlummern lassen',
  autoSnoozePerAlarm: 'Automatisches Schlummern des Alarms',
  unableToUploadGroupAvatar:
    'Das Gruppenbild kann nicht hochgeladen werden. Bitte versuchen Sie es später noch einmal',
  addNewMembersToExistingAlarms:
    'Bei dieser Gruppe gibt es die folgenden Alarme:\n\n{{alarmNames}}\n    \nMöchten Sie die neuen Mitglieder zu diesen Alarmen hinzufügen?',
  removeGroupMemberAlert:
    'Das Entfernen des Mitglieds hat Auswirkungen auf die folgenden Alarme:\n\n{{alarmNames}}\n\nMöchten Sie das Mitglied immer noch entfernen?',
  leaveGroupAlert:
    'Das Verlassen der Gruppe hat Auswirkungen auf die folgenden Alarme:\n\n{{alarmNames}}\n\nWollen Sie die Gruppe immer noch verlassen?',
  updateAppAfterFeedback:
    'Wir haben festgestellt, dass Sie eine ältere Version der App verwenden. Bitte aktualisieren Sie diese für ein besseres Erlebnis.',
  changesAreLost:
    'Sie haben ungespeicherte Änderungen.\n\nMöchten Sie vor der Abreise speichern?',
  recipientAlarmIntervalGreaterThanRepetitionInterval:
    '"Das Intervall für die Erinnerung sollte kürzer sein als das Wiederholungsintervall.',
  cascadingAlarmIntervalGreaterThanRepetitionInterval:
    'Das Intervall "Zeit zwischen den Warnungen der Teilnehmer" sollte kleiner sein als das Wiederholungsintervall.',
  subscriptionCanceled:
    'Ihr Premium-Abonnement wurde abgebrochen. Die Premium-Funktionen sind erst wieder verfügbar, wenn Sie Ihr Abonnement erneuern.',
  unableToRenewSubscription:
    'Bei der Verlängerung Ihres Premium-Abonnements ist ein Problem aufgetreten. Bitte vergewissern Sie sich, dass Ihre Zahlungsinformationen aktuell sind.',
  notice: 'Hinweis',
  ringerSettingsWillApplyToNewAlarms:
    'Änderungen, die Sie an den Einstellungen für Klänge und Vibrationen vornehmen, gelten nur für neue Alarme.\n\nBei bestehenden Alarmen können Sie den Alarm bearbeiten, um seine Einstellungen für Klang und Vibration zu ändern.',
  renew: 'Erneuern Sie',
  galarmPremium: 'Galarm Premium',
  payMonthly: 'Monatliche Zahlung unter {{price}} pro Monat',
  payYearly: 'Jährliche Zahlung unter {{price}} pro Jahr',
  free: 'Kostenlos',
  unlimited: 'Unbegrenzt',
  personalAlarms: 'Persönliche Alarme',
  groupAlarms: 'Gruppen Alarme',
  buddyAlarms: 'Freunde Alarme',
  alarmRepetitions: 'Wiederholungen',
  ringtones: 'Klingeltöne',
  alarmHistory: 'Alarm-Verlauf',
  base: 'Grundlegend',
  advanced: 'Fortgeschrittene',
  complete: 'Vollständig',
  alarmHistoryFree: 'Begrenzt',
  phoneMusicAsRingtone: 'Telefonmusik als Klingelton',
  startFreeTrial: '14-tägige kostenlose Testversion starten',
  chargedAtEndOfFreeTrial:
    'Nach Ablauf der 14-tägigen kostenlosen Testphase werden Ihnen die Kosten in Rechnung gestellt, sofern Sie Ihr Abonnement nicht abbrechen.',
  monthlySubscription: 'Monatlich',
  yearlySubscription: 'Jährlich',
  premiumRingtoneRequiresUpgrade:
    'Für diesen Klingelton ist ein Premium-Abonnement erforderlich.',
  defaultPremiumFeaturesDescription:
    'Aktualisieren Sie auf Premium, um diese coolen Funktionen zu aktivieren.',
  groupAlarmsPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr als 1 Gruppenalarm zu erstellen.',
  instantAlarmsPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr als 5 sofortige Alarme zu erstellen.',
  buddyAlarmsPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr als 1 Alarm für eine andere Person ("Freund") zu erstellen.',
  shareableAlarmLinksPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr teilbare Alarm-Links zu erstellen.',
  alarmCategoryPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um neue Kategorien zu erstellen.',
  galarmWebMovedToToolsTab:
    'Galarm Web wurde in den Tab Werkzeuge verschoben. Es wird in einer zukünftigen Version aus den Einstellungen entfernt.',
  linkedAccountsMovedToToolsTab:
    'Verknüpfte Kalender wurden in den Tab Werkzeuge verschoben. Sie werden in einer zukünftigen Version aus den Einstellungen entfernt.',
  galarmWebPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um Galarm in einem Webbrowser zu verwenden.',
  personalAlarmsFeatureDescription:
    'Verwenden Sie einen persönlichen Alarm für das Aufwachen, die Einnahme von Medikamenten oder jede andere Aufgabe für sich selbst. Sie können optional Teilnehmer hinzufügen, die benachrichtigt werden, wenn Sie einen Alarm verpassen, damit sie Sie erinneren können. Die Teilnehmer werden auch benachrichtigt, wenn Sie den Alarm als erledigt markieren.',
  groupAlarmsFeatureDescription:
    'Verwenden Sie einen Gruppenalarm für Gruppenaktivitäten wie Ausflüge, Partys oder andere Veranstaltungen. Der Alarm ertönt zur gleichen Zeit für alle Teilnehmer und sie können ihre Teilnahme bestätigen.',
  instantAlarmsFeatureDescription:
    'Verwenden Sie diesen Alarm, um einen Kontakt oder eine Gruppe von Kontakten über eine Notfallübung, den Beginn eines Spiels, eine dringende Aufgabe/Besprechung und andere Ereignisse zu informieren, die sofortige Aufmerksamkeit erfordern.',
  buddyAlarmsFeatureDescription:
    'Erstellen Sie Alarme für eine andere Person ("Freund"), um sie an Dinge zu erinnern, die sie erledigen muss. Sie werden benachrichtigt, um den Freund zu erinnern, falls er den Alarm verpasst. Sie werden auch benachrichtigt, wenn der Freund den Alarm als erledigt markiert.',
  alarmRepetitionsFeatureDescription:
    'Erstellen Sie Alarme mit erweiterten Wiederholungen, z. B. alle 30 Minuten, alle 2 Stunden und 45 Minuten, jeden zweiten Tag, zweiwöchentlich und viele mehr.',
  ringtonesFeatureDescription:
    'Wählen Sie aus einer Vielzahl von Premium-Klingeltönen für Ihre Alarme. Wir fügen dem Premium-Angebot laufend weitere Klingeltöne hinzu.',
  phoneMusicAsRingtoneFeatureDescription:
    'Wählen Sie einen beliebigen Song/Musik auf Ihrem Telefon als Alarm-Klingelton.',
  shareableAlarmLinksFeatureDescription:
    'Sie können Alarme über einen Link mit anderen teilen.\n\nEin Lehrer kann zum Beispiel den Link zu seinem Klassenalarm per E-Mail, WhatsApp oder einer anderen Nachrichten-App mit den Schülern teilen. Wenn die Schüler auf den Link tippen, wird eine Kopie des Klassenalarms auf ihren Telefonen erstellt. Alle Schüler werden zur angegebenen Zeit alarmiert, damit sie sich der Klasse anschließen können.',
  instantAlarmFeatureDescription:
    'Alarmieren Sie eine Gruppe von Personen mit einem einzigen Mausklick.\n\nVerwenden Sie diesen Alarm, um sie auf eine Notfallübung, den Beginn eines Spiels, eine dringende Aufgabe/Besprechung und andere Ereignisse aufmerksam zu machen, die sofortige Aufmerksamkeit erfordern.',
  alarmHistoryFeatureDescription:
    'Sehen Sie alle vergangenen Antworten für jeden wiederholten Alarm an. So können Sie leicht herausfinden, wann Sie den Sportunterricht verpasst haben, wann Ihre Mutter ihre Medikamente vergessen hat usw.',
  announceAlarmTitleFeatureDescription:
    'Ansage des Alarms beim Klingeln des Alarms.',
  exportToCalendarPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr Alarme in den Kalender zu exportieren.',
  exportToCalendarFeatureDescription:
    'Sie können Alarme in Ihren Kalender exportieren. So können Sie Ihre Alarme einfach im Kalender Ihres Geräts anzeigen und Ihre Verfügbarkeit besser widerspiegeln.',
  galarmWebFeatureDescription:
    'Verwenden Sie Galarm in einem Webbrowser, um Alarme zu erstellen, zu bearbeiten und zu löschen.',
  preReminderFeatureDescription:
    'Stellen Sie Vorab-Erinnerungen ein, um vor bevorstehenden Alarmen gewarnt zu werden. Sie können die relative Dauer konfigurieren, um vor der eigentlichen Zeit des Alarms benachrichtigt zu werden, z. B. 30 Minuten vorher, 1 Tag vorher usw.',
  autoSnoozeCountUpgradeTitle:
    'Das Festlegen einer Schlummeranzahl von mehr als 2 erfordert ein Premium-Abonnement',
  higherAutoSnoozeCountPerAlarm:
    'Sie können eine höhere Schlummeranzahl pro Alarm einstellen. Bearbeiten Sie die Einstellungen "Ton und Vibration" beim Erstellen oder Bearbeiten eines Alarms.',
  calendarViewFeatureDescription:
    'Ansicht der Alarme in einem Kalender, um die Alarme für jeden Tag zu sehen.',
  updatePhoneNumberFeatureDescription:
    'Sie können Ihre für dieses Konto verwendete Telefonnummer ändern. Alle Ihre Alarme, Kontakte, Gruppen und andere Einstellungen werden auf die neue Telefonnummer übertragen.',
  alarmPhotoFeatureDescription:
    'Fügen Sie einem Alarm ein Foto für schnelle visuelle Hinweise hinzu, z. B. ein Foto von einem Medikament, Anweisungen für eine Aufgabe, einem Gegenstand usw. Das Foto wird angezeigt, wenn der Alarm klingelt.',
  taskListFeatureDescription:
    'Erstellen Sie Aufgabenlisten, um zusammengehörige Aufgaben zusammenzuhalten.',
  taskAlarmPremiumFeature: 'Aufgaben-Alarme',
  taskAlarmFeatureDescription:
    'Stellen Sie Alarme für einzelne Aufgaben oder ganze Aufgabenlisten ein, um zum richtigen Zeitpunkt erinnert zu werden.',
  calendarViewPremiumFeature: 'Ansicht des Kalenders',
  updatePhoneNumberPremiumFeature: 'Telefonnummer ändern',
  alarmNotFound: 'Alarm nicht gefunden',
  alarmNotFoundMessage:
    'Dieser Alarm wurde möglicherweise kürzlich gelöscht. Tippen Sie auf "Entfernen", um weitere Benachrichtigungen für diesen Alarm zu deaktivieren.',
  alarmExistsWithDeepLinkTitle: 'Duplizierter Alarm',
  alarmExistsWithDeepLinkMessage:
    'Ein über diesen Link erstellter Alarm ist bereits auf Ihrem Telefon vorhanden.',
  errorCreatingSharedAlarmLink:
    'Es konnte kein gemeinsamer Alarm-Link erstellt werden. Bitte versuchen Sie es erneut.',
  alarmDoesntHaveNextDate:
    'Für den Alarm gibt es kein gültiges nächstes Datum.',
  sharePersonalAlarmDeepLinkDescription:
    'Tippen Sie auf diesen Link, um einen Alarm für dieses Ereignis unter {{dateString}} zu erstellen.',
  joinGroupAlarmDeepLinkDescription:
    'Klicken Sie auf diesen Link, um an dieser Gruppenveranstaltung teilzunehmen {{dateString}}',
  subscribedAlarmEdited:
    '{{alarmCreatorName}} hat {{alarmName}} aktualisiert. Möchten Sie Ihren Alarm aktualisieren?',
  subscribedAlarmDeleted:
    '{{alarmCreatorName}} hat {{alarmName}} gelöscht. Möchten Sie Ihren Alarm löschen?',
  responseReceivedForTicket:
    'Wir haben auf Ihr Ticket #{{ticketId}} geantwortet: {{email}}. Wenn sie nicht in Ihrem Posteingang ist, überprüfen Sie bitte Ihre Spam-Ordner auf eine E-Mail von support@galarm.zendesk.com.',
  newTicketReceived:
    'Danke, dass Sie uns geschrieben haben. Wir haben Ticket #{{ticketId}} erstellt, um Ihre Anfrage zu verfolgen.\n\nWir werden Ihnen an die von Ihnen angegebene E-Mail-Adresse antworten: {{email}}. Sollte diese nicht korrekt sein, übermitteln Sie Ihre Rückmeldung bitte erneut mit der richtigen E-Mail-Adresse.\n\nBitte fügen Sie auch support@galarm.zendesk.com zu Ihrem E-Mail-Adressbuch hinzu, um die ordnungsgemäße Zustellung unserer Antworten sicherzustellen. Wir werden auch hier eine Benachrichtigung senden, wenn wir auf Ihre Anfrage geantwortet haben.',
  sentAccountBackup:
    'Wir haben Ihre Alarmdaten an {{email}} gesendet. Wenn sie nicht in Ihrem Posteingang sind, überprüfen Sie bitte Ihre Spam-Ordner auf eine E-Mail von noreply@acintyo.com.',
  alarmDoesntExist: 'Der Alarm existiert nicht.',
  shareLink: 'Link teilen',
  joinedGroupAlarmFromDeepLinkMessage:
    'Sie werden unter {{alarmTime}} an "{{alarmName}}" erinnert. {{alarmDate}}',
  joinedRepeatingGroupAlarmFromDeepLinkMessage: {
    zero: 'Sie werden an "{{alarmName}}" erinnert. {{repetitionString}}',
    one: 'Unter {{alarmTime}} werden Sie an "{{alarmName}}" {{repetitionString}} erinnert. {{alarmDate}}'
  },
  youHaveSubscribedToThisAlarm:
    'Sie verfolgen diesen Alarm von {{creatorName}}.',
  alreadySharedAlarmDescription: {
    zero: 'Sie haben keine Anhänger für diesen Alarm.\n\nSie können diesen Alarm über einen Link mit weiteren Personen teilen. Wenn sie auf den Link tippen, wird eine Kopie dieses Alarms auf ihrem Telefon erstellt.',
    one: '{{count}} Person folgt diesem Alarm.\n\nSie können diesen Alarm über einen Link mit weiteren Personen teilen. Wenn sie auf den Link tippen, wird eine Kopie dieses Alarms auf ihrem Telefon erstellt.',
    other:
      '{{count}} Menschen folgen diesem Alarm.\n\nSie können diesen Alarm über einen Link mit weiteren Personen teilen. Wenn sie auf den Link tippen, wird eine Kopie dieses Alarms auf ihrem Telefon erstellt.'
  },
  shareParentAlarmDescription:
    'Sie verfolgen diesen Alarm von {{creatorName}}.\n\nSie können diesen Alarm auch über einen Link mit anderen teilen. Wenn diese auf den Link tippen, wird eine Kopie dieses Alarms auf ihrem Telefon erstellt und sie können ebenfalls diesem Alarm folgen.',
  shareableAlarmLinks: 'Teilbare Links',
  nPeopleFollowingAlarm: {
    zero: 'Sie haben keine Anhänger für diesen Alarm.',
    one: '{{count}} Person folgt diesem Alarm.',
    other: '{{count}} Menschen folgen diesem Alarm.'
  },
  likeUsOnFacebook: 'Facebook',
  followUsOnTwitter: 'X (ehemals Twitter)',
  followUsOnInstagram: 'Instagram',
  youtube: 'YouTube',
  mediumBlog: 'Blogs auf Medium',
  howtoVideos: 'Anleitungsvideos',
  followGalarmOnSocialMedia: 'Folgen Sie Galarm auf sozialen Medien',
  galarmOnSocialMedia: 'Galarm auf sozialen Medien',
  followGalarmOnSocialMediaDescription:
    'Sehen Sie sich spannende Neuigkeiten über App-Updates, die Nutzung von Funktionen, kommende Features sowie wichtige App-Bewertungen an. Sie können dort auch mit dem Galarm-Team interagieren.',
  sharedAlarm: 'Gemeinsamen Alarm bearbeiten',
  editingPublishedAlarm: {
    one: 'Sie bearbeiten einen Alarm, den Sie zuvor über einen Link freigegeben haben. {{count}} Person folgt derzeit diesem Alarm.\n\nWenn Sie Änderungen an diesem Alarm vornehmen, wird diese Person über die Änderungen benachrichtigt.',
    other:
      'Sie bearbeiten einen Alarm, den Sie zuvor über einen Link freigegeben haben. {{count}} Personen folgen derzeit diesem Alarm.\n\nWenn Sie Änderungen an diesem Alarm vornehmen, werden diese Personen über die Änderungen benachrichtigt.'
  },
  editingSubscribedAlarm:
    'Sie verfolgen diesen Alarm von {{creatorName}}. Sie erhalten keine Aktualisierungen für diesen Alarm, nachdem Sie den Alarm bearbeitet haben.',
  viewAlarm: 'Ansicht Alarm',
  view: 'Ansicht',
  editAlarm: 'Alarm bearbeiten',
  editTimeForNextOccurrence: 'Zeit für das nächste Vorkommen bearbeiten',
  editedNextOccurrenceConfirmation:
    'Dieser Alarm wurde aktualisiert, um nach dem bearbeiteten Vorkommen zu klingeln, und ein separater Alarm wurde für das bearbeitete Vorkommen erstellt.',
  thanksForTryingPremiumTitle: 'Sie sind bereit!',
  thanksForTryingPremiumMessage:
    'Wir wünschen Ihnen viel Spaß mit den Premium-Funktionen.\n\nBitte kontaktieren Sie den Support über "Einstellungen > Feedback" oder senden Sie uns eine E-Mail an galarm@acintyo.com, wenn Sie Fragen haben.',
  subscribedAlarmEditedInAlarmDetails:
    '{{creatorName}} hat seinen Alarm geändert.\nAktualisieren Sie Ihren Alarm?',
  subscribedAlarmDeletedInAlarmDetails:
    '{{creatorName}} hat seinen Alarm gelöscht.\nHaben Sie Ihren Alarm gelöscht?',
  updateSubscribedAlarm: 'Ja, aktualisieren',
  deleteSubscribedAlarm: 'Ja, löschen',
  ignoreSubscribedAlarm: 'Nein, ignorieren',
  customRepetitionPremiumScreenDescription:
    'Die benutzerdefinierte Wiederholung ist eine Premium-Funktion.\n\nMit dieser Funktion können Sie Alarme mit erweiterten Wiederholungen erstellen. Beispiele hierfür sind:\n',
  repeatAlternateDate: '✅ An abwechselnden Tagen wiederholen',
  repeatEveryNDay: '✅ Alle 3 Tage wiederholen',
  repeatEveryNHoursAndMMinutes: '✅ Alle 2 Stunden 30 Minuten wiederholen',
  repeatEveryNMinutes: '✅ Alle 45 Minuten wiederholen',
  repeatBiweekly: '✅ Alle 2 Wochen wiederholen',
  repeatEveryNWeeks: '✅ Alle 6 Wochen wiederholen',
  repeatEveryNMonths: '✅ Alle 3 Monate wiederholen (vierteljährlich)',
  repeatEveryLastDayOfMonth:
    '✅ Wiederholen Sie den letzten Tag eines jeden Monats',
  repeatDayOfWeekOfMonth: '✅ Wiederholung am 2. Samstag eines jeden Monats',
  repeatLastDayOfWeekOfMonth:
    '✅ Wiederholung am letzten Freitag eines jeden Monats',
  customRepetition: 'Benutzerdefinierte Wiederholung',
  lastDayOfMonth: 'Letzter Tag eines jeden Monats',
  dayOfWeekInMonth: '{{weekNumberOfDayInMonth}} {{dayName}} eines jeden Monats',
  lastDayOfWeekInMonth: 'Letzte {{dayName}} eines jeden Monats',
  dayOfWeekInMonthInYearSummary:
    '{{weekNumberOfDayInMonth}} {{dayName}} von {{monthName}}',
  lastDayOfWeekInMonthInYearSummary: 'Zuletzt {{dayName}} von {{monthName}}',
  lastDayOfMonthInYearSummary: 'Letzter Tag des {{monthName}}',
  dayOfWeekInMonthInYear:
    '{{weekNumberOfDayInMonth}} {{dayName}} von {{monthName}} jedes Jahr',
  lastDayOfWeekInMonthInYear: 'Letzte {{dayName}} von {{monthName}} jedes Jahr',
  lastDayOfMonthInYear: 'Letzter Tag von {{monthName}} jedes Jahr',
  chooseAMonthsConfiguration: 'Bitte wählen Sie eine Konfiguration.',
  chooseADaysConfiguration: 'Bitte wählen Sie eine Konfiguration',
  chooseAYearsConfiguration: 'Bitte wählen Sie eine Konfiguration.',
  sendCodeAgain: 'Code erneut senden',
  didntGetCodeNewUser:
    'Sie haben den Code nicht erhalten?\n\nSie können den Code erneut anfordern oder die Registrierung vorerst überspringen. Sie können sich später registrieren.',
  didntGetCodeExistingUser:
    'Sie haben den Code nicht erhalten?\n\nSie können den Code erneut anfordern oder die Registrierung abbrechen. Sie können sich später registrieren.',
  didntGetCodeUpdatePhoneNumber:
    'Sie haben den Code nicht erhalten?\n\nSie können den Code erneut anfordern oder es später noch einmal versuchen.',
  alreadySentCodeAgain:
    'Wir haben Ihnen den Code erneut zugeschickt. Wenn Sie Schwierigkeiten haben, den Code zu erhalten, überspringen Sie bitte die Registrierung und registrieren Sie sich später.',
  appearance: 'Erscheinungsbild',
  accentColor: 'Akzentfarbe',
  theme: 'thema',
  announceAlarmName: 'Alarm-Titel ankündigen',
  ttsHelperText:
    'Der Titel des Alarms wird angesagt, wenn der Alarm klingelt. Sie können auf die Wiedergabetaste vor dem Titel des Alarms tippen, um eine Vorschau zu hören.',
  initializingTts: 'Initialisierung von Text in Sprache',
  errorSpeakingAlarmName:
    'Sie können den Titel des Alarms nicht sprechen. Bitte kontaktieren Sie den Support unter "Einstellungen > Rückmeldung".',
  entityAlarm: 'alarm',
  entityGroup: 'gruppe',
  entityContact: 'kontakt',
  admin: 'Verwaltung',
  specifyAlarmTitleToSpeak:
    'Geben Sie den Titel des Alarms an, der gesprochen werden soll',
  wakeup: 'Aufwachen',
  ttsPremiumScreenDescription:
    'Die Ankündigung des Alarms mit einem Titel ist eine Premium-Funktion.\n\nWenn diese Funktion aktiviert ist, wird der Titel des Alarms angesagt, wenn der Alarm klingelt.\n\nGeben Sie zur Vorschau einen Titel für den Alarm ein und tippen Sie auf Wiedergabe.',
  unknownAlarmCategory: 'Unbekannte alarm kategorie',
  cantAnnounceAlarmTitle: 'Der Titel des Alarms wird nicht bekannt gegeben',
  ringtoneDurationIsSmall:
    'Die Dauer des Klingeltons sollte mindestens 5 Sekunden betragen, damit der Titel des Alarms angesagt werden kann.\n\nMöchten Sie mit diesen Einstellungen fortfahren?',
  noActionItems: 'Keine Aktionspunkte.',
  personNotInContacts:
    'Diese Person befindet sich nicht in Ihren Galarm-Kontakten.',
  light: 'Leicht',
  dark: 'Dunkel',
  systemDefault: 'Geräteeinstellung verwenden',
  chooseTheme: 'Thema wählen',
  dontSeeAllYourContacts: 'Sie sehen nicht alle Ihre Kontakte?',
  lastContactsSyncedAt: 'Zuletzt synchronisiert am {{dateString}}',
  refresh: 'Aktualisieren',
  forever: 'Für immer',
  autoSnoozeConfiguration: 'Schlummern konfigurieren',
  autoSnoozeConfigurationSummary:
    '{{autoSnoozeDurationLabel}}, {{autoSnoozeCountLabel}}',
  uncategorizedCategoryName: 'Nicht kategorisiert',
  uncategorizedCategoryScreenTitle: 'Uncategorized',
  setAlarmCategory: 'Einstellen der Alarm-Kategorie',
  changeAlarmCategory: 'Alarm-Kategorie ändern',
  viewAlarmHistory: 'Ansicht Alarmverlauf',
  computingAlarmHistory: 'Berechnungszusammenfassung für den Alarmverlauf...',
  alarmByCategories: '{{name}} Alarme',
  alarmCategories: 'kategorien',
  editAlarmCategory: 'Kategorie bearbeiten',
  deleteAlarmCategory: 'Kategorie löschen',
  newAlarmCategoryTitle: 'Neue kategorie',
  newAlarmCategoryNamePlaceholder: 'Geben Sie einen Namen an',
  editAlarmCategoryTitle: 'Kategorie bearbeiten',
  alarmCategorySummary: {
    zero: '{{alarmsSummary}}',
    one: '{{alarmsSummary}}, {{count}} verpasst',
    other: '{{alarmsSummary}}, {{count}} verpasst'
  },
  numAlarms: {
    zero: 'Keine Alarme',
    one: '{{count}} alarm',
    other: '{{count}} Alarme'
  },
  numIncidents: {
    zero: 'Keine Vorfälle',
    one: '{{count}} Vorfall',
    other: '{{count}} Vorfälle'
  },
  openedIncidents: 'Eröffnete Vorfälle',
  closedIncidents: 'Abgeschlossene Vorfälle',
  incidentChart: 'Tabelle der Vorfälle (letzte 30 Tage)',
  incidentCalendar: 'Kalender der Vorfälle',
  incidentDistribution: 'Verteilung der Vorfälle (letzte 30 Tage)',
  noIncidentsOpenedClosedInLast30Days:
    'Keine in den letzten 30 Tagen eröffneten oder abgeschlossenen Vorfälle',
  noIncidentsOpenedInLast30Days:
    'Keine Vorfälle in den letzten 30 Tagen eröffnet',
  color: 'Farbe',
  createNewAlarmCategory:
    'Erstellen Sie eine neue Kategorie, indem Sie auf die Schaltfläche + unten rechts tippen',
  setValidName: 'Einstellen eines gültigen Namens',
  specifyTimezoneForAlarmMessage:
    'Sie können eine Zeitzone angeben, wenn Sie Alarme erstellen. Die Alarme klingeln dann entsprechend der angegebenen Zeitzone. \n\nWenn Sie "Zeitzone des Geräts" wählen, klingeln die Alarme in der Zeitzone Ihres Geräts.',
  alarmCategoryFeatureDescription:
    'Erstellen Sie Ihre eigenen Kategorien für Alarme. Mit Kategorien können Sie Ihre Alarme einfach organisieren.',
  markAlarmDoneInAdvance: 'Alarm frühzeitig als "Erledigt" markieren?',
  skipAlarmInAdvance: '"Alarm vorzeitig überspringen"?',
  markAlarmDoneInAdvanceMessageRepeatingAlarm:
    'Wenn Sie jetzt "Erledigt" markieren, klingelt der Alarm nicht unter {{dateTimeString}}.',
  skipAlarmInAdvanceMessageRepeatingAlarm:
    'Der Alarm klingelt nicht auf {{dateTimeString}}, wenn Sie ihn jetzt überspringen.',
  markAlarmDoneInAdvanceMessageOneTimeAlarm:
    'Wenn Sie jetzt "Erledigt" markieren, klingelt der Alarm nicht unter {{dateTimeString}}.',
  skipAlarmInAdvanceMessageOneTimeAlarm:
    'Der Alarm klingelt nicht auf {{dateTimeString}}, wenn Sie ihn jetzt überspringen.',
  alarmsByCategories: 'Alarme nach Kategorien',
  workAlarmCategory: 'Arbeit',
  homeAlarmCategory: 'Startseite',
  birthdaysAlarmCategory: 'Geburtstage',
  more: 'Mehr',
  alarmCategory: 'Alarm Kategorie',
  editAlarmCategoryColor: 'Farbe bearbeiten',
  editAlarmCategoryColorTitle: 'Farbe bearbeiten für {{name}}',
  allUserCategoriesDeleted:
    'Alle von Ihnen erstellten Kategorien für Alarme wurden entfernt, da das Premium-Abonnement abgebrochen wurde. Alarme in diesen Kategorien werden unter "Nicht kategorisiert" angezeigt.',
  calendar: 'Kalender',
  eventExportedFromGalarm:
    '"Exportiert von Galarm auf {{dateString}} unter {{timeString}}."',
  unableToExportEventToCalendar:
    'Es ist nicht möglich, ein Ereignis in den Kalender zu exportieren. Bitte vergewissern Sie sich, dass Sie die Berechtigung zum Zugriff auf den Kalender auf dem Gerät erteilt haben. Senden Sie uns eine Rückmeldung über "Einstellungen > Feedback", wenn das Problem weiterhin besteht.',
  scanQrCode:
    'Um über einen Browser auf Galarm zuzugreifen, gehen Sie zu web.galarm.app und scannen Sie den QR-Code.',
  logOut: 'Abmelden',
  useHere: 'Hier verwenden',
  appRunningElsewhere:
    'Sie wurden von dieser Sitzung abgemeldet. Möchten Sie diese Sitzung fortsetzen?',
  dateTime: 'Datum und Zeit',
  selectAtLeastOneDayForRepetition:
    'Wählen Sie mindestens einen Tag, an dem der Alarm wiederholt werden soll.',
  chooseNumberOfDaysForAlarmRepetition:
    'Geben Sie die Anzahl der Tage ein, nach denen der Alarm wiederholt werden soll.',
  chooseNumberOfWeeksForAlarmRepetition:
    'Geben Sie die Anzahl der Wochen ein, nach denen der Alarm wiederholt werden soll.',
  chooseNumberOfMonthsForAlarmRepetition:
    'Geben Sie die Anzahl der Monate ein, nach denen der Alarm wiederholt werden soll.',
  chooseNumberOfYearsForAlarmRepetition:
    'Geben Sie die Anzahl der Jahre ein, nach denen der Alarm wiederholt werden soll.',
  previouslySelectedContactsAreUnselected:
    'Der/die zuvor ausgewählte(n) Kontakt(e) wird/werden abgewählt.',
  previouslySelectedGroupIsUnselected:
    'Die zuvor ausgewählte Gruppe ist nicht ausgewählt.',
  galarmWebInstructions:
    '1. Öffnen Sie die Galarm-App auf Ihrem Telefon\n2. Gehen Sie zur Registerkarte "Einstellungen" und tippen Sie auf "Galarm Web".\n3. Vergewissern Sie sich, dass Sie die neueste App verwenden, wenn Sie die Option nicht sehen.\n4. Scannen Sie den QR-Code auf der rechten Seite',
  likeToCreateAlarm: 'Erstellen Sie einen Alarm für...',
  payUtilityBills: 'Rechnungen bezahlen',
  wakeupAlarmName: 'Aufwachen',
  exerciseAlarmName: 'Übung',
  drinkWaterAlarmName: 'Wasser trinken',
  everyNHoursRepetitionStringShortSummary: {
    one: '{{startTimeString}} an {{endTimeString}} Jede Stunde',
    other: '{{startTimeString}} auf {{endTimeString}} Alle {{count}} Stunden'
  },
  firstTimeManagementQuote:
    '"Die schlechte Nachricht ist, dass die Zeit vergeht. Die gute Nachricht ist, dass du der Pilot bist."',
  firstTimeManagementQuoteAuthor: 'Michael Altshuler',
  secondTimeManagementQuote: '"Jedes Zeitmanagement beginnt mit der Planung."',
  secondTimeManagementQuoteAuthor: 'Tom Greening',
  thirdTimeManagementQuote:
    '"Was du heute kannst besorgen, das verschiebe nicht auf morgen".',
  thirdTimeManagementQuoteAuthor: 'Benjamin Franklin',
  fourthTimeManagementQuote:
    '"Zeit ist das, was wir am meisten wollen, aber das, was wir am schlechtesten nutzen."',
  fourthTimeManagementQuoteAuthor: 'William Penn',
  fifthTimeManagementQuote:
    '"In einem Jahr werden Sie sich vielleicht wünschen, Sie hätten heute angefangen.',
  fifthTimeManagementQuoteAuthor: 'Karen Lamm',
  sixthTimeManagementQuote:
    '"Ihr könnt verzögern, aber die Zeit wird es nicht."',
  sixthTimeManagementQuoteAuthor: 'Benjamin Franklin',
  tapToGetStarted: 'Tippen Sie auf "+", um zu beginnen.',
  allCategories: 'Alle kategorien',
  createAlarmWithContact: 'Erstellen Sie einen Alarm mit {{name}}',
  createAlarmWithGroup: 'Erstellen Sie einen Alarm mit {{name}}',
  editGroup: 'Gruppe bearbeiten',
  discardChanges: 'Die aktuellen Änderungen werden verworfen. Fortfahren?',
  alarmWillRingEveryNDays: {
    zero: 'Der Alarm klingelt jeden Tag.',
    one: 'Der Alarm klingelt an abwechselnden Tagen.',
    other: 'Der Alarm klingelt jeden {{dayWithOrdinal}} Tag.'
  },
  hoursString: {
    zero: '',
    one: '1 Stunde',
    other: '{{count}} Stunden'
  },
  minutesString: {
    zero: '',
    one: '1 Minute',
    other: '{{count}} Minuten'
  },
  alarmWillRingEveryMHoursAndNMinutes:
    'Der Alarm klingelt nach jedem {{repeatString}}, beginnend mit {{dayString}}. Danach {{otherDaysString}} und so weiter.',
  alarmWillRingEveryNWeeks: {
    zero: 'Der Alarm klingelt jede Woche.',
    one: 'Der Alarm klingelt alle zwei Wochen.',
    other: 'Der Alarm klingelt jede {{weekWithOrdinal}} Woche.'
  },
  alarmWillRingEveryNMonths: {
    zero: 'Der Alarm klingelt jeden Monat.',
    one: 'Der Alarm klingelt alle zwei Monate.',
    other: 'Der Alarm klingelt alle {{monthWithOrdinal}} Monate.'
  },
  alarmWillRingEveryNYears: {
    zero: 'Der Alarm wird jedes Jahr klingeln.',
    one: 'Der Alarm wird halbjährlich klingeln.',
    other: 'Der Alarm klingelt alle {{yearWithOrdinal}} Jahre.'
  },
  ringParticipantAlarmsByDefaultTooltipMessage:
    'Wenn diese Einstellung aktiviert ist, klingeln Alarme von anderen, ohne dass Sie sie akzeptieren. Sie sollten den Alarm dennoch akzeptieren, um dem Ersteller mitzuteilen, dass Sie an dem Alarm teilnehmen möchten.\n\nWenn diese Einstellung deaktiviert ist, klingeln Alarme, die von anderen für Sie hinzugefügt wurden, nicht auf Ihrem Telefon, es sei denn, Sie akzeptieren sie ausdrücklich.',
  specifyTimezoneForAlarmDefaultTooltipMessage:
    'Wenn diese Einstellung aktiviert ist, können Sie eine Zeitzone angeben, wenn Sie Alarme erstellen. Die Alarme klingeln dann gemäß der angegebenen Zeitzone.\n\nWenn diese Einstellung deaktiviert ist, klingeln die Alarme gemäß der Zeitzone Ihres Geräts.',
  ringOnEarphoneOnlyTooltipTitle:
    'Alarmverhalten bei angeschlossenen Kopfhörern',
  ringOnEarphoneOnlyTooltipMessage:
    'Wenn Kopfhörer angeschlossen sind, können Sie Ihre Alarme so konfigurieren, dass sie entweder nur auf den Kopfhörern oder sowohl auf dem Telefonlautsprecher als auch auf den Kopfhörern klingeln.\n\nWenn die Ohrhörer nicht angeschlossen sind, klingeln die Alarme über den Telefonlautsprecher.',
  gestureOptionsTooltipTitle: 'Geste zum Ignorieren eines Alarms',
  gestureOptionsTooltipMessage:
    'Wenn ein Alarm auf dem Sperrbildschirm klingelt, können Sie ihn ignorieren, indem Sie entweder auf eine Taste tippen oder eine Taste verschieben.\n\nMit dieser Einstellung können Sie wählen, wie Sie einen Alarm ignorieren möchten.',
  notificationSettingsTooltipTitle: 'Einstellungen für die Benachrichtigung',
  notificationSettingsTooltipMessage:
    'Aktivieren Sie die Benachrichtigungen, die Sie erhalten möchten, und deaktivieren Sie diejenigen, über die Sie nicht benachrichtigt werden möchten.',
  messagesForAlarm: 'Nachrichten für {{name}}',
  systemNotificationsTooltipMessage:
    'Von der App generierte Benachrichtigungen für Ereignisse wie:\n  - wenn Alarme betroffen sind, weil ein Kontakt die Zeitzone wechselt\n  - wenn ein eingeladener Kontakt sich auf Galarm registriert\n  - wenn Alarme betroffen sind, weil jemand sein Konto gelöscht hat',
  galarmWebNotificationsTooltipMessage:
    'Benachrichtigungen, die Sie von Galarm Web erhalten.',
  alarmsfromOthersNotificationsTooltipMessage:
    'Benachrichtigungen, die gesendet werden, wenn Sie als Teilnehmer zu einem Alarm hinzugefügt werden.',
  alarmChatNotifictionsTooltipMessage:
    'Benachrichtigungen für Chat-Nachrichten in einem Alarm.',
  groupNotificationsTooltipMessage:
    'Benachrichtigungen, die gesendet werden, wenn Sie zu einer Gruppe hinzugefügt oder aus einer Gruppe entfernt werden, oder wenn jemand anderes zu einer Gruppe hinzugefügt oder aus einer Gruppe entfernt wird.',
  alarmAcknowledgementNotificationsTooltipMessage:
    'Benachrichtigungen, die gesendet werden, wenn ein Teilnehmer einen Alarm quittiert, bei dem Sie ebenfalls Teilnehmer sind.',
  sharedAlarmNotificationsTooltipMessage:
    'Benachrichtigungen, die gesendet werden:\n  - wenn jemand einen von Ihnen über einen Link freigegebenen Alarm abonniert\n  - wenn ein Alarm, den Sie abonniert haben, geändert wurde',
  sleepTimer: 'Schlaf-Musik',
  sleepTimerTitle: 'Musik spielen für',
  ongoingSleepTimer: 'Schlafmusik Fortlaufend',
  stopSleepTimer: 'Möchten Sie die aktuelle Musik anhalten?',
  restartSleepTimer:
    'Möchten Sie die aktuelle Musik anhalten und eine neue starten?',
  play: 'Spielen',
  youAreOffline:
    'Sie sind derzeit offline. Gehen Sie online, um Operationen durchzuführen.',
  sleepMusicTooltip:
    'Spielen Sie natürliche Klänge, um Ihren Körper und Geist zu entspannen. Die Musik hört nach der angegebenen Dauer auf zu spielen.',
  alarmLinkCopiedToClipboard: 'Alarm-Link in die Zwischenablage kopiert.',
  confirmLogOut: 'Möchten Sie sich abmelden?',
  appNotRunningMessage:
    'Wir haben festgestellt, dass Galarm nicht auf Ihrem Telefon läuft. Tippen Sie auf , um Galarm zu starten, damit Sie keine wichtigen Alarme verpassen.',
  tapToEnterNotesForAlarm: 'Tippen Sie auf , um Notizen einzugeben',
  accountAlreadyExists: 'Bestehendes Konto gefunden',
  accountsMerged:
    'Wir haben ein bestehendes Konto gefunden, das mit dieser Handynummer verbunden ist. Wir haben die beiden Konten zusammengeführt.',
  upgradeToPremiumToAssignUserDefinedCategory:
    'Aktualisieren Sie auf Premium, um eine benutzerdefinierte Kategorie auszuwählen.',
  userDefinedCategoryNotSetForAlarm:
    'Aktualisieren Sie auf Premium, um die benutzerdefinierte Kategorie automatisch zuzuweisen. Für den Alarm ist keine Kategorie eingestellt.',
  alarmDetails: 'Details zum Alarm',
  profileDetails: 'Profil',
  activeWebSession:
    'Sie haben bereits eine aktive Web-Sitzung. Sie können sich von dieser abmelden oder eine neue Sitzung starten.\n\nWenn Sie eine neue Sitzung beginnen, werden Sie automatisch von der derzeit aktiven Web-Sitzung abgemeldet.',
  startNewSession: 'Eine neue Sitzung beginnen',
  confirmWebSessionLogout:
    'Dadurch werden Sie von Ihrer aktuellen Web-Sitzung abgemeldet. Sie können eine neue Sitzung starten, indem Sie den Code erneut scannen.',
  defaultInstantAlarmTitleForGroup: '{{groupName}} Warnung von {{creatorName}}',
  defaultInstantAlarmTitleForContact: 'Warnung von {{creatorName}}',
  atleastOneMemberShouldBeActive:
    'Mindestens ein Teilnehmer sollte aktiv sein.',
  activeParticipants: 'Aktive Teilnehmer',
  acceptAlarm: 'Akzeptieren des Alarms',
  rejectAlarm: 'Ablehnen des Alarms',
  nConfirmed: '{{count}} bestätigt',
  nDeclined: '{{count}} abgelehnt',
  nPending: '{{count}} anhängig',
  everyoneConfirmed: 'Alle haben bestätigt',
  everyoneDeclined: 'Alle sind abgelehnt worden',
  appTagline: 'Nie etwas verpassen',
  usePreviousBackup: 'Ich bin ein registrierter Benutzer >',
  viewAlarmsByCategories: 'Ansicht Alarme nach Kategorien',
  viewAllAlarms: 'Ansicht Alle Alarme',
  switchToSummaryView: 'Zur Ansicht "Zusammenfassung" wechseln',
  switchToListView: 'Umschalten auf Listenansicht',
  hideHourlyAlarms: 'Stündliche Alarme ausblenden',
  calendarView: 'Galarm Kalender',
  viewRecentlyDeletedAlarms: 'Ansicht kürzlich gelöschter Alarme',
  deletedOnDate: 'Gelöscht am {{alarmDate}}',
  recentlyDeletedAlarmFooterText:
    'Dieser Alarm wurde gelöscht am {{alarmDate}}',
  noRecentlyDeletedAlarms: 'Keine kürzlich gelöschten Alarme',
  restoreAlarmsFromMobileApp:
    'Diese Alarme werden 30 Tage nach ihrer Löschung automatisch gelöscht. Wenn Sie einen dieser Alarme wiederherstellen möchten, gehen Sie bitte zum Bildschirm "Kürzlich gelöschte Alarme" Ihrer mobilen App und tippen Sie auf das Symbol für die Wiederherstellung.',
  deleteExpiredAlarms: 'Verpasste Alarme löschen',
  deleteInactiveAlarms: 'Inaktive Alarme löschen',
  deleteAlarms: 'Alarme löschen',
  enableAlarms: 'Alarme aktivieren',
  disableAlarms: 'Alarme deaktivieren',
  noItemsToDisplay: 'Keine Elemente zum Anzeigen',
  sent: 'Gesendet',
  received: 'Empfangen',
  defaultConfigurationUpdated: 'Die Standardkonfiguration wurde aktualisiert.',
  notAlerted: '(ausgeschlossen)',
  alarmKeepsRingingHelp: 'Hilfe! Mein Alarm klingelt ständig',
  alarmKeepsRingingHelpMessage:
    'Wir haben Ihre Alarme aufgefrischt und den Problembericht verschickt.',
  alarmKeepsRingingHelpAlert:
    'Wir werden Ihre Alarme aktualisieren und Sie sollten das Problem nicht mehr bemerken. Wir werden auch einen Problembericht an unser Support-Team zur weiteren Untersuchung senden.\n\n  Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über "Einstellungen > Feedback".',
  sendingFeedback: 'Rückmeldung senden',
  sendingProblemReport: 'Problembericht abschicken',
  fixingAlarms: 'Aktualisieren Ihrer Alarme',
  existingAccountFound: 'Sicherung wiederhergestellt',
  existingAccountDataRestored: {
    zero: 'Glückwunsch, alle Daten wurden von der Sicherung wiederhergestellt.',
    one: 'Glückwunsch, alle Daten wurden von der Sicherung wiederhergestellt.',
    other: 'Glückwunsch, alle Daten wurden von der Sicherung wiederhergestellt.'
  },
  noExistingAccountFound: 'Keine Sicherung gefunden',
  createdNewAccount:
    'Diese Rufnummer wurde nicht bei Galarm registriert. Wir haben ein neues Konto mit dieser Rufnummer erstellt.',
  iosCloseToAllowedNumNotificationsScheduled:
    'Sie haben fast die Systemgrenze für geplante Benachrichtigungen von iOS erreicht.\n\nUm sicherzustellen, dass Ihre Alarme rechtzeitig klingeln, aktivieren Sie „Erweiterte Alarmzustellung“ unter „Einstellungen (Registerkarte) → Erweiterte Einstellungen“.\n\nDiese premium-Funktion nutzt die Server von Galarm, um Alarmbenachrichtigungen zuverlässig zuzustellen, wenn die Systemgrenzen von iOS erreicht sind. Dazu ist eine aktive Internetverbindung erforderlich.',
  acknowledgeAlarmToScheduleNextOccurrence:
    'Dies ist die letzte Benachrichtigung für diesen Alarm. Drücken Sie lange auf diese Benachrichtigung und führen Sie eine Aktion durch, um das nächste Auftreten dieses Alarms zu planen.',
  lastNotificationForOneTimeAlarm:
    'Dies ist die letzte Benachrichtigung für diesen Alarm.',
  criticalAlertsMessageTitle:
    'Alarme klingeln lassen, wenn Ihr Telefon stumm geschaltet ist',
  criticalAlertsMessageDescription:
    '\nSie können Galarm so konfigurieren, dass es iOS Critical Alerts verwendet, um Alarme zu klingeln, wenn Ihr Telefon stummgeschaltet ist. Möchten Sie dies für alle Alarme aktivieren?\n\nSie können es auch selektiv für einige Alarme aktivieren, indem Sie deren "Ton und Vibration > Kritische Alarme" Einstellung bearbeiten.',
  allowCriticalAlerts: 'Kritische Alarme zulassen',
  criticalAlertsPermissionDenied:
    'Galarm benötigt die Erlaubnis Ihres Telefons, um kritische Alarme anzuzeigen. Bitte aktivieren Sie diese Erlaubnis in den Einstellungen Ihres Telefons.',
  enableCriticalAlertsForAllAlarms: 'Ja, für alle Alarme aktivieren',
  selectivelyEnableCriticalAlerts: 'Nein, ich werde selektiv aktivieren',
  firstName: 'Vorname',
  lastName: 'Nachname',
  email: 'E-Mail',
  password: 'Passwort',
  confirmPassword: 'Bestätigen Sie das Passwort',
  signup: 'Anmeldung',
  login: 'Anmeldung',
  alreadySignedUp: 'Sie haben sich bereits angemeldet?',
  notAUser: 'Sie sind kein Nutzer?',
  subscribe: 'Abonnieren',
  configurePlan: 'Plan konfigurieren',
  choosePlan: 'Plan wählen',
  billingCycle: 'Abrechnungszyklus',
  needHelpToGetStarted: 'Benötigen Sie Hilfe bei den ersten Schritten?',
  browser: 'Browser: {{name}}',
  deviceOs: 'Gerät: {{name}}',
  lastActive: 'Zuletzt aktiv: {{timestamp}}',
  signUp: 'Registrieren Sie sich',
  useGalarmOnWeb: 'Galarm im Web verwenden',
  welcomeUser: 'Willkommen {{name}}',
  changePassword: 'Passwort ändern',
  saveAlarm: 'Alarm speichern',
  galarmUserTip: 'Wussten Sie das?',
  sendAlarm: 'Alarm senden',
  saveGroup: 'Gruppe speichern',
  webAppBestViewedOnDesktop:
    'Die URL (web.galarm.app) dient zum Starten einer Galarm-Oberfläche in einem Webbrowser auf Ihrem Laptop oder Desktop.\n\nUm Galarm auf diesem mobilen Gerät zu verwenden, installieren Sie bitte die Android-App von Google Play oder die iOS-App aus dem App Store über einen der unten stehenden Links:',
  scanQrCodeMessage: 'QR-Code scannen',
  reloadQrCode: 'Zum Nachladen QR-Code anklicken',
  invalidQrCodeScanned: 'Ungültiger QR-Code gescannt.',
  unableToScanCode: 'Code kann nicht gescannt werden',
  unableToScanCodeMessage:
    'Beim Scannen des Codes ist ein Problem aufgetreten. Bitte versuchen Sie es erneut. Wenn Sie weiterhin Probleme haben, senden Sie uns bitte eine Rückmeldung über die mobile App unter "Einstellungen > Feedback".',
  problemWithEnterpriseAccountSetup:
    'Bei der Einstellung Ihres Galarm Pro-Kontos ist ein Problem aufgetreten. Bitte kontaktieren Sie den technischen Support.',
  problemWithCreatingCheckoutSession:
    'Es ist ein Problem bei der Erstellung einer Checkout-Sitzung aufgetreten. Bitte kontaktieren Sie den technischen Support.',
  unableToLoadPremiumPlans:
    'Premium-Pläne können nicht geladen werden. Bitte versuchen Sie es später noch einmal.',
  noPlanSelected: 'Bitte wählen Sie einen Plan, bevor Sie fortfahren.',
  problemWithCreatingCustomerPortalSession:
    'Es gab ein Problem beim Erstellen einer Kundenportalsitzung. Bitte kontaktieren Sie den technischen Support.',
  problemWithCreatingApiKey:
    'Beim Erstellen eines API-Schlüssels ist ein Problem aufgetreten. Bitte kontaktieren Sie den technischen Support.',
  creatingAnAccount: 'Ein Konto erstellen',
  currentPlan: 'Derzeitiger Plan: {{name}} ({{quantity}} seats)',
  myAccount: 'Konto-Informationen',
  new: 'Neu',
  deleteAllAlarmHistoryAlertTitle: 'Alarmverlauf löschen',
  deleteAllAlarmHistoryAlertMessage:
    'Tippen Sie auf "Weiter", um den Verlauf für diesen Alarm zu löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
  ageOutInactiveAlarmsMessage:
    'Sie haben {{count}} Alarme, die seit mehr als 60 Tagen inaktiv sind. Eine große Anzahl inaktiver Alarme kann die Leistung der App beeinträchtigen.\n\nMöchten Sie diese Alarme löschen?',
  duplicateAlarm: 'Duplizierter Alarm',
  graduallyIncreaseVolume: 'Lautstärke schrittweise erhöhen',
  graduallyIncreaseVolumeTooltipMessage:
    'Wenn diese Einstellung aktiviert ist, erhöht sich die Lautstärke des Alarms allmählich auf die eingestellte Lautstärke des Klingeltons. So können Sie den Alarm stoppen, bevor er zu laut wird.\n\nWenn diese Einstellung deaktiviert ist, klingeln Alarme während der gesamten Dauer des Klingeltons mit der eingestellten Lautstärke.',
  shakeToStopAlarm: 'Schütteln zum Stoppen des Alarms',
  shakeToStopAlarmTooltipMessage:
    'Wenn diese Einstellung aktiviert ist, können Sie Ihr Telefon schütteln, um einen klingelnden Alarm zu stoppen. Wenn die automatische Schlummerfunktion konfiguriert ist, wird der Alarm durch Schütteln in den Schlummermodus versetzt.',
  shakeToStopAlarmNotAvailable:
    'Schütteln zum Stoppen des Alarms ist auf diesem Gerät nicht verfügbar.',
  shakeSensitivity: 'Empfindlichkeit beim Schütteln',
  shakeSensitivityVeryHigh: 'Sehr hoch',
  shakeSensitivityHigh: 'Hoch',
  shakeSensitivityMedium: 'Mittel',
  shakeSensitivityLow: 'Niedrig',
  shakeSensitivityVeryLow: 'Sehr niedrig',
  shakeTestInstructions:
    'Schütteln Sie Ihr Telefon, um zu testen. Die Leiste füllt sich, wenn eine Bewegung erkannt wird; grün bedeutet, dass der Alarm stoppen würde. Sie werden auch eine Vibration spüren, wenn der Alarm stoppen würde.',
  teams: 'Mannschaften',
  alerts: 'Warnungen',
  listeners: 'Hörer',
  noMembersConfiguredInEnterpriseAccount: `Sie haben noch keine Mitglieder hinzugefügt.

Mitglieder sind Benutzer, die benachrichtigt werden können, wenn in Ihrer Organisation Vorfälle auftreten. Diese Personen sollten bereits bei Galarm registriert sein.`,
  noMembersConfiguredInBusinessAccount: `Sie haben noch keine Mitglieder hinzugefügt.

Mitglieder sind Benutzer, denen Sie die Premium-Funktionen von Galarm gewähren möchten. Diese Personen sollten bereits bei Galarm registriert sein.`,
  noTeamsConfiguredInEnterpriseAccount: `Sie haben noch keine Teams erstellt.

Teams sind Gruppen von Mitgliedern, die zusammen benachrichtigt werden können, wenn in Ihrer Organisation Vorfälle auftreten.`,
  noAlertsConfiguredInEnterpriseAccount: `Sie haben noch keine Listener erstellt.

Listener überwachen Vorfälle in Ihrer Organisation. Sie können festlegen, welche Mitglieder oder Teams benachrichtigt werden, wenn ein Vorfall erkannt wird, und Eskalationsregeln festlegen, wenn er nicht rechtzeitig bestätigt wird.

Jeder Listener bietet einen Webhook, den Sie in Ihre Überwachungstools integrieren können, um Vorfälle automatisch auszulösen, wenn die Bedingungen erfüllt sind. Sie können auch manuell Vorfälle aus der App erstellen, wenn etwas Aufmerksamkeit erfordert.`,
  noShiftsConfiguredInEnterpriseAccount:
    'Sie haben noch keine Schichtkonfigurationen erstellt.',
  noRotationsConfiguredInEnterpriseAccount:
    'Sie haben noch keine Rotationen erstellt.',
  rotations: 'Umdrehungen',
  addRotation: 'Rotation hinzufügen',
  enterRotationName: 'Name der Rotation eingeben',
  rotationType: 'Drehung Typ',
  numberOfHoursInRotation: 'Anzahl der Stunden in der Rotation',
  numberOfDaysInRotation: 'Anzahl der Tage im Turnus',
  numberOfWeeksInRotation: 'Anzahl der Wochen im Turnus',
  specify: 'Spezifizieren Sie...',
  noIntegrationsConfiguredInEnterpriseAccount:
    'Sie haben noch keine Integrationskonfigurationen konfiguriert.',
  loadingUser: 'Laden von Benutzerinformationen',
  addMember: 'Mitglied hinzufügen',
  add: 'hinzufügen',
  noUserFoundWithMobileNumber:
    'Kein registrierter Galarm-Benutzer mit dieser Rufnummer gefunden. Bitte stellen Sie sicher, dass Sie die Telefonnummer mit der Landesvorwahl ohne Sonderzeichen wie Klammern, Bindestriche, Leerzeichen usw. eingeben.',
  memberWithPhoneNumberAlreadyAdded:
    'Das Mitglied mit dieser Telefonnummer wurde bereits hinzugefügt.',
  memberWithEmailAlreadyAdded:
    'Das Mitglied mit dieser E-Mail wurde bereits hinzugefügt.',
  assignKeyToMember: 'Lizenzschlüssel zuweisen',
  revokeKeyFromMember: 'Lizenzschlüssel widerrufen',
  cantAssignKeyToMember: 'Schlüssel kann dem Mitglied nicht zugewiesen werden',
  noEnterpriseLicenseKeyAvailable:
    'Es sind keine Lizenzschlüssel verfügbar. Bitte aktualisieren Sie Ihren Plan.',
  addTeam: 'Team hinzufügen',
  enterTeamName: 'Eingabe eines Teamnamens',
  addAlert: 'Hörer hinzufügen',
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
  severity: 'Schweregrad',
  enterAlertName: 'Name für den Hörer eingeben',
  organization: 'Organisation',
  startTime: 'Start Zeit',
  endTime: 'Ende Zeit',
  shiftName: 'Schicht {{index}}',
  addShift: 'Verschiebung hinzufügen',
  assignees: 'Beauftragte',
  shiftStartEndTime: '{{startTime}} - {{endTime}}',
  assignee: 'Rechtsnachfolger',
  specifyAssigneeForShift: 'Zuweiser für die Schicht angeben',
  selectAtLeastOneMember: 'Mindestens ein Mitglied auswählen',
  editMember: 'Bearbeiten Mitglied',
  editTeam: 'Team bearbeiten',
  cantRemoveMemberAssignedToTeamsOrAlerts:
    'Das Mitglied ist Teil eines Teams oder einem Hörer zugewiesen. Bitte entfernen Sie das Mitglied aus diesen Teams/Hörern, bevor Sie es löschen.\nTeams: {{teams}}\nHörer: {{alerts}}',
  cantRevokeKeyFromMemberAssignedToTeamsOrAlerts:
    'Das Mitglied ist Teil eines Teams oder einem Hörer zugewiesen. Bitte entfernen Sie das Mitglied aus diesen Teams/Hörern, bevor Sie den Schlüssel entziehen.\nTeams: {{teams}}\nHörer: {{alerts}}',
  cantDeleteTeamAssignedToAlerts:
    'Das Team ist Teil eines Hörers. Bitte entfernen Sie das Team aus dem Hörer, bevor Sie es löschen.\nHörer: {{alerts}}',
  cantDeleteRotationAssignedToAlerts:
    'Die Rotation ist Teil eines Hörers. Bitte entfernen Sie das Team aus dem Hörer, bevor Sie es löschen.\nHörer: {{alerts}}',
  editAlert: 'Listener bearbeiten',
  timezoneDisplayString: '(GMT{{offset}}) {{timezone}}',
  getCode: 'Code erhalten',
  apiKey: 'API-Schlüssel',
  viewApiKey: 'Ansicht API-Schlüssel',
  apiKeyWarningMessage:
    'Bewahren Sie Ihren API-Schlüssel zu jeder Zeit sicher auf. Geben Sie ihn nicht an Dritte weiter. Wenn Sie glauben, dass Ihr API-Schlüssel kompromittiert wurde, tippen Sie oben auf die Schaltfläche "Ändern", um ihn zu ändern. Nachdem Sie den Schlüssel geändert haben, müssen Sie den neuen Schlüssel an allen Stellen angeben, an denen Sie Vorfälle über die REST-API auslösen',
  integrationConfigs: 'Integration-Konfigurationen',
  addIntegrationConfig: 'Integrationskonfiguration hinzufügen',
  editIntegrationConfig: 'Integrationskonfiguration bearbeiten',
  integrationSource: 'Integration Quelle',
  apiToken: 'API-Token',
  integrations: 'Integrationen',
  selectPlaceholder: 'Wählen Sie...',
  chooseRoleForMember: 'Rolle für das Mitglied wählen',
  zendeskSubdomain: 'Zendesk Subdomain',
  creatorTimeForBuddyAlarm: '{{timeString}} ({{remindMeAfter}})',
  nextFiveAlarms: 'Die nächsten 5 Alarme',
  categories: 'kategorien',
  viewingAlarmsDueToday: 'Ansicht der heute fälligen Alarme',
  viewingAlarmsDueTomorrow: 'Ansicht der morgen fälligen Alarme',
  expiredAlarms: 'Verpasste Alarme',
  viewingExpiredAlarms: 'Verpasste Alarme anzeigen',
  noAlarmsDueToday: 'Heute keine Alarme fällig',
  noAlarmsDueTomorrow: 'Keine Alarme für morgen',
  noExpiredAlarms: 'Keine verpassten Alarme',
  viewingAllAlarms: 'Ansicht aller Alarme',
  viewingRecentlyDeletedAlarms: 'Ansicht der kürzlich gelöschten Alarme',
  summaryView: 'Versuchen Sie die Ansicht "Zusammenfassung"?',
  summaryViewDescription:
    'Siehe Alarme nach Daten und Kategorien geordnet.\n\nMit der Schaltfläche ⋮ oben rechts können Sie wieder zur Listenansicht wechseln.',
  disableBatteryOptimizationMessageOnStartup:
    'Galarm muss im Hintergrund laufen, damit die Alarme zuverlässig klingeln können. Erlauben Sie dies bitte auf dem nächsten Bildschirm.',
  disableBatteryOptimizationMessage:
    'Galarm muss im Hintergrund laufen, damit die Alarme zuverlässig klingeln.',
  allowNotificationsToDisplayAlarms:
    'Galarm benötigt die Erlaubnis, Benachrichtigungen anzuzeigen, wenn Alarme klingeln.',
  scheduleExactAlarmsMessage:
    'Galarm benötigt die Erlaubnis, genaue Alarme zu planen.',
  alarmCategoryWithSameNameExists:
    'Eine Kategorie mit diesem Namen existiert bereits. Bitte geben Sie einen anderen Namen an.',
  alarmRepetitionsPremiumFeature: 'Erweiterte Wiederholungsoptionen',
  ringtonesPremiumFeature: 'Mehr Klingeltöne',
  galarmWebPremiumFeature: 'Galarm im Web verwenden',
  taskListPremiumFeature: 'Mehrere Aufgabenlisten erstellen',
  preReminderPremiumFeature: 'Vorab-Erinnerung für Alarme',
  alarmCategoriesPremiumFeature: 'Benutzerdefinierte Kategorien für Alarme',
  shareableAlarmLinksPremiumFeature: 'Freigegebene Alarm-Links',
  announceAlarmNamePremiumFeature: 'Alarm-Titel ankündigen',
  manageSubscription: 'Abonnement verwalten',
  modifySubscription: 'Abonnement ändern',
  purchaseRestored: 'Kauf wiederhergestellt.',
  unableToRetrieveSubscriptionPlansAndroid:
    'Wir können keine Verbindung zu Google Play herstellen, um die Aktualisierung durchzuführen. Bitte vergewissern Sie sich, dass Sie mit dem Internet verbunden sind, und versuchen Sie es dann erneut. \n\nBitte melden Sie das Problem an unser Support-Team, wenn es weiterhin besteht.',
  unableToRetrieveSubscriptionPlansIos:
    'Wir können keine Verbindung zum App Store herstellen, um die Aktualisierung durchzuführen. Bitte vergewissern Sie sich, dass Sie mit dem Internet verbunden sind, und versuchen Sie es dann erneut. \n\nBitte melden Sie das Problem an unser Support-Team, wenn es weiterhin besteht.',
  drawOverOtherApps: 'Anzeige über anderen Anwendungen',
  drawOverOtherAppsHelperText: 'Erlauben Sie Galarm, Alarme oben anzuzeigen',
  learnHowToUseFocus: 'Fokus lernen',
  enhancedNotificationsDeprecated: 'Verbesserte Benachrichtigungen Veraltet',
  enhancedNotificationsDeprecatedMessage:
    'Wir haben festgestellt, dass die erweiterten Benachrichtigungen nicht zuverlässig sind und den Akku übermäßig belasten. Bitte verwenden Sie iOS Focus, um Galarm zu erlauben, Alarme zu klingeln, wenn Ihr Telefon auf "Nicht stören" eingestellt ist.',
  usingIosFocus: 'iOS Focus verwenden',
  iosFocusModePara1:
    'Galarm klingelt nicht, wenn der Ruftonschalter des Telefons ausgeschaltet ist oder wenn die Lautstärke des Ruftons auf 0 steht.\n\nApple empfiehlt die Verwendung von "Focus", wenn Sie Ihr Telefon stumm schalten möchten, aber dennoch die Benachrichtigung durch bestimmte Anwendungen zulassen möchten. Befolgen Sie die folgenden Anweisungen, um Focus auf Ihrem Telefon einzurichten.',
  iosFocusModePara2:
    'Eine ausführliche Anleitung mit Screenshots finden Sie unter https://galarm.zendesk.com/hc/en-us/articles/10906890793236-Allow-alarms-to-ring-on-silent-on-iOS',
  settingFocus: 'Einstellen des Fokus:',
  settingFocusFootNotes:
    'Bitte beachten Sie, dass Focus unter iOS 15 und höher verfügbar ist.\n\nBei Fragen oder Rückmeldungen kontaktieren Sie uns bitte über "Einstellungen > Feedback".',
  enablingFocus: 'Enabling Focus:',
  settingFocusInstruction1: 'Gehen Sie zu "Telefoneinstellungen > Fokus".',
  settingFocusInstruction2: 'Tippen Sie auf das Profil "Bitte nicht stören".',
  settingFocusInstruction3: 'Tippen Sie auf "Apps" und fügen Sie Galarm hinzu.',
  settingFocusInstruction4:
    'Verfahren Sie mit den anderen von Ihnen eingestellten Focus-Profilen genauso.',
  enablingFocusInstruction1:
    'Wischen Sie von der oberen rechten Ecke nach unten, um die Ansicht des Kontrollzentrums anzuzeigen.',
  enablingFocusInstruction2: 'Tippen Sie auf Fokus.',
  enablingFocusInstruction3:
    'Tippen Sie auf "Nicht stören" oder ein anderes Fokusprofil, das Sie aktivieren möchten.',
  enablingFocusInstruction4:
    'Der derzeit aktivierte Fokus scheint ausgewählt zu sein. Sie können erneut darauf tippen, um ihn zu deaktivieren.',
  startDateForRotation: 'Startdatum für die Rotation',
  startTimeForRotation: 'Startzeit für die Rotation',
  member: 'Mitglied',
  multipleShiftsInADay: 'Mehrere Schichten an einem Tag',
  escalationPolicy: 'Eskalationspolitik',
  atTimeOfEvent: 'Zur Zeit des Ereignisses',
  afterNMinutes: 'Nach {{count}} Minuten',
  afterNHours: {
    one: 'Nach 1 Stunde',
    other: 'Nach {{count}} Stunden'
  },
  afterDuration: 'Nach {{durationString}}',
  addTrigger: 'Auslöser hinzufügen',
  viewCode: 'Ansicht Code',
  apiCodes: 'API-Codes',
  viewIncidents: 'Ansicht Vorfälle',
  viewInstantAlarms: 'Sofortalarme anzeigen',
  viewTasks: 'Aufgaben anzeigen',
  incidentsForAlert: 'Vorfälle für Zuhörer {{alertName}}',
  timestamp: 'Zeitstempel',
  acknowledged: 'Anerkannt',
  noIncidentsForAlert: 'Noch keine Vorfälle für diesen Hörer',
  apiCodeCopiedToClipboard: 'Der API-Code wurde in die Zwischenablage kopiert.',
  triggerName: 'Auslöser {{index}}',
  delay: 'Verzögerung',
  chooseAssigneePlaceholder: 'Empfänger auswählen...',
  delayForTrigger: 'Verzögerung für Trigger',
  assigneeWillBeAlertedAfterDelay:
    'Der Abtretungsempfänger wird nach {{durationString}} benachrichtigt.',
  escalationForIncidentsForAlert:
    'Eskalation für Vorfälle unter {{incidentDate}} für Zuhörer {{alertName}}',
  alertIncidentAcknowledged:
    'Anerkannt von {{memberName}} unter {{dateString}}',
  alertIncidents: 'Vorfälle',
  viewingAlertIncidents: 'Ansicht von Vorfällen',
  createOrganization: 'Organisation erstellen',
  youAreNotPartOfAnyOrganization:
    'Sie sind nicht Teil einer Organisation. Erstellen Sie eine Organisation, um loszulegen.',
  tellUsAboutYourOrganization: 'Erzählen Sie uns von Ihrer Organisation',
  noActiveSubscription: 'Sie haben kein aktives Abonnement.',
  chooseOrganization: 'Wählen Sie eine Organisation aus, um fortzufahren.',
  noTriggersForIncident:
    'Es wurden keine Auslöser für diesen Vorfall gefunden.',
  role: 'Rolle',
  viewer: 'Betrachter',
  viewerNoLogin: 'Betrachter (Kein Login)',
  incidentCoordinator: 'Vorfallkoordinator',
  assignedListeners: 'Zugewiesene Zuhörer',
  assignedLabels: 'Zugewiesene Etiketten',
  noListenersAssignedToCoordinator:
    'Bitte weisen Sie dem Vorfallkoordinator mindestens einen Zuhörer oder ein Etikett zu.',
  recipientRole: 'Empfängerrolle',
  editor: 'Bearbeiter',
  recipientRoleTooltipMessage: `Sie können dem Empfänger erlauben, das Datum und die Uhrzeit des Alarms zu ändern.

Der Empfänger muss ein Galarm Premium-Abonnent sein, um das Datum und die Uhrzeit des Alarms zu ändern.`,
  recipientChangeDateTimePremiumDescription:
    'Das Ändern von Datum und Uhrzeit eines Buddy-Alarms ist eine Premium-Funktion. Upgrade auf Galarm Premium, um Datum und Uhrzeit dieses Alarms zu ändern.',
  recipientUpdatedAlarmDateAndTime:
    'Alarmzeit auf {{dateTimeString}} geändert. Der Ersteller wurde benachrichtigt.',
  recipientChangedAlarmTimeChatMessage:
    '{{username}} hat die Alarmzeit von {{originalTime}} auf {{newTime}} geändert',
  allowRecipientToChangeTime: 'Empfänger erlauben, die Alarmzeit zu ändern',
  enterpriseViewerRoleDescription:
    'Benutzer mit der Rolle Betrachter können zu Zuhörern hinzugefügt werden, um Vorfallalarme zu erhalten. Sie können sich auch in die Webanwendung einloggen, um Vorfälle und Zuhörer anzusehen, aber keine Änderungen vornehmen.',
  enterpriseViewerNoLoginRoleDescription:
    'Benutzer mit der Rolle Betrachter (Kein Login) können zu Zuhörern hinzugefügt werden, um Vorfallalarme zu erhalten. Sie können sich nicht in die Webanwendung einloggen, um Vorfälle und Zuhörer zu sehen.',
  enterpriseAdminRoleDescription:
    'Benutzer mit der Rolle Administrator können zu Zuhörern hinzugefügt werden, um Vorfallalarme zu erhalten. Sie können sich auch in die Webanwendung einloggen, um Vorfälle und Zuhörer anzusehen und Änderungen vorzunehmen.',
  enterpriseIncidentCoordinatorRoleDescription:
    'Benutzer mit der Rolle des Vorfallkoordinators können sich in die Anwendung einloggen, um Vorfälle für ihnen zugewiesene Zuhörer anzuzeigen. Sie können auch Vorfälle für diese Zuhörer über das Dashboard schließen.',
  findAppleOrder: 'Apple-Bestellung finden',
  incidentCoordinatorListenerLimitWarning:
    'Ihnen sind mehr als 30 Zuhörer zugewiesen. Nur die Vorfälle der ersten 30 werden hier angezeigt. Bitte kontaktieren Sie Ihren Administrator.',
  newOrganization: 'Neue Organisation',
  switchOrganization: 'Organisation wechseln',
  usageAnalytics: 'Nutzungsanalyse',
  incidentsOpened: 'Gesamtzahl der geöffneten Vorfälle',
  incidentsOpen: 'Offen',
  incidentsAcknowledged: 'Anerkannt',
  incidentsClosed: 'Geschlossen',
  incidentsAutoClosed: 'Automatisch geschlossen',
  alarmsSent: 'Gesendete Alarme',
  avgTimeToAcknowledge: 'Durchschn. Zeit zur Anerkennung',
  avgTimeToResolve: 'Durchschn. Zeit zur Lösung',
  noAnalyticsData:
    'Noch keine Analysedaten verfügbar. Daten werden aufgezeichnet, wenn Vorfälle und andere Ereignisse auftreten.',
  dailyTrend: 'Täglicher Trend (letzte 30 Tage)',
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  numbersView: 'Zahlen',
  chartView: 'Diagramm',
  last7Days: 'Letzte 7 Tage',
  last30Days: 'Letzte 30 Tage',
  last90Days: 'Letzte 90 Tage',
  last6Months: 'Letzte 6 Monate',
  lastYear: 'Letztes Jahr',
  noOrganizations: 'Sie sind nicht Teil einer Organisation.',
  maxOrganizationsReached:
    'Ein Benutzer kann höchstens 10 Organisationen angehören.',
  yourOrganizations: 'Organisationen',
  urlNotFound: 'Die URL stimmt mit keiner unterstützten Route überein.',
  triggerAlert: 'Auslösender Vorfall',
  recaptchaFailed: 'reCAPTCHA-Überprüfung fehlgeschlagen. {{error}}',
  loadingAccountInformation: 'Laden von Kontoinformationen',
  loadingAuthInfo: 'Laden von Authentifizierungsinformationen',
  allAlerts: 'Alle Hörer',
  recentlyTriggeredAlerts: 'Kürzlich ausgelöste Hörer',
  recentlyClosedIncidents: 'Kürzlich abgeschlossene Vorfälle',
  noRecentlyTriggeredAlerts: 'In letzter Zeit wurden keine Hörer ausgelöst.',
  noRecentlyClosedIncidents:
    'In letzter Zeit wurden keine Vorfälle abgeschlossen.',
  closedAt: 'Geschlossen am {{dateTimeString}}',
  dashboard: 'Dashboard',
  viewIncidentEscalation: 'Ansicht Vorfall-Eskalation',
  closeIncident: 'Vorfall schließen',
  closingIncident: 'Abschließendes Ereignis',
  unableToRefreshEnterpriseAccount: 'Sie können Ihr Konto nicht aktualisieren.',
  viewAuthToken: 'Ansicht Auth Token',
  problemWithCreatingAuthToken:
    'Es gab ein Problem bei der Erstellung eines Authentifizierungstokens. Bitte kontaktieren Sie den technischen Support.',
  authToken: 'Auth Token',
  authTokenWarningMessage:
    'Bewahren Sie dieses Authentifizierungs-Token zu jeder Zeit sicher auf. Geben Sie es nicht an Dritte weiter. Wenn Sie glauben, dass Ihr API-Schlüssel kompromittiert wurde, tippen Sie oben auf die Schaltfläche "Ändern", um ihn zu ändern. Nachdem Sie das Token geändert haben, müssen Sie das neue Token an allen Stellen angeben, an denen Sie Vorfälle über die REST-API auslösen',
  authTokenCopiedToClipboard:
    'Das Auth-Token wurde in die Zwischenablage kopiert.',
  resendVerificationEmail: 'Verifizierungs-E-Mail erneut senden',
  loggedInUsingEmail: 'Eingeloggt mit E-Mail {{email}}.',
  checkingIfMemberIsAppUser: 'Prüfen, ob das Mitglied ein App-Benutzer ist.',
  settingMemberDetails: 'Einstellen der Details eines Mitglieds.',
  addingTeam: 'Team hinzufügen.',
  editingTeam: 'Das Redaktionsteam.',
  addingRotation: 'Hinzufügen von Rotation.',
  editingRotation: 'Rotation der Bearbeitung.',
  assigningKeyToMember: 'Zuweisung eines Schlüssels an ein Mitglied.',
  revokingKeyFromMember: 'Entzug des Schlüssels eines Mitglieds.',
  deletingTeam: 'Löschung des Teams.',
  deletingRotation: 'Löschen der Rotation.',
  addingAlert: 'Hinzufügen eines Hörers.',
  editingAlert: 'Hörer editieren.',
  deletingAlert: 'Löschung des Hörers.',
  triggeringAlert: 'Auslösendes Ereignis.',
  creatingOrganizationAccount: 'Erstellen eines Organisationskontos.',
  creatingCheckoutSession: 'Starten Sie Ihre Checkout-Sitzung.',
  creatingAnAccountForMember: 'Erstellen eines Kontos für ein Mitglied.',
  passwordResetEmailSent:
    'Wir haben Ihnen eine E-Mail geschickt, um Ihr Passwort zurückzusetzen. Ändern Sie Ihr Passwort und melden Sie sich erneut an.',
  changeOwner: 'Besitzer wechseln',
  changeOrganizationOwner: 'Organisationseigentümer ändern',
  newOwnerEmail: 'E-Mail des neuen Besitzers',
  saveOnYearlySubscription: 'Speichern {{percent}}%',
  annual: 'Jährlich',
  resetAlarms: 'Alarme aktualisieren',
  resetAlarmsAlert:
    'Alle Alarme wurden aufgefrischt. Wenn Sie weiterhin Probleme mit den Alarmen feststellen, reichen Sie bitte ein Ticket über die Option "Problem melden" ein.',
  resetAlarmsTooltipMessage:
    'Wenn Sie Probleme mit Alarmen haben, wie z. B. gelöschte Alarme, die auf dem Telefon klingeln, aktualisieren Sie bitte die Alarme mit dieser Option. Wenn das Problem weiterhin besteht, reichen Sie bitte ein Ticket über die Option "Problem melden" ein.',
  resetTempPassword: 'Temporäres Passwort zurücksetzen',
  currPassword: 'Aktuelles Passwort',
  tempPassword: 'Temporäres Passwort',
  newPassword: 'Neues Passwort',
  reset: 'Zurücksetzen',
  loggingIn: 'Einloggen',
  resettingTempPassword: 'Temporäres Passwort zurücksetzen',
  changingPassword: 'Passwort ändern',
  numSeats: 'Anzahl der Sitze',
  helpMeDecide: 'Helfen Sie mir zu entscheiden',
  numEnterpriseSeatsHelper:
    'Sie sollten die Anzahl der Sitze als die Anzahl der Personen in Ihrer Organisation wählen, die die App zum Empfang von Vorfällen verwenden werden. Bei der Konfiguration eines Hörers können Sie dessen Eskalationsrichtlinie festlegen. In einer Eskalationsrichtlinie können Sie mehrere Stufen festlegen. Sie können zum Beispiel festlegen, dass die erste Eskalationsstufe an ein Team von 3 Personen geht. Wenn die erste Eskalationsstufe nicht innerhalb von 5 Minuten reagiert, geht die zweite Eskalationsstufe an ein Team von 5 Personen. In diesem Fall können Sie die Anzahl der Plätze auf 8 festlegen.',
  numBusinessSeatsHelper:
    'Wählen Sie die Anzahl der Plätze entsprechend der Anzahl der Personen, die Galarm für den Empfang von Alarmen und Erinnerungen nutzen werden.',
  perSeatPrice: '{{price}} pro {{interval}} pro Sitzplatz',
  doneForToday: 'Anerkannt',
  getStarted: "Los geht's",
  firstAlertInstructions: 'Anweisungen für den ersten Hörer',
  learnMoreAboutGalarmEnterprise: 'Erfahren Sie mehr über Galarm Pro',
  home: 'Startseite',
  team: 'Team',
  alert: 'Alarmierung',
  listener: 'Hörer',
  forgotPassword: 'Passwort vergessen?',
  forgotPasswordTitle: 'Passwort vergessen',
  sendPasswordResetEmail: 'E-Mail zum Zurücksetzen des Passworts senden',
  sendingPasswordResetEmail: 'E-Mail zum Zurücksetzen des Passworts senden',
  field: 'Feld',
  description: 'Beschreibung',
  requestIntegration: 'Weitere Integration anfordern',
  integrationDetails: 'Details zur Integration',
  enterIntegrationDetails: 'Details zur Integration bereitstellen',
  galarmEnterpriseFreeTrial:
    'Registrieren Sie sich für einen 14-tägigen kostenlosen Test',
  galarmEnterpriseFreeTrialDescription:
    'Automatisieren Sie das Vorfallmanagement',
  bySigningUpYouAgreeToOur: 'Mit der Anmeldung erklären Sie sich mit unseren',
  and: 'und',
  alarmSubscribers: 'Alarm Follower',
  otherSubscribersCount: {
    one: '1 weiterer Follower nicht in Ihren Kontakten',
    other: '{{count}} mehr Follower, die nicht in Ihren Kontakten sind'
  },
  getAccountData: 'Alarmdaten exportieren',
  getAccountDataPrompt:
    'Geben Sie eine E-Mail-Adresse an, an die wir eine Textdatei mit allen Ihren Alarmen senden werden.',
  getAccountDataConfirmation:
    'Bitte beachten Sie, dass wir Ihnen eine Textdatei mit allen Ihren Alarmen per E-Mail an {{email}} zusenden werden.',
  sendingAccountData: 'Exportieren von Alarmdaten...',
  sentAccountData: 'Alarmdaten werden an {{email}} gesendet.',
  errorSendingAccountData: 'Fehler beim Exportieren von Alarmdaten: {{error}}',
  sendingEmailVerificationLink: 'E-Mail-Verifizierungslink senden',
  viewLogs: 'Ansicht Logs',
  message: 'Nachricht',
  billing: 'Rechnungsstellung',
  newIncidentForAlert: 'Neues Ereignis für Hörer {{alertName}}',
  triggerFailureForAlert:
    'Auslösen des Hörers {{alertName}} fehlgeschlagen: {{error}}',
  clickNextAfterAddingMembers:
    'Klicken Sie nach dem Hinzufügen von Mitgliedern auf "Weiter".',
  clickDoneAfterAddingAlerts:
    'Klicken Sie auf "Erledigt", um die Einrichtung abzuschließen und zum Dashboard zu gelangen.',
  alertCreatedSuccessfully:
    'Der Listener wurde erfolgreich erstellt. Sie können diesen Listener über das Menüsymbol mit den drei Punkten vor dem Namen des Listeners auslösen.',
  fixSubscription: 'Fix-Abonnement',
  fixSubscriptionDescription:
    'Wir haben ein Problem mit Ihrem Abonnement festgestellt. Ihr Abonnement enthält {{numSeats}} Platz(e), aber Sie haben Schlüssel an {{numSeatsAssigned}} Mitglied(er) vergeben. Sie können höchstens {{numSeats}} Schlüssel zuweisen.',
  fixSubscriptionChooseOption:
    'Bitte korrigieren Sie Ihr Abonnement mit einer der unten aufgeführten Optionen.',
  fixSubscriptionContactAdmin:
    'Bitte kontaktieren Sie den Administrator Ihrer Organisation.',
  unassignKeysFromMembers:
    'Heben Sie die Zuweisung von mindestens {{extraKeysAssigned}} Schlüssel(n) von Mitgliedern auf',
  addMoreSeatsToSubscription:
    'Fügen Sie Ihrem Abonnement mindestens {{extraKeysAssigned}} Platz(e) hinzu.',
  revokeMembersKey: 'Schlüssel der Mitglieder widerrufen',
  revokeMembersKeyDescription:
    'Wählen Sie die Mitglieder aus, deren Schlüssel Sie widerrufen möchten.',
  revoke: 'Widerrufen',
  unableToRevokeMembersKey:
    'Es ist ein Fehler beim Entzug des Schlüssels eines Mitglieds aufgetreten. Bitte kontaktieren Sie den Support.',
  problemWithLoadingProducts: 'Problem beim Laden von Produkten. {{error}}',
  verificationCompleted: 'Überprüfung abgeschlossen',
  deviceAlreadyRegistered:
    'Diese Rufnummer wurde bereits auf diesem Gerät verifiziert.',
  phoneNumberAutoFilled:
    'Galarm verwendet die ausgewählte Telefonnummer aus Ihrem Google-Konto.',
  unableToRegisterPreVerifiedUser:
    'Vorverifizierter Benutzer kann nicht registriert werden.',
  allowNotifications: 'Benachrichtigungen zulassen',
  allowNotificationsDescription: 'Um Alarme anzuzeigen, wenn sie klingeln.',
  scheduleExactAlarms: 'Zeitplan für Alarme',
  scheduleExactAlarmsHelperText:
    'Erlauben Sie Galarm, Alarme zur genauen Zeit zu klingeln.',
  scheduleExactAlarmsDescription:
    'Um Alarme genau zur richtigen Zeit klingeln zu lassen.',
  disableBatteryOptimization: 'Verwalten der Batterie-Optimierung',
  disableBatteryOptimizationDescription:
    'Um Galarm im Hintergrund laufen zu lassen.',
  requestRequiredPermissions:
    'Galarm benötigt die folgenden Berechtigungen, um Alarme zu klingeln',
  allowDisallowedPermissions: 'Antippen, um zuzulassen',
  notificationsAreEnabled:
    'Die Erlaubnis, Benachrichtigungen anzuzeigen, ist bereits erteilt.',
  connectingToStore: 'Verbindung zum Speicher...',
  restartApp: 'App neu starten',
  updateAvailable: 'Update verfügbar',
  english: 'Englisch',
  russian: 'Russisch',
  german: 'Deutsch',
  french: 'Französisch',
  spanish: 'Spanisch',
  italian: 'Italienisch',
  portuguese: 'Portugiesisch',
  japanese: 'Japanisch',
  korean: 'Koreanisch',
  indonesian: 'Indonesisch',
  changeAppLanguage: 'App-Sprache ändern',
  appLanguage: 'App Sprache',
  iosChangeAppLanguagePara1:
    'Galarm wählt die Sprache der App aus den Einstellungen Ihres Telefons aus. Bitte folgen Sie diesen Schritten, um die Sprache der App für Galarm zu ändern:',
  iosChangeAppLanguageInstruction1:
    'Öffnen Sie "Telefoneinstellungen > Allgemein > Sprache & Region". Stellen Sie sicher, dass die Sprache, die Sie für Galarm verwenden möchten, in der Liste der bevorzugten Sprachen enthalten ist.',
  iosChangeAppLanguageInstruction2:
    'Gehen Sie zurück zu den "Telefoneinstellungen" und tippen Sie auf "Galarm" in der Liste der Apps am unteren Rand.',
  iosChangeAppLanguageInstruction3:
    'Tippen Sie auf "Sprache" und wählen Sie die Sprache, die Sie für Galarm einstellen möchten. Kehren Sie zur App zurück, nachdem Sie die Sprache ausgewählt haben',
  androidChangeAppLanguagePara1:
    'Galarm wählt die Sprache der App aus den Einstellungen Ihres Telefons aus. Bitte folgen Sie diesen Schritten, um die Sprache der App für Galarm zu ändern:',
  androidChangeAppLanguageInstruction1:
    'Tippen Sie unten auf die Schaltfläche "App-Einstellungen öffnen".',
  androidChangeAppLanguageInstruction2:
    'Tippen Sie auf "Sprache" und wählen Sie die Sprache, die Sie für Galarm verwenden möchten.',
  androidChangeAppLanguageInstruction3:
    'Nachdem Sie die Sprache ausgewählt haben, kehren Sie hierher zurück und klicken Sie unten auf die Schaltfläche "App neu starten".',
  problemRetrievingSubscriptionData:
    'Beim Abrufen Ihrer Abonnementinformationen ist ein Problem aufgetreten. Wir leiten Sie jetzt zur Kontoseite weiter. Bitte überprüfen Sie Ihren Abonnementstatus und kontaktieren Sie den technischen Support, wenn Sie weiterhin Probleme haben.',
  deletingOrganization: 'Löschung der Organisation...',
  deleteOrganization: 'Organisation löschen',
  deleteOrganizationDescription:
    'Sind Sie sicher, dass Sie Ihre Organisation löschen möchten?\n  \n  Dies ist ein irreversibler Vorgang. Alle Daten Ihrer Organisation werden gelöscht.\n  \n  Bitte stellen Sie sicher, dass Sie Ihr Abonnement abgebrochen haben, bevor Sie die Organisation löschen.',
  galarmEnterpriseTrialDescription:
    'Es gibt eine 14-tägige kostenlose Testphase, in der Sie das Abo kostenlos abbrechen können.',
  galarmEnterpriseTrialAlreadyAvailed:
    'Sie haben die 14-tägige kostenlose Testversion bereits in Anspruch genommen. Kontaktieren Sie den Support, wenn Sie mehr Zeit benötigen, um das Produkt zu testen.',
  signinWithGoogle: 'Mit Google anmelden',
  signinWithGithub: 'Mit GitHub anmelden',
  verifyAccount: 'Konto verifizieren',
  verifyAccountMessage:
    'Sie sollten eine E-Mail mit einem Bestätigungscode erhalten haben. Geben Sie den Code unten ein, um Ihr Konto zu verifizieren. Wenn Sie den Code nicht erhalten haben, können Sie einen neuen Code anfordern, indem Sie auf die Schaltfläche "Code erneut senden" klicken.',
  verificationCode: 'Verifizierungscode',
  optionalString: '{{string}}',
  quickReminderTitle: 'Titel (optional)',
  accountVerified: 'Konto verifiziert',
  accountVerifiedMessage: 'Bitte melden Sie sich mit Ihren Anmeldedaten an.',
  multipleUsersWithSameEmail:
    'Es gibt mehrere Benutzer mit derselben E-Mail. Bitte kontaktieren Sie den Support.',
  multipleUsersWithSameMobileNumber:
    'Es gibt mehrere Benutzer mit derselben Handynummer. Bitte kontaktieren Sie den Support.',
  startTrial: 'Versuch starten',
  nextSteps: 'Nächste Schritte',
  firstTimeSetupComplete:
    'Sie haben die Ersteinrichtung von Galarm Enterprise abgeschlossen und Ihren ersten Hörer erstellt. Im Folgenden finden Sie einige nächste Schritte, die Sie von hier aus unternehmen können.',
  testTheAlertInstruction:
    'Lesen Sie die Anweisungen unter {{link}}, um zu erfahren, wie Sie den soeben erstellten Hörer testen können.',
  integrateTheAlertInstruction:
    'Schauen Sie sich die Anweisungen unter {{link}} an, um den Listener mit verschiedenen Überwachungsprogrammen zu integrieren.',
  createMoreAlertsInstruction:
    'Sie können weitere Hörer hinzufügen, indem Sie auf die Registerkarte "Hörer" auf der linken Seite gehen.',
  addMoreMembersInstruction:
    'Sie können weitere Mitglieder hinzufügen, indem Sie auf die Registerkarte "Mitglieder" auf der linken Seite gehen.',
  createTeamsInstruction:
    'Sie können die Mitglieder in "Teams" gruppieren und ein ganzes Team alarmieren, wenn ein Vorfall eintritt. Erstellen Sie Teams auf der Registerkarte "Teams" auf der linken Seite und verwenden Sie sie in der Konfiguration des Hörers.',
  testTheAlert: 'Testen Sie den Listener',
  integrateTheAlert: 'Integrieren Sie den Listener',
  createMoreAlerts: 'Mehr Zuhörer schaffen',
  addMoreMembers: 'Weitere Mitglieder hinzufügen',
  createTeams: 'Teams erstellen',
  contactSupport: 'Kontakt zum Support',
  pastDue: 'Überfällig',
  canceled: 'Abgebrochen',
  unpaid: 'Unbezahlt',
  incomplete: 'Unvollständig',
  incomplete_expired: 'Unvollständig Abgelaufen',
  trialing: 'Kostenlose Testversion',
  paused: 'Pausiert',
  plan: 'Plan',
  status: 'Status',
  renewsOn: 'Erneuert am',
  yourRoles: 'Ihre Rollen',
  enterprisePlan: '{{quantity}} Sitze, erneuert jede {{interval}}',
  currentOrganization: 'Aktuelle Organisation',
  useThisOrganization: 'Verwenden Sie diese Organisation',
  fixPayment: 'Zahlung fixieren',
  fixingPayment: 'Festsetzung der Zahlung',
  addPaymentInformation: 'Zahlungsinformationen hinzufügen',
  noPaymentInformationAvailable:
    'Keine Zahlungsinformationen verfügbar. Bitte aktualisieren Sie die Seite, wenn Sie kürzlich Zahlungsinformationen hinzugefügt haben.',
  openBillingPortal: 'Abrechnungsportal öffnen',
  startupWizardDescription:
    'Dieser Assistent hilft Ihnen bei den ersten Schritten und der Erstellung Ihres ersten Hörers.',
  userNotFound: 'Benutzer nicht gefunden',
  wrongPassword: 'Falsches Passwort',
  emailAlreadyInUse: 'E-Mail bereits in Gebrauch',
  restoreDeletedAlarms: 'Gelöschte Alarme wiederherstellen',
  deleteAlarmAlert:
    'Gelöschte Alarme können unter "Zuletzt gelöschte Alarme" wiederhergestellt werden. Sie können sie durch Tippen auf das Drei-Punkte-Menü (⋮) oben rechts auf der Registerkarte "Alarme" anzeigen.\n\nGelöschte Alarme bleiben dort 30 Tage lang gespeichert, danach werden sie endgültig gelöscht.',
  slackVerificationCode:
    'Ihr Slack-Verifizierungscode lautet {{verificationCode}}.',
  dndAccess: 'Bitte nicht stören Zugang',
  dndHelperText:
    'Erlauben Sie Galarm, Alarme zu klingeln, wenn Ihr Telefon auf "Nicht stören" eingestellt ist.',
  cantRestoreInstantAlarmMessage:
    'Sofortige Alarme können nicht wiederhergestellt werden. Sie können bei Bedarf den Chat und andere Informationen zu diesem Alarm anzeigen. Dieser Alarm wird 30 Tage nach der Löschung dauerhaft entfernt.',
  upgradeToUnlockAllFeatures:
    'Aktualisierung zur Freischaltung aller Funktionen',
  otherSignupOptions: 'Andere Anmeldemöglichkeiten:',
  renewSubscription: 'Abonnement verlängern',
  subscriptionOnHold:
    'In Wartestellung (Ihr Plan erlaubt {{subscriptionQty}} Plätze\naber Sie haben {{numSubscriptionKeys}} Plätze zugewiesen.',
  checklists: 'Aufgaben',
  checklist: 'Aufgabenliste',
  typeToAddTask: 'Typ zum Hinzufügen der Aufgabe',
  specifyTaskName: 'Aufgabenname angeben',
  otherChecklists: 'Aufgabenlisten',
  defaultChecklistName: 'unbetitelt',
  addTasksToChecklist:
    'Fügen Sie Aufgaben über das Eingabefeld am unteren Rand hinzu',
  addTasksToDefaultChecklist:
    'Fügen Sie Aufgaben über das Eingabefeld unten hinzu... oder beginnen Sie eine neue Aufgabenliste, indem Sie auf die Schaltfläche + oben rechts klicken.',
  createNewChecklist:
    'Sie können neue Aufgabenlisten erstellen, um verwandte Aufgaben an einem Ort zu verfolgen.',
  addNewChecklist: 'Neue Aufgabenliste',
  alarmPhoto: 'Alarm Foto',
  alarmPhotoFeatureTitle: 'Alarm Foto',
  alarmPhotoFeatureDescriptionPremiumUser:
    'Mit dieser Funktion können Sie einem Alarm ein Foto hinzufügen, um schnelle visuelle Hinweise zu geben, z. B. ein Foto von einem Medikament, Anweisungen für eine Aufgabe, einem Gegenstand usw. Das Foto wird angezeigt, wenn der Alarm klingelt.',
  alarmPhotoFeatureDescriptionFreeUser:
    'Mit dieser Funktion können Sie einem Alarm ein Foto hinzufügen, um schnelle visuelle Hinweise zu geben, z. B. ein Foto von einem Medikament, Anweisungen für eine Aufgabe, einem Gegenstand usw. Das Foto wird angezeigt, wenn der Alarm klingelt.\n  \nDies ist eine Premium-Funktion. Um diese Funktion nutzen zu können, werden Sie aufgefordert, eine Aktualisierung auf Premium vorzunehmen.',
  alarmPhotoPremiumFeature: 'Foto zu Alarmnotizen hinzufügen',
  installPendingAppUpdate:
    'Das neueste App-Update wurde heruntergeladen und ist bereit zur Installation.',
  numTasks: {
    zero: 'Keine Aufgaben',
    one: '1 Aufgabe',
    other: '{{count}} Aufgaben'
  },
  numTasksWithCompleted: {
    one: '1 Aufgabe, {{completed}} abgeschlossen',
    other: '{{count}} Aufgaben, {{completed}} abgeschlossen'
  },
  muteAlarms: 'Alarme stummschalten',
  unmuteAlarms: 'Alarme stumm schalten',
  alarmsAreMuted:
    'Alle Ihre Alarme sind derzeit stummgeschaltet. Tippen Sie auf , um die Stummschaltung aufzuheben.',
  alarmsHaveBeenMuted:
    'Ihre Alarme wurden stummgeschaltet. Sie klingeln erst wieder, wenn Sie die Stummschaltung aufheben.',
  alarmsHaveBeenUnmuted:
    'Ihre Alarme wurden entstummt. Sie sollten wie konfiguriert klingeln.',
  deleteChecklist: 'Aufgabenliste löschen',
  confirmDeleteChecklist: 'Aufgabenliste löschen?',
  confirmDeleteCompletedTasks: 'Erledigte Aufgaben löschen?',
  confirmResetCompletedTasks: 'Erledigte Aufgaben zurücksetzen?',
  confirmDeleteTask: '{{taskName}} löschen?',
  showCompletedTasks: 'Erledigte Aufgaben anzeigen',
  hideCompletedTasks: 'Erledigte Aufgaben ausblenden',
  deleteCompletedTasks: 'Erledigte Aufgaben löschen',
  resetCompletedTasks: 'Erledigte Aufgaben zurücksetzen',
  yourGroups: 'Ihre Gruppen',
  newAlarmWith: 'Neuer Alarm mit {{name}}',
  newGroupWith: 'Neue Gruppe mit {{name}}',
  alertContact: 'Alarmierung {{name}}',
  alertGroup: 'Alarmierung {{name}}',
  instantAlarmMovedToFabNotice:
    'Die Sofortalarm-Funktion ist jetzt über die “+” Schaltfläche unten rechts auf diesem Bildschirm verfügbar. Das “Lautsprecher”-Symbol wird in einer zukünftigen Version aus der oberen rechten Ecke entfernt.',
  tasksIntroTitle: 'Aufgaben und Aufgabenlisten',
  tasksIntroDescription:
    'Aufgaben sind Ihre Aufgaben, die keine Frist haben. Sie können sie hier schnell hinzufügen und verwalten, indem Sie sie abhaken, wenn Sie eine Aufgabe erledigen.\n\nSie können auch Aufgabenlisten erstellen, um ähnliche Aufgaben zu gruppieren. Sie können z. B. eine Aufgabenliste für Ihre Lebensmitteleinkäufe erstellen, eine andere für Ihre Arbeitsaufgaben und so weiter.',
  groupsMovedToContactsScreen:
    '"Gruppen" wurden in dieser Registerkarte zusammengeführt. Ihre Gruppen erscheinen oben unter "Ihre Gruppen". Sie können neue Gruppen erstellen, indem Sie unten rechts auf die Schaltfläche "+" tippen.',
  loadingTasks: 'Aufgaben laden...',
  tryPremium: 'Premium ausprobieren',
  buyPremiumToUnlockFeature:
    'Dies ist eine Premium-Funktion. Schalten Sie diese und viele andere coole Funktionen mit unserem Premium-Abo frei, das Sie 14 Tage lang kostenlos testen können.',
  newTask: 'Neue Aufgabe',
  newTaskList: 'Neue Aufgabenliste',
  enterTaskName: 'Aufgabenname eingeben',
  enterTaskListName: 'Name der Aufgabenliste eingeben',
  taskName: 'Aufgabe Name',
  taskListName: 'Name der Aufgabenliste',
  checklistTasks: '{{name}}',
  editTaskListName: 'Name der Aufgabenliste bearbeiten',
  editTask: 'Aufgabe bearbeiten',
  currentRelease: '(derzeit installiert)',
  id: 'ID',
  subscriptionData: 'Abonnement-Daten',
  organizations: 'Organisationen',
  showRotationCalendar: 'Rotationskalender anzeigen',
  rotationCalendar: 'Rotationskalender',
  editShift: 'Verschiebung bearbeiten',
  startDateForShift: 'Datum des Schichtbeginns',
  startTimeForShift: 'Zeit für den Schichtbeginn',
  endDateForShift: 'Enddatum der Schicht',
  endTimeForShift: 'Zeit für das Schichtende',
  editingShift: 'Editierschicht',
  addingShift: 'Hinzufügen einer Schicht',
  products: 'Produkte',
  prices: 'Pläne',
  planType: 'Plan Typ',
  business: 'Business',
  enterprise: 'Unternehmen',
  compare: 'Vergleichen Sie',
  apiSupport: 'API-Unterstützung zur Überwachung von Diensten',
  accessToConsoleToViewAndCloseIncidents:
    'Dashboard zur Verwaltung von Vorfällen',
  triggerInstantAlertsFromTheConsole:
    'Auslösen von Vorfällen über die Enterprise Console',
  coreFeatures: 'Wesentliche Merkmale:',
  everythingInBusiness: 'Alles in Businessplan und:',
  updatePlanInstructions:
    'Sie können Ihren Plan aktualisieren, indem Sie auf die Schaltfläche "Abrechnungsportal öffnen" auf der rechten Seite klicken und im Abrechnungsportal die Schaltfläche "Plan aktualisieren" wählen.',
  membersDescription:
    'Sie haben {{subscriptionKeysCount}} Plätze gekauft - {{assignedSubscriptionKeysCount}} zugewiesen und {{unassignedSubscriptionKeysCount}} verfügbar. Ein Häkchen vor dem Namen eines Mitglieds bedeutet, dass es einen zugewiesenen Sitzplatz hat.',
  wizardMembersDescription:
    'Beginnen Sie damit, die Personen hinzuzufügen, die benachrichtigt werden sollen, wenn ein Alarm ausgelöst wird. Ein Mitglied ist jeder in Ihrer Organisation, der Vorfallbenachrichtigungen auf seinem Telefon über die Galarm-App erhalten muss.',
  wizardAlertsDescription:
    'Fügen Sie nun einen Listener hinzu, mit dem Sie konfigurieren können, wen Sie benachrichtigen möchten, wenn in Ihrer Organisation Vorfälle auftreten. Sie können auch konfigurieren, wie Vorfälle eskaliert werden, wenn sie nicht rechtzeitig bestätigt werden. Sobald Sie einen Listener erstellt haben, können Sie auf dessen Webhook-URL zugreifen, um Vorfälle von Ihren Überwachungstools aus dem Listener-Menü auszulösen. Sie können auch manuell einen Vorfall aus dem Listener-Menü auslösen.',
  centralBilling: 'Zentrale Abrechnung',
  saveTwoMonths: '2 Monate speichern',
  owner: 'Eigentümer',
  enterpriseAccountSummary:
    'Sie gehören zu der Organisation {{organizationName}}, die für den Plan Galarm Pro {{planType}} angemeldet ist.',
  perYearPerUser: 'pro Nutzer/Jahr',
  perMonthPerUser: 'pro Benutzer/Monat',
  creationDate: 'Datum der Erstellung',
  updatePhoneNumber: 'Telefonnummer ändern',
  confirmCountryCodeAndEnterUpdatedPhoneNumber:
    'Bitte bestätigen Sie die Landesvorwahl und geben Sie Ihre neue Telefonnummer ein. Ihr Konto wird mit dieser Telefonnummer verknüpft, nachdem Sie die Überprüfung abgeschlossen haben.',
  unableToUpdatePhoneNumber:
    'Die Rufnummer kann nicht geändert werden: {{error}}. Bitte kontaktieren Sie den Support.',
  phoneNumberUpdated: 'Rufnummer erfolgreich geändert.',
  phoneNumberUpdatedMessage:
    'Sie können die App ganz normal verwenden. Bitten Sie Ihre Kontakte, Ihre Rufnummer in ihrem Adressbuch zu aktualisieren.',
  memberChangedPhoneNumber:
    '{{memberName}} hat seine Rufnummer geändert. Bitte aktualisieren Sie Ihr Adressbuch, um sie weiterhin zu Ihren Alarmen hinzuzufügen.',
  preferredSourceForIncidents: 'Bevorzugte Quelle für Vorfälle',
  apiCodesDescription:
    'Verwenden Sie die folgenden Anweisungen, um den Hörer in eine Quelle zu integrieren',
  rotation: 'Drehung',
  noAlarmsForThisDay: 'Keine Alarme für diesen Tag',
  markAlarmsAsComplete: 'Alarme als abgeschlossen markieren',
  markAlarmsAsCompleteExplanation:
    'Einmalige Alarme werden als abgeschlossen markiert und erscheinen in der Rubrik "Inaktive" Alarme.\n\nWiederholte Alarme werden als abgeschlossen markiert und zum nächsten Ereignis verschoben.',
  enterIncidentPrefix: 'Maximal 5 Zeichen',
  incidentPrefix: 'Vorfall-Präfix',
  incidentPrefixAlreadyExists: 'Vorgangs-Präfix existiert bereits',
  removeTask: 'Aufgabe entfernen?',
  incidentPrefixLengthExceeded: 'Vorfallpräfix ist länger als 5 Zeichen',
  criticalAlerts: 'Kritische Alarme',
  criticalAlertsConfiguration:
    'Der Alarm klingelt mit {{criticalAlertsVolume}}% Lautstärke, auch wenn Ihr Telefon stummgeschaltet oder ein Fokus eingeschaltet ist.',
  criticalAlertsDisabledShort:
    'Der Alarm klingelt nicht, wenn Ihr Telefon stummgeschaltet ist.',
  criticalAlertsConfigurationGlobal:
    'Alarme klingeln mit {{criticalAlertsVolume}}% Lautstärke, auch wenn Ihr Telefon stummgeschaltet ist oder ein Fokus eingeschaltet ist.',
  criticalAlertsDisabledShortGlobal:
    'Alarme klingeln nicht, wenn Ihr Telefon stummgeschaltet ist.',
  criticalAlertsEnabled:
    'Kritische Alarme sind aktiviert. Alarme klingeln auch dann, wenn Ihr Telefon stummgeschaltet oder ein Fokus eingeschaltet ist.',
  criticalAlertsDisabled:
    'Kritische Alarme sind deaktiviert. Alarme klingeln nicht, wenn Ihr Telefon stummgeschaltet ist.',
  enableCriticalAlerts: 'Aktivieren Sie kritische Alarme',
  summer_soft: 'Weicher Sommer',
  beeps: 'Pieptöne',
  bollywood_nights: 'Bollywood-Nächte',
  gentle_reminder: 'Sanfte Erinnerung',
  himalayan_piper: 'Himalaya-Waldmeister',
  holiday_joy: 'Urlaubsfreude',
  hollywood_adventure: 'Hollywood-Abenteuer',
  melody: 'Melody',
  morning_rooster: 'Morgenhahn',
  morning_sunshine: 'Morgensonne',
  sweet_sea: 'Süßes Meer',
  old_school_ring: 'Tring Tring',
  MyAlarmNotification: '{{alarmName}} - Es ist an der Zeit.',
  ParticipantCascadingAlarmNotification:
    '{{alarmName}} - Es ist an der Zeit, {{alarmCreatorName}} zu erinneren.',
  ParticipantSimultaneousAlarmNotification:
    '{{alarmName}}. Es ist an der Zeit, Ihre Teilnahme zu bestätigen.',
  InstantAlarmNotification:
    '{{alarmName}}. Wir bitten um Ihre sofortige Aufmerksamkeit.',
  MyAlarmNotificationShort: 'Es ist an der Zeit.',
  ParticipantCascadingAlarmNotificationShort:
    'Es ist an der Zeit, {{alarmCreatorName}} zu erinneren.',
  ParticipantSimultaneousAlarmNotificationShort:
    'Es ist an der Zeit, Ihre Teilnahme zu bestätigen.',
  InstantAlarmNotificationShort: 'Wir bitten um Ihre sofortige Aufmerksamkeit.',
  MyRecipientAlarmNotification:
    '{{alarmName}} - Es ist an der Zeit, {{alarmRecipientName}} zu erinneren.',
  MyRecipientAlarmNotificationShort:
    'Es ist an der Zeit, {{alarmRecipientName}} zu erinneren.',
  RecipientAlarmNotification:
    '{{alarmName}} (von {{alarmCreatorName}}) - Es ist Zeit.',
  RecipientAlarmNotificationShort:
    'Es ist die Zeit – von {{alarmCreatorName}}.',
  selectADate: 'Bitte wählen Sie ein Datum, um die Alarme anzuzeigen',
  cantUpdateTimezoneForAllAlarms:
    'Zeitzone für bestehende Alarme kann nicht aktualisiert werden',
  cantUpdateRingtonesForAllAlarms:
    'Einstellungen für Klänge und Vibrationen bei bestehenden Alarmen können nicht aktualisiert werden',
  preReminderWillRingAt: {
    zero: 'Eine Vorab-Erinnerung für diesen Alarm klingelt \nunter {{timeString}}.',
    one: 'Eine Vorab-Erinnerung für diesen Alarm klingelt \nunter {{timeString}} am Vortag.',
    other:
      'Eine Vorab-Erinnerung für diesen Alarm klingelt \nunter {{timeString}} {{count}} Tage vorher.'
  },
  verficationCodeInfo:
    'Sie erhalten eine Textnachricht oder einen Anruf mit einem 4-stelligen Code.',
  verficationCodeInfoWhatsApp:
    'Sie erhalten dann eine WhatsApp-Nachricht mit einem 4-stelligen Code.',
  deletePastAlarmsNotificationMessage:
    'Sie haben mehrere inaktive Alarme. Bitte löschen Sie die Alarme, die Sie nicht mehr benötigen.',
  confirmCountryCodeAndEnterNumber:
    'Bitte bestätigen Sie Ihre Landesvorwahl und geben Sie Ihre Telefonnummer ein.',
  sendCodeOnSms: 'Code per SMS senden',
  sendCodeOnWhatsApp: 'Code per WhatsApp senden',
  verifyNumberWhatsApp:
    'Wir werden Ihnen eine WhatsApp-Nachricht mit dem Verifizierungscode schicken:\n\n{{formattedMobileNumber}}',
  verifyNumberCall:
    'Sie erhalten einen Telefonanruf mit dem Verifizierungscode:\n\n{{formattedMobileNumber}}',
  defaultTimezoneForAlarm: 'Standardzeitzone für Alarme',
  changeDefaultTimezoneForAllExistingAlarms: {
    zero: 'Möchten Sie die Zeitzone für alle bestehenden Alarme zurücksetzen?',
    one: 'Möchten Sie die Zeitzone für alle bestehenden Alarme auf diese Zeitzone ändern? Die Alarme klingeln dann zur eingestellten Zeit in der neuen Zeitzone.'
  },
  changeDefaultRingerSettingsForAllExistingAlarms:
    'Möchten Sie die Einstellungen für Klänge und Vibrationen bei bestehenden Alarmen ändern?\n\nWenn Sie Ja wählen, klingeln die vorhandenen Alarme mit den neuen Einstellungen. Wenn Sie Nein wählen, klingeln die vorhandenen Alarme weiterhin mit den alten Einstellungen.',
  defaultTimezoneChangedForAllAlarms: 'Zeitzone für alle Alarme geändert.',
  ringerSettingsChangedForAllAlarms:
    'Die Einstellungen für Klang und Vibration wurden für bestehende Alarme geändert.',
  unlimitedAlarmsFeatureDescription:
    'Erstellen Sie mehr Alarme für Gruppen und Freunde.',
  instantAlarmsPremiumFeature: 'Notfallwarnungen senden',
  duplicateAlarmPremiumFeature: 'Duplizierter Alarm',
  duplicateAlarmFeatureDescription:
    'Erstellen Sie schnell Kopien eines Alarms mit denselben Einstellungen und nehmen Sie vor dem Speichern Änderungen vor.',
  showingAlarmsForDate: 'Anzeigen von Alarmen für {{date}}',
  shareAlarm: 'Alarm Link teilen',
  shareAlarmDescription:
    'Sie können diesen Alarm über einen Link mit jeder Person teilen, ohne sie als Kontakt hinzuzufügen. Wenn jemand auf den Link auf seinem Telefon tippt, wird eine Kopie des Alarms erstellt.',
  selectDefaultTimezoneForAlarmDefaultTooltipMessage:
    'Wählen Sie eine Standardzeitzone für Ihre Alarme. Sie können die Zeitzone für Alarme ändern, wenn Sie sie erstellen.',
  alarmLinkRelativeToTimezone: '{{timeString}} in ihrer Zeitzone.',
  alarmLinkNotRelativeToTimezone:
    'Der Alarm für alle klingelt um {{timeString}}',
  alarmShouldRingAt: 'Der Alarm wird bei allen klingeln:',
  showHourlyAlarms: 'Stündliche Alarme anzeigen',
  critical: 'Kritisch',
  alarmsWillBeAutomaticallyDeleted:
    'Alarme werden 30 Tage nach der Löschung endgültig entfernt.',
  unlimitedAlarmsPremiumFeature: 'Unbegrenzte Gruppen- und Freundesalarme',
  notAcknowledged: 'Nicht quittiert',
  closed: 'Geschlossen',
  showFullScreenIntents: 'Alarm im Vollbildmodus anzeigen',
  showFullScreenIntentsDescription:
    'Der Alarm wird auf dem gesamten Bildschirm angezeigt, wenn das Telefon gesperrt ist.',
  percentVolume: '{{volume}}% lautstärke',
  affiliates: 'Tochtergesellschaften',
  referralCount: 'Anzahl der Überweisungen',
  addAffiliate: 'Partner hinzufügen',
  creatingAffiliate: 'Partner erstellen',
  affiliateLink: 'Partner-Link',
  upgradeRequiredForWeb: 'Aktualisierung erforderlich',
  upgradeToPremiumForWeb:
    'Für diese Funktion ist ein Premium-Abonnement erforderlich. Bitte erwerben Sie ein Premium-Abonnement über die mobile App, um diese Funktion zu nutzen.',
  accountType: 'Konto-Typ',
  profileAndSettings: 'Profil und Einstellungen',
  confirmIncidents: 'Vorfälle bestätigen',
  removeIncidents: 'Mehrere Vorfälle entfernen',
  incidents: 'Vorfälle',
  closeSelectedIncidents: 'Ausgewählte Vorfälle schließen',
  viewIncidentNotes: 'Ansicht der Notizen zum Vorfall',
  incidentNotes: 'Notizen zum Vorfall',
  incidentSummary: 'Vorfallzusammenfassung',
  addNote: 'Notiz hinzufügen',
  noAdditionalNotesForIncident: 'Keine weiteren Notizen zu diesem Vorfall.',
  fromIncident: 'Vom Vorfall:',
  fromUsers: 'Von Benutzern:',
  database: 'Datenbank',
  chooseFirstDayOfWeek: 'Wählen Sie den ersten Tag der Woche',
  firstDayOfWeek: 'Erster Tag der Woche',
  changePlan: 'Plan ändern',
  currentPremiumSubscriptionStatus:
    'Sie haben derzeit den Plan {{planName}} abonniert.',
  currentProSubscriptionStatus:
    'Sie sind ein Mitglied der Organisation {{orgName}}.',
  currentStripePremiumSubscriptionStatus:
    'Sie sind derzeit beim {{planName}}-Plan angemeldet.',
  changeToAnnualPlan: 'Änderung des Jahresplans',
  confirmChangeToAnnualPlan: 'Möchten Sie zum Jahresplan wechseln?',
  changeToAnnualPlanDescription:
    'Die Kosten für das Jahresabonnement werden Ihnen unter {{price}} in Rechnung gestellt. Alle verbleibenden Tage in Ihrem aktuellen Plan werden an den Jahresplan angepasst.',
  alarmTimezoneChanged:
    'Einige Alarme wurden aktualisiert, um die Zeitzone des Geräts zu verwenden, da die für diese Alarme verwendete Zeitzone von diesem Gerät nicht unterstützt wird.',
  defaultTimezoneChanged:
    'Die Standardzeitzone für Alarme wurde auf die Zeitzone des Geräts geändert, da die Zeitzone „{{defaultTimezoneForAlarm}}“ von diesem Gerät nicht unterstützt wird. Bitte aktualisieren Sie gegebenenfalls alle vorhandenen Alarme, die diese Zeitzone verwenden.',
  invalidEmail: 'Ungültige E-Mail Adresse.',
  unableToValidateEmail: 'E-Mail kann nicht validiert werden. {{error}}',
  havingProblems: 'Haben Sie Probleme?',
  alertData: 'Alert-Daten',
  notificationActionBehavior: 'Benachrichtigung Aktion Verhalten',
  foreground: 'Vorderseite',
  background: 'Hintergrund',
  notificationActionBehaviorTooltipMessage:
    'Bei der Einstellung "Vordergrund" wird die App durch Tippen auf eine Benachrichtigung im Vordergrund geöffnet. Bei der Einstellung "Hintergrund" wird die App durch Tippen auf eine Benachrichtigung im Hintergrund gehalten.',
  getCodeOnWhatsApp: 'Code per WhatsApp erhalten',
  dontHaveWhatsApp: 'Sie haben kein WhatsApp?',
  unableToSendCodeViaWhatsAppTitle:
    'Code kann nicht über WhatsApp gesendet werden',
  unableToSendCodeViaWhatsAppMessage:
    '{{error}}\n\nBitte fordern Sie den Code auf einem anderen Kanal erneut an.',
  dataSecurity: 'Datensicherheit',
  filterByCalendar: 'Nach Kalendername filtern',
  adFreeExperiencePremiumFeature: 'Werbefreie Erfahrung',
  adFreeExperienceFeatureDescription:
    'Genießen Sie ein ungestörtes Erlebnis ohne Werbung.',
  accountLabel: 'Kontobezeichnung',
  editAccountLabel: 'Kontobezeichnung bearbeiten',
  enterAccountLabel: 'Geben Sie eine Bezeichnung für dieses Konto ein.',
  failedToUpdateLabel:
    'Das Aktualisieren der Kontobezeichnung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
  considerEvents: 'Alarm einstellen für',
  importAllDayEvents: 'Ganztägige Ereignisse importieren',
  considerEventsStartingWith: 'Stellen Sie Alarme für Ereignisse ein, die mit',
  eventsStartingWith: 'Veranstaltungen beginnend mit',
  allEvents: 'Alle Veranstaltungen',
  noEvents: 'Keine Veranstaltungen',
  ringAlarmsForCalendarEvents: 'Veranstaltungserinnerung',
  durationBefore: '{{duration}} vor',
  durationBeforeEventTime: '{{duration}} vor der Veranstaltungszeit',
  beforeEventTime: 'vor der Veranstaltungszeit',
  promptForUpdates: 'Aufforderung zur Installation von App-Updates',
  enableEnhancedNotifications: 'Aktivieren',
  calendarEventFeedbackHeader:
    'Sie senden einen Teil der Informationen zu diesem Kalenderereignis zu Debugging-Zwecken. Personenbezogene Daten wie Ereignisname, Beschreibung oder Teilnehmer werden nicht weitergegeben.',
  screenWillCloseAutomatically:
    'Dieser Bildschirm wird sich in {{seconds}} Sekunde(n) automatisch schließen.',
  viewingCalendarEvent: 'Ansicht des Kalenderereignisses für „{{title}}“',
  snoozingCalendarEvent: 'Kalenderereignis „{{title}}“ zum Schlummern bringen',
  linkedAccountsPremiumFeaturesDescription:
    'Sie können Ihre Google-Konten verknüpfen und Ereignisse aus Ihrem Hauptkalender in Galarm importieren.',
  instantAlarmPremiumFeaturesDescription:
    'Sie benötigen ein Premium-Abonnement, um mehr Sofortalarme zu erstellen.',
  linkedAccountsPremiumFeatureDescription:
    'Verknüpfen Sie Ihre Google-Konten, um Ereignisse aus Ihrem Hauptkalender in Galarm zu importieren.',
  linkedAccountsPremiumFeature: 'Google Kalender verknüpfen',
  calendarNotificationsTooltipMessage:
    'Benachrichtigungen für verknüpfte Kalenderereignisse.',
  hideRecentlyDeletedAlarms: 'Zuletzt gelöschte Alarme ausblenden',
  loadingCalendarEvent: 'Kalenderereignis wird geladen...',
  noOpenIncidents: 'Keine offenen Vorfälle',
  incidentsForMember: 'Vorfälle für „{{name}}“',
  noIncidentsForMember: 'Bisher keine Vorfälle für dieses Mitglied',
  noIncidents: 'Keine Zwischenfälle',
  labels: 'Etiketten',
  manageLabels: 'Labels verwalten',
  addLabel: 'Etikett hinzufügen',
  editLabel: 'Etikett bearbeiten',
  labelName: 'Label-Name',
  enterLabelName: 'Label-Namen eingeben',
  existingLabels: 'Vorhandene Etiketten',
  noLabelsYet: 'Es wurden noch keine Etiketten erstellt.',
  labelNameRequired: 'Der Name des Labels ist erforderlich.',
  labelAlreadyExists: 'Ein Label mit diesem Namen existiert bereits.',
  selectLabels: 'Etiketten auswählen',
  filterByMember: 'Nach Mitglied filtern',
  filterByTeam: 'Nach Team filtern',
  filterByLabel: 'Nach Etikett filtern',
  deletingLabel: 'Etikett löschen...',
  dutch: 'Niederländisch',
  turkish: 'Türkisch',
  ukrainian: 'Ukrainisch',
  appSupportedLanguages:
    'Galarm unterstützt derzeit Englisch, Russisch, Deutsch, Französisch, Spanisch, Italienisch, Portugiesisch, Japanisch, Koreanisch, Indonesisch, Niederländisch, Türkisch und Ukrainisch.',
  enhancedNotifications: 'Verbesserte Alarmübermittlung',
  enhancedNotificationsPremiumFeatureDescription:
    'Wenn diese Funktion aktiviert ist, können Sie zusätzliche Alarme erstellen, auch wenn das Betriebssystem Ihres Telefons keine weiteren Alarme zulässt. Galarm löst dies, indem es Alarme in der Cloud plant und Push-Benachrichtigungen an Ihr Telefon sendet, wenn die Alarme fällig sind.',
  enhancedNotificationsFeatureDescription:
    'Erstellen Sie Alarme, auch wenn das Betriebssystem Ihres Telefons keine weiteren Alarme zulässt.\n\nGalarm löst dieses Problem, indem es Alarme in der Cloud plant und Push-Benachrichtigungen an Ihr Telefon sendet, wenn die Alarme fällig sind.',
  appTerminatedNotification: 'Benachrichtigung über Beendigung der App',
  appTerminatedNotificationTooltipMessage:
    'Benachrichtigung, die angezeigt wird, wenn die App beendet wird. Es wird empfohlen, die App im Hintergrund laufen zu lassen, um sicherzustellen, dass Alarme zur richtigen Zeit klingeln.',
  cantChangeSetting: '{{settingName}} kann nicht geändert werden',
  fetchingAlarm: 'Alarm abrufen...',
  viewIncidentAlarms: 'Ansicht der Vorfälle',
  showingIncidents: {
    zero: 'Keine Zwischenfälle',
    one: 'Anzeige von {{startIndex}} – {{endIndex}} von {{count}} Vorfall',
    other: 'Anzeige von {{startIndex}} – {{endIndex}} von {{count}} Vorfällen'
  },
  noIncidentsFound: 'Keine Vorfälle gefunden',
  noIncidentsInSystem: 'Im System wurden noch keine Vorfälle gemeldet.',
  sendTestIncident: 'Testvorfall',
  sendTestIncidentConfirmMessage:
    'Dies wird einen Testvorfall für den Zuhörer "{{alertName}}" auslösen. Fortfahren?',
  noListenersToSendTestIncident:
    'Sie müssen einen Zuhörer konfigurieren, bevor Sie einen Testvorfall senden können. Gehen Sie zum Abschnitt Zuhörer, um einen zu erstellen.',
  pageSize: 'Seitengröße',
  incidentsPerPage: 'Vorfälle pro Seite',
  identifier: 'Kennung',
  reportedAt: 'Gemeldet bei',
  closedAtLabel: 'Geschlossen am',
  priority: 'Priorität',
  allListeners: 'Alle Zuhörer',
  allDates: 'Alle Daten',
  allPriorities: 'Alle Prioritäten',
  allStatuses: 'Alle Status',
  connectedAccountsDescription:
    'Sie können Ihr Google-Konto mit Galarm verbinden, um Benachrichtigungen für Kalenderereignisse in Galarm zu erhalten. Weitere Informationen finden Sie unter https://features.galarmapp.com/calendar-integration.',
  removeGoogleAccount: 'Google-Konto entfernen',
  removeGoogleAccountDescription:
    'Möchten Sie dieses Google-Konto wirklich löschen?',
  unableToRemoveGoogleAccount: 'Google-Konto kann nicht entfernt werden',
  googleAccountRemoved: 'Konto Entfernt',
  googleAccountRemovedDescription: 'Dieses Google-Konto wurde entfernt.',
  calendarEvent: 'Kalenderereignis',
  connectedAccount: 'Verknüpftes Konto',
  linkedCalendars: 'Verknüpfte Kalender',
  syncedCalendars: 'Synchronisierte Kalender',
  availableCalendars: 'Verfügbare Kalender',
  noSyncedCalendars:
    'Keine synchronisierten Kalender gefunden. Fügen Sie Kalender aus dem Abschnitt "Verfügbare Kalender" unten hinzu.',
  noAvailableCalendars: 'Keine Kalender verfügbar zum Synchronisieren.',
  removeCalendar: 'Kalender Entfernen',
  calendarDetails: 'Kalenderdetails',
  addingCalendar: 'Kalender wird hinzugefügt...',
  calendarAdded: 'Kalender erfolgreich hinzugefügt',
  errorAddingCalendar: 'Fehler beim Hinzufügen des Kalenders: {{error}}',
  duplicateCalendarDetectedTitle: 'Doppelter Kalender Erkannt',
  removingCalendar: 'Kalender wird entfernt...',
  calendarRemoved:
    'Wir haben eine Aufgabe hinzugefügt, um den Kalender zu entfernen. Sie können diesen Dialog schließen und die App weiter verwenden. Bitte kontaktieren Sie den Support, wenn der Kalender nach ein paar Minuten nicht entfernt wird.',
  errorRemovingCalendar: 'Fehler beim Entfernen des Kalenders: {{error}}',
  removeCalendarDescription:
    'Sind Sie sicher, dass Sie den Kalender "{{calendarName}}" entfernen möchten?',
  default: 'Standard',
  join_meeting_action: 'An Meeting teilnehmen',
  view_calendar_event: 'Ansicht',
  snooze_calendar_event: 'Schlummern',
  dismiss_calendar_event: 'Ignorieren',
  numEvents: {
    one: '1 Veranstaltung',
    other: '{{count}} Veranstaltungen'
  },
  calendarEvents: 'Kalenderereignisse',
  viewingCalendarEvents: 'Ansicht der Kalenderereignisse',
  calendarEventAlarmName: 'Kalenderereignis',
  calendarName: 'Kalendername',
  meetingLink: 'Link zum Meeting',
  attendees: 'Teilnehmer',
  organizer: 'Veranstalter',
  addAccount: 'Konto hinzufügen',
  accountAlreadyConnected: 'Konto bereits verbunden',
  unableToSignInWithGoogle: 'Anmeldung mit Google nicht möglich',
  unableToSignInWithGoogleDescription:
    'Es gab ein Problem bei der Anmeldung mit Google. Bitte kontaktieren Sie den technischen Support über „Einstellungen > Rückmeldung“.',
  requiredScopesNotGranted:
    'Galarm hat keinen Zugriff auf Ihre Kalender, weshalb wir keine Ereignisse aus Ihrem Kalender importieren können. Bitte entfernen Sie das Konto und fügen Sie es erneut hinzu, wobei Sie sicherstellen müssen, dass Galarm Zugriff auf Ihre Kalender erhält. Wenn das Problem weiterhin besteht, kontaktieren Sie bitte den technischen Support über „Einstellungen > Rückmeldung”.',
  refreshTokenNotFound:
    'Sie können nicht auf Ihr Konto zugreifen. Bitte entfernen Sie das Konto und fügen Sie es erneut hinzu. Sollte das Problem weiterhin bestehen, entfernen Sie das Konto bitte ein weiteres Mal. Gehen Sie zu myaccount.google.com, tippen Sie links auf „Daten & Datenschutz“, scrollen Sie nach unten zu „Apps & Dienste von Drittanbietern“, wählen Sie Galarm aus und tippen Sie auf „Alle Verbindungen zu Galarm löschen“. Fügen Sie das Konto anschließend erneut hinzu. Sollten Sie diese Meldung nach diesen Schritten weiterhin sehen, wenden Sie sich bitte an den technischen Support.',
  noCalendarsSyncedForConnectedAccount: 'Keine Kalender sind synchronisiert.',
  calendarsNotSynced:
    'Primärer Kalender nicht synchronisiert. Bitte tippen Sie auf die Schaltfläche „Aktualisieren“, um Ihren Kalender zu synchronisieren.',
  calendarsSynced: 'Kalender erfolgreich synchronisiert.',
  refreshGoogleAccount: 'Google-Konto aktualisieren',
  refreshingGoogleAccount: 'Google-Konto wird aktualisiert...',
  googleAccountRefreshed: 'Google-Konto erfolgreich aktualisiert',
  errorRefreshingGoogleAccount:
    'Fehler beim Aktualisieren des Google-Kontos: {{error}}',
  refreshGoogleAccountDescription:
    'Importieren Sie Ereignisse aus Ihrem Google-Kalender erneut und richten Sie automatische Updates ein.',
  ignoreEvents: 'Ereignisse ignorieren',
  ignoreEvent: 'Ereignis ignorieren',
  unignoreEvent: 'Veranstaltung planen',
  yourIgnoredEvents: 'Ihre ignorierten Ereignisse',
  ignoredCalendarEvents: 'Ignorierte Kalenderereignisse',
  noEventsSelected: 'Keine Veranstaltungen ausgewählt',
  selectEventsToIgnore: 'Zu ignorierende Ereignisse auswählen',
  showInCalendar: 'Im Kalender anzeigen',
  viewingIgnoredCalendarEvents:
    'Ignorierte Kalenderereignisse in der Ansicht anzeigen',
  viewIgnoredEvents: 'Ansicht ignorierter Ereignisse',
  general: 'Allgemein',
  addMembersAsContacts: 'Mitglieder als Galarm-Kontakte hinzufügen',
  addMembersAsContactsDescription:
    'Synchronisierte Mitglieder können in der Galarm-App zu Alarmen und Gruppen hinzugefügt werden. Verwenden Sie das Aktualisierungssymbol, um nach einer Änderung dieser Einstellung eine erneute Synchronisierung durchzuführen.',
  resyncMembersPrompt:
    'Möchten Sie die Mitglieder mit der neuen Einstellung neu synchronisieren?',
  toAdmins: 'An die Administratoren',
  toEveryone: 'An alle',
  accountManagers: 'Kundenbetreuer',
  accountManager: 'Kundenbetreuer',
  viewAccountManagers: 'Ansicht der Kundenbetreuer',
  addAccountManager: 'Kundenbetreuer hinzufügen',
  userAlreadyManager: 'Der Benutzer ist bereits ein Account Manager.',
  noAccountManagersConfigured: 'Es sind keine Kundenbetreuer konfiguriert.',
  addingAccountManager: 'Kundenbetreuer hinzufügen...',
  proMemberContact: 'Mitglied der Organisation in Galarm Pro',
  viewCalendarEvents: 'Ansicht der Kalenderereignisse',
  noScheduledCalendarEvents: 'Keine geplanten Kalenderereignisse',
  notSpecified: 'Nicht angegeben',
  addedTaskToRemoveGoogleAccount:
    'Eine Aufgabe zum Entfernen des Google-Kontos wurde hinzugefügt. Sie können diesen Dialog schließen und die App weiter verwenden. Bitte kontaktieren Sie den Support, wenn das Konto nach einigen Minuten nicht entfernt wurde.',
  success: 'Erfolg',
  addingTaskToRemoveGoogleAccount:
    'Hinzufügen einer Aufgabe zum Entfernen eines Google-Kontos...',
  addingGoogleCalendar:
    'Hinzufügen einer Aufgabe zur Synchronisierung mit Google Kalender...',
  googleCalendarAdded:
    'Wir haben Ihr Google-Konto verknüpft und importieren Ereignisse aus dem primären Kalender. Tippen Sie auf das verknüpfte Konto, um dessen Klang- und Vibrationseinstellungen zu konfigurieren.\n\nBitte kontaktieren Sie den Support, wenn die Ereignisse nach einigen Minuten nicht importiert wurden.',
  googleAccountLinkedSelectCalendars:
    'Wir haben Ihr Google-Konto verknüpft und importieren Ereignisse aus den ausgewählten Kalendern.',
  multipleCalendarsUpgradeMessage:
    'Wir haben die Unterstützung zum Importieren mehrerer Kalender von einem Konto hinzugefügt. Wenn Sie mehrere Kalender von diesem Konto importieren möchten, entfernen Sie das Konto und fügen Sie es erneut hinzu.',
  errorAddingGoogleCalendar:
    'Fehler beim Hinzufügen von Google Kalender: {{error}}',
  acceptedEvents: 'Von Ihnen akzeptierte Veranstaltungen',
  declinedEvents: 'Von Ihnen abgelehnte Veranstaltungen',
  tentativeEvents: 'Veranstaltungen, die Sie als „Vielleicht“ markiert haben',
  needsActionEvents: 'Ereignisse, die auf Ihre Antwort warten',
  show: 'Anzeigen',
  hide: 'Ausblenden',
  showAndRing: 'Show und Ring',
  chooseBehavior: 'Verhalten auswählen',
  calendarEventBehavior:
    'Umgang mit Veranstaltungen, zu denen Sie eingeladen sind',
  lastSyncedAt: 'Zuletzt synchronisiert unter {{dateTimeString}}',
  apiConfiguration: 'API-Konfiguration',
  apiVersion: 'API-Version',
  apiVersionDescription:
    'Die API-Version wird verwendet, um die Kompatibilität zwischen der App und dem Server sicherzustellen. Wenn Sie V2 verwenden, muss die mobile App mindestens die Version 9.9.0 haben. Wenn Sie Probleme mit der API haben, kontaktieren Sie bitte den technischen Support.',
  reschedulingEventsAsNeeded: 'Veranstaltungen nach Bedarf verschieben...',
  failedToUpdateSetting:
    'Einstellung konnte nicht aktualisiert werden: {{error}}',
  selectEventsToSchedule:
    'Wählen Sie Ereignisse aus, für die Sie Alarme planen möchten.',
  scheduleEvents: 'Veranstaltungen planen',
  unableToRefreshGoogleAccount:
    'Ereignisse aus Google Kalender können nicht erneut importiert werden',
  calendarEventBehaviorDescription:
    'Wählen Sie aus, wie Galarm mit Veranstaltungen umgehen soll, zu denen Sie eingeladen sind.',
  ringAlarmsForCalendarEventsTooltip:
    'Geben Sie an, wann Sie an ein Ereignis erinnert werden möchten.\n\n  Um zusätzliche Erinnerungen zu erhalten, können Sie in den Einstellungen unter „Ton und Vibration” die automatische Funktion zum Schlummern aktivieren.',
  sortAlarmCategories: 'Alarmkategorien sortieren nach',
  byNumAlarms: 'Alarmzahl',
  byName: 'Name',
  preReminderRingtone: 'Vorab-Erinnerungs-Klingelton',
  timerRingtone: 'Timer-Klingelton',
  sortAlarmCategoriesTooltipMessage:
    'Wählen Sie aus, wie Sie Ihre Alarmkategorien sortieren möchten. Sie können sie nach der Anzahl der Alarme in jeder Kategorie oder alphabetisch nach Namen sortieren.',
  resetFilters: 'Filter zurücksetzen',
  alarm: 'Persönlicher Alarm',
  alarmWithContacts: 'Alarm mit Kontakten',
  instantAlarm: 'Sofortige Warnung',
  buddyAlarm: 'Freundalarm',
  proMembersSyncCompleted: 'Synchronisierung der Pro-Mitglieder abgeschlossen.',
  errorSyncingProMembers:
    'Fehler bei der Synchronisierung von Pro-Mitgliedern: {{error}}',
  label: 'Etikett',
  iosNotificationsLimitReached:
    'Sie erreichen die Benachrichtigungsgrenze von iOS für eine App.\n\nAktivieren Sie „Erweiterte Alarmzustellung“, um sicherzustellen, dass alle Alarme klingeln. Wenn diese Funktion aktiviert ist, plant Galarm die Alarme, die über die zulässige Grenze hinausgehen, in der Cloud und sendet Push-Benachrichtigungen an Ihr Telefon, wenn diese Alarme fällig sind.',
  notificationLimitReached:
    'Warnung bei Erreichen des Limits für Benachrichtigungen',
  remoteAlarmCloudMessage:
    'Dieser Alarm wird aus der Ferne über die Cloud programmiert und erfordert zum Zeitpunkt des Alarms eine aktive Internetverbindung.',
  signUpForMailingList: 'Für wichtige Ankündigungen anmelden',
  signedUpForMailingList: 'Für wichtige Ankündigungen angemeldet',
  unsubscribe: 'Abmelden',
  confirmUnsubscribeFromMailingList:
    'Möchten Sie sich wirklich von wichtigen Ankündigungen abmelden?',
  unsubscribingFromMailingList: 'Abmeldung von wichtigen Ankündigungen...',
  successfullyUnsubscribedFromMailingList:
    'Erfolgreich von wichtigen Ankündigungen abgemeldet.',
  errorUnsubscribingFromMailingList:
    'Beim Abmelden von wichtigen Ankündigungen ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
  signingUpForMailingList:
    'Anmeldung, um wichtige Ankündigungen zu erhalten...',
  successfullySignedUpForMailingList:
    'Sie haben sich erfolgreich angemeldet, um wichtige Updates zu erhalten.',
  errorSigningUpForMailingList:
    'Bei der Anmeldung für wichtige Updates ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
  recentlyUsed: 'Zuletzt verwendet',
  startStopWatch: 'Stoppuhr starten',
  stopWatch: 'Stoppuhr',
  stopWatches: 'Stoppuhren',
  utilities: 'Werkzeuge',
  addAlarmForTask: 'Alarm für Aufgabe hinzufügen',
  noExpiredAlarmsToDelete: 'Keine verpassten Alarme zum Löschen',
  noAlarmsToDelete: 'Keine Alarme zum Löschen',
  noAlarmsToEnable: 'Keine Alarme zum Aktivieren',
  noAlarmsToDisable: 'Keine Alarme zum Deaktivieren',
  noAlarmsToMarkAsComplete: 'Keine Alarme zum Abschließen markieren',
  noIncidentsToConfirm: 'Keine Vorfälle zu bestätigen',
  noIncidentsToClose: 'Keine Vorfälle zu schließen',
  noEventsToIgnore: 'Keine Ereignisse zu ignorieren',
  noEventsToSchedule: 'Keine Ereignisse zu planen',
  addAlarmForChecklist: 'Alarm für Aufgabenliste hinzufügen',
  openTaskList: 'Aufgabenliste öffnen',
  alarmForTask: 'Aufgabe',
  alarmForTaskList: 'Aufgabenliste',
  EnterpriseAlertIncidentTriggered:
    'Ein Vorfall für die Alarm{{alertName}} wurde ausgelöst.',
  docChatbotWelcome:
    'Hallo! Ich bin hier, um Ihnen bei der Nutzung von Galarm Enterprise zu helfen. Stellen Sie mir gerne Fragen zu Funktionen, zur Einrichtung oder zur Durchführung bestimmter Aufgaben.',
  docChatbotError:
    'Es tut mir leid, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.',
  docChatbotTitle: 'Allie',
  docChatbotPlaceholder: 'Eine Frage stellen...',
  helpAssistant: 'Hilfe',
  needHelp: 'Benötigen Sie Hilfe?',
  helpPopupMessage:
    '"Allie", unser Chat-Assistent, ist hier, um Ihnen zu helfen! Sie können ihn jederzeit über das "Hilfe"-Menü in der oberen Leiste starten.',
  askTheHelpAssistant: 'Fragen Sie "Allie"',
  newConversation: 'Neue Unterhaltung',
  setupStep: 'Schritt {{current}} von {{total}}',
  escalationPolicyTooltip:
    'Eine Eskalationsrichtlinie legt fest, wer benachrichtigt wird, wenn ein Vorfall auftritt und in welcher Reihenfolge. Sie können mehrere Auslöser hinzufügen, um verschiedene Personen zu unterschiedlichen Zeiten zu alarmieren, wenn der Vorfall nicht bestätigt wird.',
  stopwatchTotal: 'Gesamt',
  stopwatchCurrent: 'Aktuell',
  stopwatchStart: 'Start',
  stopwatchStop: 'Stopp',
  stopwatchFinish: 'Beenden',
  stopwatchStartNextLap: 'Nächste Runde starten',
  startTimer: 'Starten',
  stopwatchLapAndContinue: 'Runde und weiter',
  stopwatchLapAndPause: 'Runde und pausieren',
  stopwatchLapAndStop: 'Runde und beenden',
  savingStopwatch: 'Stoppuhr wird gespeichert...',
  errorSavingStopwatch: 'Fehler beim Speichern der Stoppuhr.',
  timerRequiresValidDuration: 'Stellen Sie zuerst eine Timer-Dauer ein.',
  stopwatchLapAndContinueHelp:
    'Zeichnet die aktuelle Runde auf und startet sofort eine neue.',
  stopwatchLapAndPauseHelp:
    'Zeichnet die aktuelle Runde auf und pausiert. Sie können Rundennotizen hinzufügen und fortfahren, wenn Sie bereit sind, die nächste Runde zu starten.',
  stopwatchLapAndStopHelp:
    'Zeichnet die letzte Runde auf und beendet die Stoppuhr. Sie können ein Label und Notizen für jede Runde hinzufügen, bevor Sie speichern.',
  stopwatchDiscardConfirmMessage:
    'Sie haben eine aktive Stoppuhr. Wenn Sie zurückgehen, wird sie verworfen. Fortfahren?',
  stopwatchLapLabel: 'Runde {{index}}',
  stopwatchAddNote: 'Notiz hinzufügen',
  stopwatchLabelPlaceholder: 'Eine Bezeichnung hinzufügen',
  stopwatchStoppedAt: 'Gestoppt bei',
  stopwatchDetails: 'Stoppuhrdetails',
  deleteStopwatches: 'Stoppuhren löschen',
  deleteStopwatch: 'Stoppuhr löschen',
  deleteStopwatchConfirmMessage:
    'Sind Sie sicher, dass Sie diese Stoppuhr löschen möchten?',
  noStopwatchesToDelete: 'Keine Stoppuhren zum Löschen',
  noStopwatchesYet:
    'Tippen Sie auf +, um eine Stoppuhr zu starten. Ihre abgeschlossenen Stoppuhren mit Rundenzeiten werden hier aufgelistet.',
  stopwatchInProgress: 'Stoppuhr läuft — tippen zum Öffnen',
  stopwatchLaps: {
    one: '1 Runde',
    other: '{{count}} Runden'
  },
  newAlarmButtonBehavior: 'Verhalten der neuen Alarmtaste',
  newAlarmButtonBehaviorTooltipMessage:
    'Ändern Sie die Optionen, die in der neuen Alarmtaste angezeigt werden',
  classic: 'Standard',
  mode: 'Modus',
  classicFabDescription: 'Optionen für Schnellerinnerung und Alarm anzeigen',
  classicAlarmDescription: 'Zeigt Optionen zur Auswahl eines Alarmtyps',
  custom: 'Benutzerdefiniert',
  customFabDescription: 'Wählen Sie, welche Optionen angezeigt werden sollen',
  chooseNewAlarmButtonOptions: 'Optionen für neue Alarmtaste',
  fabOptionsMustHaveAtLeastOne: 'Mindestens eine Option muss ausgewählt werden',
  actUtilities: 'Handeln',
  connectUtilities: 'Verbinden',
  timer: 'Timer',
  setTimer: 'Timer einstellen',
  timerFinished: 'Zeit abgelaufen!',
  hoursShort: 'Stunden',
  minutesShort: 'Minuten',
  secondsShort: 'Sekunden',
  adBelow: 'Anzeige unten',
  buyGalarmPremium: 'Galarm Premium kaufen',
  phoneNumberForPremiumDescription: `Geben Sie die bei Galarm registrierte Telefonnummer ein. Wir senden einen Verifizierungscode an Ihre Galarm-App.

Um zu prufen, ob Ihre Telefonnummer registriert ist, offnen Sie in Galarm die Registerkarte Einstellungen. Ihre registrierte Telefonnummer wird unter Ihrem Profilnamen angezeigt.

Wenn Sie noch keine Telefonnummer registriert haben, konnen Sie dies uber die Registerkarte Kontakte in der Galarm-App tun. Sobald sie registriert ist, geben Sie hier dieselbe Telefonnummer ein, um ein Premium-Abonnement zu kaufen.`,
  enterPhoneNumberForPremiumValidation:
    'Bitte geben Sie Ihre Landesvorwahl und Telefonnummer ein.',
  pleaseCompleteCaptcha:
    'Bitte vervollständigen Sie die CAPTCHA-Verifizierung.',
  requestVerificationCode: 'Code anfordern',
  unableToSendAppVerificationCode:
    'Verifizierungscode konnte nicht gesendet werden. Bitte versuchen Sie es erneut. {{error}}',
  enterVerificationCodeForPremium: 'Verifizierungscode eingeben',
  verificationCodeForPremiumDescription: `Geben Sie den Verifizierungscode ein, der an Ihre Galarm-App gesendet wurde.

Um den Code zu finden, offnen Sie die Registerkarte Benachrichtigungen und tippen Sie auf Systemnachrichten.

Wenn Sie den Code nicht sehen:
  - Stellen Sie sicher, dass Sie die neueste Version der Galarm-App verwenden.
  - Prufen Sie, ob Ihr Gerat uber eine aktive Internetverbindung verfugt.
  - Wenn Sie die App gerade aktualisiert haben, gehen Sie zuruck und fordern Sie den Code erneut an.

Wenn der Code weiterhin nicht angezeigt wird, kontaktieren Sie bitte den Support aus der App uber Registerkarte Einstellungen > Feedback.`,
  enterVerificationCodeForPremiumValidation:
    'Bitte geben Sie den Verifizierungscode ein.',
  verifyCode: 'Verifizieren',
  unableToVerifyAppCode:
    'Code konnte nicht verifiziert werden. Bitte überprüfen und erneut versuchen. {{error}}',
  buyPremiumMonthly: 'Monatlich',
  buyPremiumYearly: 'Jährlich (Bester Wert)',
  monthlyPrice: '{{price}}/Monat',
  yearlyPrice: '{{price}}/Jahr',
  buyPremiumLifetime: 'Lebenslang',
  lifetimePrice: '{{price}} einmalig',
  creatingStripeCustomer: 'Ihr Konto wird vorbereitet...',
  problemCreatingStripeCustomer:
    'Es gab ein Problem bei der Einrichtung Ihres Kontos. Bitte versuchen Sie es erneut. {{error}}',
  premiumPurchaseSuccessTitle: 'Willkommen bei Galarm Premium!',
  premiumPurchaseSuccess:
    'Ihr Kauf war erfolgreich. Vielen Dank für Ihr Abonnement bei Galarm Premium. Öffnen Sie die Galarm-App auf Ihrem Telefon, um Ihre neuen Funktionen zu genießen.',
  goToGalarmWeb: 'Gehe zu Galarm Web',
  premiumPurchaseCancelledTitle: 'Kauf abgebrochen',
  premiumPurchaseCancelled:
    'Ihr Kauf wurde nicht abgeschlossen. Sie können es jederzeit erneut versuchen.',
  countryCode: 'Ländervorwahl',
  appVerificationCodeToBuyPremiumSubscription:
    'Verifizierungscode zum Kauf eines Premium-Abonnements: {{verificationCode}}',
  loadingProducts: 'Produkte werden geladen...',
  invoicesSentToThisEmail:
    'Rechnungen werden an diese E-Mail-Adresse gesendet.',
  tryPremiumFreeCancelAnytime:
    '🎉 14-tägige kostenlose Testversion — Testen Sie Premium kostenlos, jederzeit kündbar. Ein Test pro Konto.',
  galarmWebPremium: 'Galarm Web ist eine Premium-Funktion',
  subscribeToGetAccess:
    'Abonnieren Sie, um Zugriff zu erhalten. Beinhaltet eine 14-tägige kostenlose Testversion.',
  subscribeToPremium: 'Abonnieren Sie Galarm Premium',
  havingTroubleWithPremium: 'Probleme beim Kauf von Premium?',
  purchaseOnWebsite: 'Auf der Website kaufen',
  purchaseOnWebsiteDescription:
    'Wenn Sie Probleme beim Kauf von Premium in der App haben, können Sie es auf unserer Website kaufen.',
  manageSubscriptionFromBillingPortal:
    'Sie können Änderungen an Ihrem Abonnement über das Abrechnungsportal vornehmen.',
  docChatbotDefaultResponse:
    'Es tut mir leid, ich habe die von Ihnen gesuchten Informationen nicht. Bitte lesen Sie unsere Dokumentation unter https://docs.galarmapp.com oder kontaktieren Sie den Support, um weitere Unterstützung zu erhalten.'
}
